// src/locales/en/common.json
var common_default = {
  theme: {
    switchToLight: "Switch to light mode",
    switchToDark: "Switch to dark mode"
  },
  live: {
    opportunitiesChanged: "Opportunities changed. Review your selections and odds before saving.",
    reconnecting: "Live updates are temporarily unavailable. Data refreshes automatically while we reconnect."
  },
  app: {
    name: "Pick Pro"
  },
  nav: {
    matches: "Matches",
    language: "Language",
    mainLabel: "Main",
    myLabel: "Saved",
    primaryAction: "Start free",
    settings: "Settings",
    signIn: "Sign in",
    signOut: "Sign out",
    signUp: "Create account",
    pricing: "Pricing",
    account: "Account",
    admin: "Admin",
    sports: "Sports",
    openNavigation: "Open navigation",
    closeNavigation: "Close navigation",
    sport: "Sport",
    overview: "Today",
    search: "Search",
    competitions: "Competitions",
    teams: "Teams",
    players: "Players",
    radar: "Radar",
    "ticket-generator": "Pick Pro",
    bets: "Bets"
  },
  common: {
    loading: "Loading",
    retry: "Retry",
    empty: "Nothing to show yet",
    error: "The page failed to load.",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    loadMore: "Load more",
    close: "Close",
    required: "Required"
  },
  errors: {
    internal: "Unexpected error",
    notFound: "Not found",
    notFoundDescription: "The address does not match any page.",
    validation: "Some fields are invalid",
    unauthorized: "Sign in to continue",
    forbidden: "You do not have access to this",
    rateLimited: "Too many requests, try again shortly",
    network: "Could not reach the server"
  },
  auth: {
    invalidCredentials: "Email or password is incorrect",
    emailNotVerified: "Confirm your email before signing in",
    invalidToken: "This link is invalid or has expired",
    sportLocked: "This sport is not enabled for your account yet",
    fields: {
      email: "Email",
      password: "Password",
      newPassword: "New password",
      currentPassword: "Current password",
      confirmPassword: "Confirm password",
      passwordHint: "At least 10 characters",
      firstName: "First name",
      lastName: "Last name"
    },
    validation: {
      email: "Enter a valid email",
      passwordLength: "Use at least 10 characters",
      passwordTooLong: "Use a shorter password",
      passwordMatch: "Passwords do not match",
      required: "Required",
      nameLength: "Enter 1 to 100 characters"
    },
    signUp: {
      title: "Create your account",
      description: "Research starts with an account. Your first {{freeScans}} scans are free, then each sport opens with its plan.",
      submit: "Create account",
      haveAccount: "Already have an account?",
      sentTitle: "Check your email",
      sentDescription: "We sent a confirmation link to {{email}}. Open it to activate your account.",
      resend: "Send the link again",
      resent: "A new link is on its way."
    },
    verify: {
      title: "Confirming your email",
      success: "Your email is confirmed. You can sign in now.",
      missing: "This page needs the link from your confirmation email.",
      resendPrompt: "Enter your email to receive a new link."
    },
    signIn: {
      title: "Sign in",
      description: "Welcome back.",
      submit: "Sign in",
      forgot: "Forgot your password?",
      noAccount: "New here?",
      unverifiedHelp: "Need a new confirmation link?"
    },
    forgot: {
      title: "Reset your password",
      description: "Enter your email and we will send you a link to choose a new password.",
      submit: "Send reset link",
      sent: "If an account exists for {{email}}, a reset link is on its way.",
      back: "Back to sign in"
    },
    reset: {
      title: "Choose a new password",
      submit: "Save new password",
      success: "Your password is updated. Sign in with the new one.",
      missing: "This page needs the link from your reset email."
    }
  },
  access: {
    title: "Your account is ready",
    description: "Each sport on your account is enabled by its plan. You will be able to research as soon as a sport is enabled.",
    sportsTitle: "Sports on your account",
    granted: "Enabled",
    pending: "Pending",
    pricingLink: "See the plans",
    contact: "Questions? Write to {{email}}.",
    inactive: "Your account is inactive. Contact support to restore access."
  },
  sports: {
    football: "Soccer",
    nba: "NBA",
    nfl: "NFL",
    mlb: "MLB"
  },
  overview: {
    firstMatchOn: "First match on {{date}}",
    lastMatchOn: "Last match on {{date}}"
  },
  today: {
    title: "Today",
    datePattern: "dddd, D MMMM",
    summary: "{{date}}, {{live}} and {{upcoming}}",
    summaryQuiet: "{{date}}, no matches",
    liveCount_zero: "{{count}} live",
    liveCount_one: "{{count}} live",
    liveCount_other: "{{count}} live",
    upcomingCount_zero: "{{count}} to come",
    upcomingCount_one: "{{count}} to come",
    upcomingCount_other: "{{count}} to come",
    openRadar: "Open Radar",
    openPickPro: "Pick Pro",
    liveMatches: "Live matches",
    nextKickoff: "Next kickoff",
    kickingOff: "Kicking off",
    countdownHours: "{{hours}}h {{minutes}}m",
    countdownMinutes: "{{minutes}} min",
    nextMatchday: "Next matchday",
    nextMatchdayCount_zero: "{{count}} matches on {{date}}",
    nextMatchdayCount_one: "{{count}} match on {{date}}",
    nextMatchdayCount_other: "{{count}} matches on {{date}}",
    nextUp: "Next up",
    allOnMatches: "All {{count}} on Matches",
    favouriteCompetition: "Favourite competition",
    phase: {
      off_season: "The season is over. Radar keeps working on the last rounds.",
      pre_season: "The season starts soon.",
      in_season: "No matches scheduled."
    },
    loadError: "Could not load today's matches.",
    strip: {
      title: "This month",
      profit: "Profit",
      roi: "ROI",
      open: "Open",
      openDetail_zero: "{{count}} bets, {{amount}} at risk",
      openDetail_one: "{{count}} bet, {{amount}} at risk",
      openDetail_other: "{{count}} bets, {{amount}} at risk",
      bankroll: "Bankroll",
      noBankroll: "No bankroll",
      noSettled: "No settled bets this month yet.",
      loadError: "Could not load this month's results.",
      bankrollError: "Could not load your bankrolls."
    },
    plan: {
      title: "Your plan",
      status: "Status",
      active: "Active plan",
      inactive: "Plan inactive",
      sports: "Sports",
      manage: "Manage on Access"
    }
  },
  competitions: {
    search: "Search competitions",
    results: "{{visible}} of {{total}} competitions",
    noResults: "No competitions found",
    noResultsDescription: "Try a different competition name or clear your search.",
    clearSearch: "Clear search",
    title: "Competitions",
    seasons: "Seasons",
    standings: "Standings",
    season: "Season",
    noStandings: "No standings for this season yet.",
    columns: {
      rank: "Rank",
      team: "Team",
      played: "Played",
      won: "Won",
      drawn: "Drawn",
      lost: "Lost",
      scored: "Scored",
      conceded: "Conceded",
      goalDifference: "GD",
      points: "Points",
      record: "W-L",
      pct: "PCT"
    }
  },
  search: {
    title: "Search",
    resultsFor: 'Results for "{{query}}"',
    noResults: "No results for this search.",
    seeAll: "See all",
    competitions: "Competitions",
    teams: "Teams",
    players: "Players"
  },
  metrics: {
    points: "Points",
    runs: "Runs",
    hits: "Hits",
    errors: "Errors",
    goals: "Goals",
    corners: "Corners",
    cards: "Cards",
    shots: "Shots",
    shots_on_target: "Shots on target",
    shots_off_target: "Shots off target",
    shots_inside_box: "Shots inside the box",
    shots_outside_box: "Shots outside the box",
    shots_blocked: "Blocked shots",
    attacks: "Attacks",
    dangerous_attacks: "Dangerous attacks",
    passes: "Passes",
    accurate_passes: "Accurate passes",
    tackles: "Tackles",
    interceptions: "Interceptions",
    crosses: "Crosses",
    accurate_crosses: "Accurate crosses",
    big_chances_created: "Big chances created",
    key_passes: "Key passes",
    dribbles: "Dribbles",
    duels_won: "Duels won",
    clearances: "Clearances",
    touches: "Touches",
    rating: "Rating",
    minutes: "Minutes",
    fouls: "Fouls",
    yellow_cards: "Yellow cards",
    red_cards: "Red cards",
    offsides: "Offsides",
    saves: "Saves",
    possession: "Possession",
    rebounds: "Rebounds",
    offensive_rebounds: "Offensive rebounds",
    defensive_rebounds: "Defensive rebounds",
    assists: "Assists",
    steals: "Steals",
    blocks: "Blocks",
    turnovers: "Turnovers",
    field_goals_made: "Field goals made",
    field_goals_attempted: "Field goals attempted",
    three_pointers_made: "Three pointers made",
    three_pointers_attempted: "Three pointers attempted",
    free_throws_made: "Free throws made",
    free_throws_attempted: "Free throws attempted",
    plus_minus: "Plus/minus",
    total_yards: "Total yards",
    passing_yards: "Passing yards",
    rushing_yards: "Rushing yards",
    passing_attempts: "Pass attempts",
    passing_completions: "Completions",
    rushing_attempts: "Rush attempts",
    first_downs: "First downs",
    first_downs_passing: "Passing first downs",
    first_downs_rushing: "Rushing first downs",
    first_downs_penalty: "First downs by penalty",
    third_down_conversions: "Third down conversions",
    third_down_attempts: "Third down attempts",
    fourth_down_conversions: "Fourth down conversions",
    fourth_down_attempts: "Fourth down attempts",
    red_zone_scores: "Red zone scores",
    red_zone_attempts: "Red zone trips",
    interceptions_thrown: "Interceptions thrown",
    fumbles_lost: "Fumbles lost",
    penalties: "Penalties",
    penalty_yards: "Penalty yards",
    sacks: "Sacks",
    sack_yards_lost: "Yards lost to sacks",
    total_offensive_plays: "Offensive plays",
    total_drives: "Drives",
    possession_time_seconds: "Time of possession",
    defensive_touchdowns: "Defensive touchdowns",
    yards_per_play: "Yards per play",
    yards_per_pass: "Yards per pass",
    yards_per_rush_attempt: "Yards per rush",
    passing_touchdowns: "Passing touchdowns",
    passing_interceptions: "Interceptions thrown",
    rushing_touchdowns: "Rushing touchdowns",
    receiving_yards: "Receiving yards",
    receiving_touchdowns: "Receiving touchdowns",
    receptions: "Receptions",
    receiving_targets: "Targets",
    total_tackles: "Total tackles",
    solo_tackles: "Solo tackles",
    defensive_sacks: "Sacks",
    defensive_interceptions: "Interceptions",
    at_bats: "At bats",
    rbi: "RBI",
    home_runs: "Home runs",
    walks: "Walks",
    strikeouts: "Strikeouts",
    doubles: "Doubles",
    triples: "Triples",
    stolen_bases: "Stolen bases",
    batting_average: "Batting average",
    on_base_percentage: "On-base percentage",
    slugging: "Slugging",
    innings_pitched: "Innings pitched",
    earned_run_average: "ERA",
    pitching_strikeouts: "Strikeouts pitched",
    pitching_walks: "Walks allowed",
    fouls_drawn: "Fouls drawn",
    aerials_won: "Aerial duels won",
    usage_percentage: "Usage percentage",
    true_shooting_percentage: "True shooting percentage",
    effective_field_goal_percentage: "Effective field goal percentage",
    offensive_rating: "Offensive rating",
    defensive_rating: "Defensive rating",
    net_rating: "Net rating",
    pace: "Pace",
    pie: "Player impact estimate",
    plate_appearances: "Plate appearances",
    total_bases: "Total bases",
    pitches_thrown: "Pitches thrown",
    points_rebounds_assists: "Points + rebounds + assists",
    points_rebounds: "Points + rebounds",
    points_assists: "Points + assists",
    rebounds_assists: "Rebounds + assists",
    double_double: "Double-double",
    triple_double: "Triple-double",
    anytime_touchdown: "Anytime touchdown",
    first_touchdown: "First touchdown",
    rushing_receiving_yards: "Rushing + receiving yards",
    longest_reception: "Longest reception",
    longest_rush: "Longest rush",
    longest_pass: "Longest pass",
    kicking_points: "Kicking points",
    singles: "Singles",
    extra_base_hits: "Extra-base hits",
    hits_runs_rbis: "Hits + runs + RBI",
    runs_rbis: "Runs + RBI",
    hits_stolen_bases: "Hits + stolen bases",
    hits_runs_stolen_bases: "Hits + runs + stolen bases",
    hits_walks_stolen_bases: "Hits + walks + stolen bases",
    pitcher_outs: "Outs recorded",
    pitcher_earned_runs: "Earned runs allowed",
    pitcher_hits_allowed: "Hits allowed",
    pitcher_hits_walks_earned_runs: "Hits + walks + earned runs allowed",
    pitcher_win: "Pitcher win",
    first_home_run: "First home run",
    touchdowns: "Rushing + receiving touchdowns",
    hit_woodwork: "Hit the woodwork",
    big_chances_missed: "Big chances missed",
    tackles_won: "Tackles won",
    throw_ins: "Throw-ins",
    goal_kicks: "Goal kicks",
    free_kicks: "Free kicks",
    long_passes: "Long passes",
    xg: "Expected goals (xG)",
    goals_0_15: "Goals 0-15 min",
    goals_15_30: "Goals 15-30 min",
    goals_30_45: "Goals 30-45 min",
    goals_45_60: "Goals 45-60 min",
    goals_60_75: "Goals 60-75 min",
    goals_75_90: "Goals 75-90 min",
    blocked_shots: "Shots blocked",
    dispossessed: "Dispossessed",
    duels: "Duels",
    penalties_committed: "Penalties conceded",
    goals_conceded: "Goals conceded",
    own_goals: "Own goals",
    penalty_kicks: "Penalty kicks"
  },
  oddsFormats: {
    decimal: "Decimal (1.85)",
    fractional: "Fractional (17/20)",
    american: "American (-118)"
  },
  settings: {
    title: "Settings",
    preferences: {
      title: "Preferences",
      locale: "Language",
      timezone: "Time zone",
      defaultSport: "Default sport",
      noDefaultSport: "First enabled sport",
      oddsFormat: "Odds format",
      save: "Save preferences",
      saved: "Preferences saved."
    },
    password: {
      title: "Password",
      description: "Changing your password signs out every other device.",
      save: "Change password",
      saved: "Password changed. Other sessions were signed out."
    },
    delete: {
      title: "Delete account",
      description: "This removes your account and everything attached to it. It cannot be undone.",
      confirmLabel: "Type {{word}} to confirm",
      submit: "Delete my account",
      cancel: "Cancel",
      mismatch: "Type the confirmation word exactly"
    }
  },
  admin: {
    users: {
      title: "Users",
      search: "Search by email",
      email: "Email",
      status: "Account access",
      sports: "Sports",
      verified: "Verified",
      unverified: "Unverified",
      firstGranted: "First grant",
      view: "View",
      empty: "No users match.",
      saved: "Saved",
      statuses: {
        beta: "Enabled",
        active: "Enabled",
        inactive: "Disabled"
      }
    },
    navigation: {
      title: "Administration",
      overview: "Overview",
      ingestion: "Ingestion"
    },
    overview: {
      description: "Manage accounts, review access and follow up on new registrations.",
      manageUsers: "Manage users",
      totalUsers: "Total users",
      verifiedUsers: "Verified accounts",
      adminUsers: "Administrators",
      usersWithAccess: "Users with access",
      planStatuses: "Plan status",
      sportAccess: "Access by sport",
      accessDescription: "Includes administrators. Expired grants and inactive member accounts are excluded.",
      recentUsers: "Recent accounts",
      review: "Needs attention",
      awaiting: "Awaiting verification",
      disabled: "Disabled accounts",
      created: "Joined",
      accessNote: "Enabled accounts still need a sport grant. Administrators have access to every sport."
    },
    filters: {
      role: "Role",
      planStatus: "Filter by plan status",
      verified: "Email verification",
      sport: "Access to sport",
      all: "All",
      user: "User",
      admin: "Administrator",
      true: "Verified",
      false: "Unverified",
      enabled: "Filter by account access"
    },
    details: {
      back: "Back to users",
      account: "Account",
      created: "Created",
      activeSessions: "Active sessions",
      grants: "Stored grants",
      noGrants: "No stored grants.",
      expires: "Expires",
      noExpiry: "No expiry",
      grantedBy: "Granted by",
      viewGrantor: "View administrator",
      enableAccount: "Enable account",
      disableAccount: "Disable account"
    },
    ingestion: {
      description: "Follow the provider backlog, the live feeds and what is already stored.",
      refresh: "Refresh",
      sport: "Diagnostics for sport",
      approximate: "Approximate counts from planner statistics",
      outbox: "Projection outbox",
      counts: {
        records: "Records",
        versions: "Versions",
        fixtures: "Matches",
        teamMetrics: "Team metrics",
        playerMetrics: "Player metrics",
        quotes: "Odds snapshots"
      },
      tasks: "Task families",
      noTasks: "No tasks scheduled for this sport.",
      family: "Family",
      families: {
        leagues: "Leagues",
        seasons: "Seasons",
        schedules: "Schedules",
        teams: "Teams",
        squads: "Squads",
        standings: "Standings",
        "fixture-batches": "Match batches",
        odds: "Odds",
        "live-feeds": "Live feeds",
        games: "Games",
        stats: "Stats",
        "box-scores": "Box scores",
        other: "Other"
      },
      statuses: {
        pending: "Pending",
        running: "Running",
        complete: "Complete",
        failed: "Failed",
        retired: "Retired",
        restricted: "Restricted"
      },
      oldestPending: "Oldest pending",
      priority: "priority {{priority}}",
      feeds: "Live feeds",
      noFeeds: "No live feeds scheduled for this sport.",
      endpoint: "Endpoint",
      cadence: "Cadence",
      completedAgo: "completed {{age}} ago",
      neverCompleted: "Never completed",
      match: "Match diagnostics",
      matchDescription: "Paste a match id or the match page URL to see the stored research behind it.",
      matchId: "Match id or URL",
      inspect: "Inspect",
      invalidId: "Paste a match id or a match page URL.",
      side: "Side",
      team: "Team",
      storedFinishedBefore: "Finished before",
      withTeamMetrics: "With team metrics",
      withPlayerMetrics: "With player metrics",
      lastMetric: "Last stored metric",
      quotes: "Odds snapshots",
      pendingBatches: "Pending match batches",
      competition: "Competition",
      none: "None",
      provider: {
        title: "Provider status",
        description: "Based on ingestion activity for the selected sport. Refresh to update.",
        statuses: {
          healthy: "Healthy",
          issues: "Issues detected",
          stale: "Stale",
          unknown: "No data",
          not_configured: "Not configured"
        },
        hints: {
          healthy: "Recent successful requests with no failed or restricted tasks.",
          issues: "Review failed and restricted task families below. Restricted requests may require provider access or subscription changes.",
          stale: "No successful request in the last 30 minutes. Check the worker and provider; ingestion may also be idle.",
          unknown: "No successful request recorded yet. Check that ingestion is configured and running.",
          not_configured: "The worker reported missing provider configuration. Check its provider credentials."
        },
        counts: "{{failed}} failed \xB7 {{restricted}} restricted \xB7 {{parked}} parked",
        lastSuccess: "Last success: {{age}} ago",
        lastAttempt: "Last attempt: {{age}} ago",
        noSuccess: "No successful request recorded",
        noAttempt: "No attempt recorded"
      }
    },
    loginHistory: {
      title: "Login history",
      description: "Successful sign-ins, newest first. IP locations are approximate and may reflect a VPN or network provider. History starts when tracking is enabled.",
      empty: "No logins recorded.",
      time: "Date and time",
      location: "Approximate location",
      ip: "IP address",
      browser: "Browser / device",
      unavailable: "Unavailable"
    }
  },
  matches: {
    title: "Matches",
    locked: "Locked",
    lockedTitle: "Sport access required",
    lockedDescription: "Your account does not have access to this sport. Choose an available sport from the menu.",
    unavailableTitle: "Match data is not available yet",
    unavailableDescription: "Your access is active. Schedules and research will appear here once sports data is connected.",
    previousDay: "Previous day",
    nextDay: "Next day",
    date: "Date",
    today: "Today",
    stale: "Updates are delayed. These are the last stored results.",
    empty: "No matches scheduled for this day.",
    loadingSchedule: "Loading matches for this day",
    timeUnknown: "Time to be confirmed",
    search: "Search by team",
    filters: {
      label: "Status",
      all: "All",
      upcoming: "Upcoming",
      live: "Live",
      finished: "Finished"
    },
    allCompetitions: "All competitions",
    competitions: {
      picker: "Competitions",
      search: "Search competition",
      selected_zero: "{{count}} competitions",
      selected_one: "{{count}} competition",
      selected_other: "{{count}} competitions"
    },
    favourite: "Favourite",
    unfavourite: "Remove favourite",
    noResults: "No matches match these filters.",
    clearFilters: "Clear filters",
    gamesCount_zero: "{{count}} matches",
    gamesCount_one: "{{count}} match",
    gamesCount_other: "{{count}} matches",
    collapseGroup: "Collapse",
    expandGroup: "Expand",
    statuses: {
      scheduled: "Scheduled",
      live: "Live",
      finished: "Finished",
      postponed: "Postponed",
      cancelled: "Cancelled",
      unknown: "Status unavailable",
      suspended: "Suspended",
      delayed: "Delayed",
      abandoned: "Abandoned",
      awarded: "Awarded"
    },
    notFound: "Match not found",
    backToMatches: "Back to matches",
    venue: "Venue",
    season: "Season",
    roundSuffix: ", round {{round}}",
    shootoutScore: "Penalties {{home}} \u2013 {{away}}",
    pageTitle: "{{home}} vs {{away}}",
    kickoff: "Start time",
    teams: "Teams",
    team: "Team",
    sides: {
      home: "Home",
      draw: "Draw",
      away: "Away"
    },
    rankOrdinal: "#{{rank}}",
    form: {
      label: "Recent form",
      W: "W",
      D: "D",
      L: "L"
    },
    referee: "Referee: {{name}}",
    refereeCards_zero: "{{cards}} cards per match ({{sample}} matches)",
    refereeCards_one: "{{cards}} cards per match ({{sample}} match)",
    refereeCards_other: "{{cards}} cards per match ({{sample}} matches)",
    prices: {
      label: "Prices",
      captured: "captured {{time}}"
    },
    total: "Total",
    winner: "Winner",
    periodScores: "Period scores",
    overviewPending: {
      title: "Nothing is recorded for this match yet",
      description: "Statistics and period scores appear here once the game starts. Recent form and previous meetings are already in the analysis.",
      action: "Open the analysis"
    },
    openMatch: "{{home}} versus {{away}}",
    liveMinute: "{{minute}}'",
    periods: {
      q1: "Q1",
      q2: "Q2",
      q3: "Q3",
      q4: "Q4",
      ot: "OT",
      runs: "Runs",
      hits: "Hits",
      errors: "Errors",
      full: "Full time",
      first_half: "First half",
      half_time: "Half time",
      second_half: "Second half",
      extra_time: "Extra time",
      penalties: "Penalties"
    },
    sections: {
      label: "Match sections",
      overview: "Overview",
      analysis: "Analysis",
      players: "Players",
      lines: "Lines"
    },
    markets: {
      fulltime_result: "Match result",
      double_chance: "Double chance",
      draw_no_bet: "Draw no bet",
      match_goals: "Goals over/under",
      goals_over_under: "Goals over/under",
      goal_line: "Goal line",
      asian_handicap: "Asian handicap",
      both_teams_to_score: "Both teams to score",
      half_time_result: "Half time result",
      "1st_half_goals": "First half goals",
      home_team_goals: "Home team goals",
      away_team_goals: "Away team goals",
      corners: "Corners",
      cards: "Cards"
    },
    lines: {
      disclaimer: "Prices are the bookmaker's own, captured at the time shown. Historical frequency is not a probability.",
      empty: "No bookmaker prices stored for this match yet.",
      history: "{{hits}} of {{sample}} matches over the line, history",
      over: "Over",
      under: "Under",
      yes: "Yes",
      no: "No",
      columns: {
        line: "Line",
        side: "Selection",
        price: "Price",
        opening: "Opening",
        captured: "Captured",
        history: "History"
      }
    },
    players: {
      sample: "Recent matches",
      sampleCount_zero: "{{count}} matches",
      sampleCount_one: "{{count}} match",
      sampleCount_other: "{{count}} matches",
      player: "Player",
      position: "Position",
      appearances: "Appearances",
      empty: "No recorded player statistics for this match yet."
    },
    research: {
      noHistory: "No previous matches recorded for these teams yet."
    },
    statistics: {
      lead: "Recorded results per metric for the selected filters.",
      sampleFilter: "Recent matches",
      sampleOption: "Last {{size}} matches",
      venueFilter: "Venue",
      venues: {
        all: "Home and away",
        home: "Home only",
        away: "Away only"
      },
      periodFilter: "Period",
      columns: {
        metric: "Metric",
        mean: "Average",
        variation: "Variation",
        sample: "Sample",
        values: "Recent values"
      },
      sample: "{{sampleSize}} of {{eligible}} matches",
      sampleWithMissing: "{{sampleSize}} of {{eligible}} matches, {{missing}} without this metric",
      empty: "No recorded team statistics for this sport yet.",
      match: {
        title: "Match statistics",
        period: "Match period"
      }
    },
    analysis: {
      loading: "Loading the analysis",
      empty: "No recorded games for these filters yet.",
      filters: {
        sample: "Sample",
        sampleOption: "{{size}} games",
        venue: "Venue",
        venues: {
          split: "Home/Away",
          all: "All",
          home: "Home",
          away: "Away"
        },
        competition: "Competition",
        competitions: {
          all: "All"
        }
      },
      groups: {
        label: "Analysis groups",
        performance: "Performance",
        goals: "Goals",
        timing: "Goal minutes",
        corners: "Corners",
        shots: "Shots",
        discipline: "Discipline",
        odds: "Odds",
        head_to_head: "Head-to-head",
        projection: "Projection",
        scoring: "Scoring",
        team_stats: "Team stats"
      },
      periods: {
        full: "full time",
        first_half: "first half",
        second_half: "second half"
      },
      metrics: {
        goals: "goals",
        corners: "corners",
        yellow_cards: "yellow cards",
        points: "points",
        runs: "runs"
      },
      blocks: {
        goalsScored: "Goals scored",
        goalsConceded: "Goals conceded",
        goalMarkets: "Goal over rates",
        timingFor: "Goals scored by minute",
        timingAgainst: "Goals conceded by minute",
        expectedGoals: "Expected goals",
        cornersFor: "Corners won",
        cornersAgainst: "Corners conceded",
        cornersTotal: "Match corners",
        cornerMarkets: "Corner over rates",
        shots: "Shots",
        efficiency: "Finishing",
        discipline: "Cards and fouls",
        cardMarkets: "Card over rates",
        record: "Head-to-head record",
        rates: "Match rates",
        meetings: "Meetings",
        projection: "Projection",
        scoringFor: "{{metric}} scored",
        scoringAgainst: "{{metric}} conceded",
        scoringMarkets: "Total over rates"
      },
      rows: {
        games: "Games",
        points: "Points",
        pointsRate: "Points rate",
        won: "Won",
        drawn: "Drawn",
        lost: "Lost",
        form: "Form",
        scoredFirst: "Scored first",
        wonFirstHalf: "Won at half-time",
        btts: "Both teams to score",
        cleanSheet: "Clean sheet",
        failedToScore: "Failed to score",
        scoreFor: "Score for",
        scoreAgainst: "Score against",
        mean: "Mean",
        cv: "CV",
        median: "Median",
        p75: "P75",
        goalsScored: "Goals scored, {{period}}",
        goalsConceded: "Goals conceded, {{period}}",
        over: "Over {{line}} {{metric}}, {{period}}",
        teamOver: "Team over {{line}} {{metric}}, {{period}}",
        perGame: "Per game, {{period}}",
        cornersFor: "Corners won, {{period}}",
        cornersAgainst: "Corners conceded, {{period}}",
        cornersTotal: "Match corners, {{period}}",
        metricFor: "{{metric}} for",
        metricAgainst: "{{metric}} against",
        shotsPerGoal: "Shots per goal",
        shotsOnTargetPerGoal: "Shots on target per goal",
        conversion: "Conversion",
        expectedFor: "Expected goals for",
        expectedAgainst: "Expected goals against",
        draws: "Draws {{drawn}}",
        meanGoals: "Mean goals",
        meanCorners: "Mean corners",
        over25: "Over 2.5 goals",
        produced: "Produced",
        opponentConceded: "Opponent concedes",
        projection: "Projection",
        pricedGames: "Games with a closing price",
        averagePrice: "Average price",
        impliedProbability: "Implied probability",
        winRate: "Win rate",
        profit: "Profit and loss",
        roi: "Return on investment",
        scoringFor: "{{metric}} scored, {{period}}",
        scoringAgainst: "{{metric}} conceded, {{period}}",
        spreadCover: "Spread cover",
        totalOver: "Total over"
      },
      odds: {
        empty: "Closing prices exist for games from the 2025-26 season on",
        profitSummary: "Cumulative profit and loss over {{count}} priced games, ending at {{total}} units",
        columns: {
          date: "Date",
          opponent: "Opponent",
          result: "Result",
          price: "Closing price",
          profit: "Profit and loss"
        }
      },
      headToHead: {
        empty: "No meetings in this sample",
        columns: {
          date: "Date",
          competition: "Competition",
          score: "Score",
          corners: "Corners",
          cards: "Cards"
        }
      },
      projection: {
        formula: "Projection = (team produced + opponent conceded) / 2, over the selected sample"
      }
    }
  },
  teams: {
    latestStanding: "Latest standing",
    viewHistory: "View season history",
    seasonHistory: "Season history",
    historyDescription: "Latest available standings for each season and group.",
    noHistory: "No season standings available yet.",
    loaded_zero: "{{formattedCount}} teams loaded",
    loaded_one: "{{formattedCount}} team loaded",
    loaded_other: "{{formattedCount}} teams loaded",
    clearFilters: "Clear filters",
    noResultsDescription: "Try another team name or clear your filters.",
    title: "Teams",
    search: "Search teams",
    competition: "Competition",
    allCompetitions: "All competitions",
    empty: "No teams found.",
    notFound: "Team not found",
    backToTeams: "Back to teams",
    sections: {
      standings: "Standings",
      label: "Team sections",
      overview: "Overview",
      statistics: "Statistics",
      fixtures: "Fixtures",
      players: "Players"
    },
    standing: "Standing",
    noStanding: "No standings for this team yet.",
    position: "Position",
    played: "Played",
    won: "Won",
    drawn: "Drawn",
    lost: "Lost",
    points: "Points",
    group: "Group",
    form: "Recent form",
    results: {
      won: "W",
      lost: "L",
      drawn: "D"
    },
    liveMatch: "Live now",
    nextMatch: "Next match",
    lastMatch: "Last match",
    noNextMatch: "No scheduled match.",
    noLastMatch: "No finished match.",
    season: "Season",
    seasonOption: "{{competition}} \xB7 {{season}}",
    noFixtures: "No fixtures for this season.",
    player: "Player",
    appearances: "Appearances",
    lastPlayed: "Last played",
    noPlayers: "No players recorded for this team yet.",
    analysis: {
      empty: "No completed matches match these filters.",
      competition: "Competition",
      allCompetitions: "All competitions",
      efficiency: "Points earned",
      points: "Points",
      record: "Record",
      sample_zero: "{{count}} matches analyzed",
      sample_one: "{{count}} match analyzed",
      sample_other: "{{count}} matches analyzed",
      scoredSample: "Results available: {{count}}",
      form: "Recent form",
      full: "Full match",
      first_half: "First half",
      averages: "Averages per match",
      for: "For",
      against: "Against",
      total: "Total",
      trend: "Trend: last three matches compared with the sample average.",
      coverage: "Available in {{count}} of {{total}} matches",
      homeAway: "Home vs away",
      home: "Home",
      away: "Away",
      frequencies: "Historical frequencies",
      markets: "Historical market frequencies",
      historicalNote: "Historical hit rates, not forecasts. Missing statistics are excluded from each calculation.",
      over: "Over {{line}} \xB7 {{metric}}",
      btts: "Both teams scored",
      clean_sheet: "Clean sheet",
      failed_to_score: "Failed to score",
      scored_first: "Scored first",
      won_first_half: "Won first half",
      recent: "Last five matches",
      opponent: "Opponent",
      matrix: "Match-by-match statistics",
      indicator: "Indicator",
      mean: "Avg.",
      cv: "CV",
      cvHelp: "CV measures variation relative to the average; lower values mean more consistent results.",
      available: "Sample",
      all: "All",
      category: "Statistic category",
      period: "Match period",
      won: "W",
      drawn: "D",
      lost: "L",
      unknown: "Unknown result",
      score: "Score",
      yellowCardsNote: "Card thresholds use yellow cards from both teams. Red cards are shown separately in Statistics."
    }
  },
  players: {
    title: "Players",
    search: "Search players",
    player: "Player",
    position: "Position",
    team: "Team",
    allTeams: "All teams",
    searchTeams: "Search teams",
    noTeams: "No teams found.",
    empty: "No players found.",
    notFound: "Player not found",
    backToPlayers: "Back to players",
    averages: "Averages",
    sections: {
      label: "Player sections"
    },
    gameLog: "Game log",
    formerTeam: "Former team",
    appearances_zero: "{{appearances}} games recorded",
    appearances_one: "{{appearances}} game recorded",
    appearances_other: "{{appearances}} games recorded",
    opponent: "Opponent",
    noGames: "No recorded games for this player yet.",
    sample: {
      label: "Recent games",
      option: "Last {{size}} games",
      all: "All games"
    },
    analysis: {
      title: "Player analysis",
      overview: "Overview",
      statistics: "Statistics",
      role: "Participation",
      allRoles: "All appearances",
      starter: "Starter",
      substitute: "Substitute",
      unknown: "Unknown",
      minMinutes: "Minimum minutes",
      empty: "No appearances match these filters.",
      frequencies: "Historical player frequencies",
      recent: "Recent appearances",
      matrix: "Player match-by-match statistics",
      per90: "Per 90",
      starts: "Starts",
      minutes: "Minutes played",
      coverage: "Data coverage",
      methodology: "Per-90 values use only matches with both the statistic and recorded minutes. Missing values are excluded. Frequencies describe past appearances, not predictions.",
      over: "Over {{line}} \xB7 {{metric}}",
      all: "All",
      attack: "Attack",
      creation: "Creation",
      defense: "Defense",
      discipline: "Discipline",
      goalkeeping: "Goalkeeping",
      trend: "Last 3 vs sample",
      per36: "Per 36",
      per9: "Per 9 innings",
      scoring: "Scoring",
      rebounding: "Rebounding",
      advanced: "Advanced",
      passing: "Passing",
      rushing: "Rushing",
      receiving: "Receiving",
      batting: "Batting",
      pitching: "Pitching",
      batter: "Batter",
      pitcher: "Pitcher",
      battingOrder: "Batting order",
      sportMethodology: "Averages and historical frequencies exclude missing values. NBA rates use 36 minutes; MLB pitching rates use nine innings, using only games with both the statistic and recorded workload. Frequencies describe past games, not predictions."
    }
  },
  footer: {
    message: "18+ only. Bet responsibly.",
    responsibility: "Betting involves real financial risk. Never stake money you cannot afford to lose.",
    independent: "Pick Pro is an independent sports research service. It does not accept bets, hold betting deposits or pay winnings. Any bet is placed separately with a third-party operator.",
    noIncome: "Betting is not an investment or a source of income. Statistics and suggestions do not guarantee returns. You may lose the entire amount staked.",
    help: "If betting is affecting you, seek support through Brazil\u2019s SUS, a UBS or CAPS. You can also request exclusion from federally authorized betting platforms.",
    resources: "Responsible gambling resources in Brazil",
    selfExclusion: "Self-exclusion \xB7 GOV.BR",
    healthSupport: "Health support \xB7 SUS",
    authorized: "Check authorized operators \xB7 SPA",
    regulation: "Brazilian betting regulations",
    tagline: "A clearer view of the game. Research with context, on your terms.",
    product: "Explore",
    transparency: "Transparency",
    support: "Support & safety",
    rights: "All rights reserved."
  },
  landing: {
    meta: {
      title: "Sports research with real odds",
      description: "Team and player history next to real bookmaker lines for soccer, NBA, NFL and MLB. Your first {{freeScans}} scans are free."
    },
    hero: {
      title: "Research the match. Compare the line. Decide for yourself.",
      description: "Team and player history next to the real bookmaker line, with the time it was captured. Soccer, NBA, NFL and MLB.",
      primaryAction: "Start with {{freeScans}} free scans",
      offer: "No card needed. Then {{base}} a month, cancel anytime.",
      caption: "Flamengo went over 9.5 corners in {{hits}} of their last {{known}}. The line offered {{price}}, captured before kickoff. The record and the line side by side. The call is yours.",
      secondaryAction: "How it works",
      responsibility: "Adults only. Betting involves financial risk."
    },
    how: {
      title: "From fixture to informed decision",
      description: "Follow the evidence without turning past performance into a prediction.",
      steps: {
        research: {
          title: "Scan the day",
          description: "One scan runs Radar or Pick Pro over a sport's matches and lists the selections with their recent record."
        },
        compare: {
          title: "Compare the real line",
          description: "The market, the line and the time it was captured sit beside the record."
        },
        track: {
          title: "Save and track the result",
          description: "Saved picks and result tracking keep the whole loop in one place."
        }
      }
    },
    honesty: {
      title: "History stays history.",
      description: "A historical frequency describes what happened in a defined sample and never what comes next, so there are no tips here: the reading and the decision are yours."
    },
    faq: {
      title: "The short version",
      items: {
        bettingSite: {
          question: "Is this a betting site?",
          answer: "No. It is an independent sports research product. You cannot place a bet here."
        },
        guarantees: {
          question: "Do you guarantee results?",
          answer: "No. Sport is uncertain, historical records do not predict future outcomes, and no result is guaranteed."
        },
        scans: {
          question: "What counts as a scan?",
          answer: "One scan runs Radar or Pick Pro over the day's matches for one sport. Your first {{freeScans}} are free. The plan includes {{monthlyScans}} a month across all your sports."
        },
        leagues: {
          question: "Which leagues are included?",
          answer: "Soccer, NBA, NFL and MLB are covered. Availability depends on each sport's release and data coverage."
        },
        free: {
          question: "How does pricing work?",
          answer: "Your first {{freeScans}} scans are free, with no card. After that, choose a main sport for {{base}} a month and add sports for {{additional}} each: two sports total {{two}} and three total {{three}}. Every plan includes {{monthlyScans}} scans a month across all your sports. Prices are in Brazilian reais. Cancel anytime."
        }
      }
    },
    sports: {
      football: "Soccer",
      nba: "NBA",
      nfl: "NFL",
      mlb: "MLB"
    },
    closing: {
      title: "Start with {{freeScans}} free scans.",
      description: "No card needed. The plan starts only when you choose it."
    },
    pricing: {
      title: "{{freeScans}} scans free. Then one plan for your sports.",
      description: "Choose your main sport, then add the sports you want to follow. One monthly price in Brazilian reais, with {{monthlyScans}} scans a month included.",
      base: "per month for one sport",
      extra: "per month for each additional sport",
      mainSport: "Choose your main sport",
      extraSports: "Add extra sports (optional)",
      total: "Your monthly total",
      perMonth: "/month",
      included: "Includes {{monthlyScans}} scans a month across all your sports. Cancel anytime."
    }
  },
  legal: {
    back: "Back to Pick Pro",
    updated: "Last reviewed:",
    contents: "On this page",
    resources: "Official resources",
    draftTitle: "Draft for review",
    draftDescription: "This document is not yet final. The provider\u2019s legal identity, public contacts and operating procedures must be confirmed before subscriptions open.",
    terms: {
      title: "Terms of Service",
      description: "The scope of our service, your responsibilities and the conditions for using Pick Pro.",
      sections: {
        scope: {
          title: "About the service",
          body: "Pick Pro is an independent sports research product. It presents information, statistics and analysis tools. It does not accept or execute bets, hold betting deposits or pay winnings. Bankrolls and bet records are tracking tools. An external operator is responsible for any bet placed with it. This draft describes the current service and the intended subscription model."
        },
        access: {
          title: "Age and access",
          body: "The service is intended for people aged 18 or over. Do not use it if you are under 18 or access is prohibited where you live. Every account includes {{freeScans}} free scans. After that, research tools open per sport according to the account plan. Registration does not create a paid subscription. Automated billing is not active yet."
        },
        use: {
          title: "Permitted use",
          body: "Use the service lawfully for your research. Do not interfere with security, attempt unauthorized access, misuse personal data, redistribute licensed datasets without permission or manipulate sporting events. Rights in the software, brand and content belong to their respective holders, preserving your statutory rights and lawful uses."
        },
        payments: {
          title: "Monthly prices and billing",
          body: "The proposed subscription costs {{base}} per month for a main sport of your choice, plus {{additional}} monthly per additional sport. Prices are in Brazilian reais. The calculator does not process payments. Before purchase, checkout must identify the supplier, available sports, recurring total, renewal and cancellation terms. Extras require explicit selection. No bundles are available."
        },
        rights: {
          title: "Cancellation and consumer rights",
          body: "Cancellation and refund channels must be presented before purchase. Applicable consumer rights are preserved, including the seven-day withdrawal right for qualifying distance contracts. No clause limits mandatory refunds, legal remedies or access to consumer protection bodies. The preview does not yet offer subscription management or refunds."
        },
        responsibility: {
          title: "Research limits and responsibility",
          body: "Historical frequencies do not guarantee future outcomes. Data and prices may change or contain errors. Check the source, capture time and operator\u2019s actual conditions before deciding. Betting can cause dependency and the loss of the entire stake. These terms do not exclude mandatory legal liability or shift responsibility for service defects onto consumers."
        },
        changes: {
          title: "Changes and disputes",
          body: "Material changes must be communicated clearly without retroactively removing acquired rights. Access restrictions for security, maintenance or unlawful use must respect consumer protections. Brazilian law governs the Brazilian offer without excluding other mandatory protections. Access to the competent courts is preserved, including the consumer\u2019s home forum where the law provides it."
        },
        contact: {
          title: "Provider and contact",
          body: "The legal name, CNPJ/CPF where applicable, business address and public support contact are pending confirmation. These terms therefore remain a draft. These details and an effective support channel must be published before subscriptions open. Do not send documents or sensitive information to unverified contacts."
        }
      }
    },
    privacy: {
      title: "Privacy Policy",
      description: "How account access, preferences and saved research are handled.",
      sections: {
        scope: {
          title: "Controller and scope",
          body: "This draft covers the Pick Pro public pages and signed-in research tools. The controller\u2019s legal identity, address and privacy contact remain pending confirmation. External bookmakers and services have their own privacy notices."
        },
        access: {
          title: "Preview data",
          body: "Registration collects your email address and password, which is stored as a hash. Your account stores verification and access status, language, timezone and odds-format preferences. When you use research and tracking tools, we store saved selections, tickets, bankrolls and bet records. Login and session records include technical information such as IP address, browser and access times. The pricing calculator does not process a payment."
        },
        use: {
          title: "Purposes and legal bases",
          body: "Account and session data support sign-in, email verification, password recovery and access control. Preferences customize the interface. Saved research and tracking records let you revisit selections and results. The processing record and legal bases remain pending operational confirmation. Browsing does not authorize optional tracking, advertising or marketing."
        },
        payments: {
          title: "Browser storage and cookies",
          body: "Sign-in uses the pickpro_access and pickpro_refresh cookies for authentication and pickpro_session to indicate a session to the interface. Preferences are also stored locally under pickpro.preferences and remain until changed or cleared. The application does not install advertising pixels or audience analytics scripts. Infrastructure cookies, if enabled, must be inventoried separately."
        },
        rights: {
          title: "Your rights",
          body: "Where applicable under the LGPD, you may request confirmation, access, correction, sharing information, anonymization or deletion of unnecessary or unlawful data, portability under the rules and withdrawal of consent. You may also challenge unlawful processing and request review of qualifying automated decisions. The public request channel is pending confirmation. You can manage local data through the browser and contact the ANPD or consumer protection bodies."
        },
        responsibility: {
          title: "Providers and security",
          body: "Hosting and network services receive request information, which may include IP address, browser, requested path and time. Providers, countries, safeguards and retention must be confirmed against the live deployment. Access controls, transport protection and incident procedures are required; no system is risk-free. International transfers, if any, require a valid LGPD mechanism and disclosure; this draft does not certify an implemented mechanism."
        },
        changes: {
          title: "Retention and future features",
          body: "Account, saved research and tracking data persist to provide your account history. You can remove saved items and request account deletion through Settings. Server, security and backup retention periods and deletion from backups remain pending confirmation. Automated billing is not active yet; payment processing will require an updated notice before activation."
        },
        contact: {
          title: "Contact, minors and changes",
          body: "The service is intended for adults. A working privacy contact, procedures for requests and reports involving minors, and the controller\u2019s identity must be added before finalization. Material changes to purposes, recipients or choices will be communicated. Updating the policy does not provide consent to a new optional use."
        }
      }
    },
    responsible: {
      title: "Responsible gambling",
      description: "Research can provide context. It cannot remove the risks of betting.",
      sections: {
        scope: {
          title: "Independent research",
          body: "Pick Pro does not accept bets, hold betting deposits or pay winnings. Any bet happens separately with an external operator. The subscription pays for research software, not betting credit."
        },
        access: {
          title: "For adults only",
          body: "The service is intended for people aged 18 or over. Operators have their own eligibility checks and legal restrictions; being an adult or using Pick Pro does not prove eligibility to bet."
        },
        use: {
          title: "Numbers in context",
          body: "Check sample size and period, missing records and quote capture times. A high historical frequency does not guarantee an outcome. Example data is illustrative; suggestions are not promises of profit."
        },
        payments: {
          title: "Money and time",
          body: "Betting is not an investment, employment substitute or solution to debt. You may lose the full stake. Do not use money for essential needs, borrow to bet or increase stakes to recover losses. Set limits and stop if betting affects your life."
        },
        rights: {
          title: "Centralized self-exclusion",
          body: "Brazil\u2019s government offers voluntary blocking of platforms federally authorized by the SPA, for a chosen period or indefinitely. Use the GOV.BR link below. This does not automatically delete Pick Pro data or cancel a separate research subscription."
        },
        responsibility: {
          title: "Health support",
          body: "If betting affects your wellbeing or relationships, seek support through Brazil\u2019s SUS, at a UBS or CAPS. Family members can also seek guidance. The Ministry of Health link below lists current channels."
        },
        changes: {
          title: "External operators",
          body: "If you decide to bet, check the operator and exact domain against the current SPA list for federally authorized services. A brand in a research example is not an endorsement or proof that a link is authorized. Do not rely only on logos or advertising."
        },
        contact: {
          title: "Official information",
          body: "The links below lead to government services for self-exclusion, health support, operator checks and regulations, with their own terms and privacy notices. Pick Pro does not represent the government or claim these links constitute regulatory approval."
        }
      }
    }
  },
  radar: {
    title: "{{sport}} Radar",
    matches: "Matches",
    players: "Players",
    search: "Search matches and players",
    searchPlaceholder: "Team, player or competition",
    date: "Day",
    market: "Market",
    sort: "Sort by",
    probability: "Model probability",
    ev: "Estimated EV",
    fairOdds: "Fair odds",
    offeredOdds: "Offered odds",
    oddsUpdated: "Price updated",
    analyzeMatch: "Analyze match",
    analyzePlayer: "Analyze player",
    error: "Could not load Radar",
    empty: "No matching selections",
    emptyDescription: "Try another day or adjust your filters.",
    noFixtures: "No upcoming matches on this day",
    noFixturesDescription: "Choose another day to explore upcoming {{sport}}.",
    loading: "Loading Radar",
    loadingMore: "Loading more",
    count_zero: "{{count}} selections",
    count_one: "{{count}} selection",
    count_other: "{{count}} selections",
    coverage: "{{analyzed}} of {{total}} matches have usable data and odds for the selected markets",
    showMore: "Show more",
    reset: "Reset filters",
    historical: "Recent performances",
    minutes: "Average minutes",
    average: "Average",
    sample_zero: "Last {{count}} appearances",
    sample_one: "Last {{count}} appearance",
    sample_other: "Last {{count}} appearances",
    unknown: "Not recorded",
    over: "Over {{line}}",
    milestone: "{{count}}+",
    opening: "Opening price",
    quarters: "By quarter",
    lineup: {
      battingOrder: "Batting {{order}}",
      probablePitcher: "Probable pitcher"
    },
    lineupStatus: {
      starter: "Starter",
      bench: "Bench",
      absent: "Not in squad",
      expected: "Probable starter",
      pending: "Lineup pending"
    },
    lineupStatusHint: {
      expected: "Probable lineup, not confirmed yet.",
      pending: "The lineup is not out yet. The player may not start."
    },
    availability: {
      out: "Out",
      doubtful: "Doubtful",
      questionable: "Questionable",
      day_to_day: "Day to day",
      probable: "Probable",
      active: "Active"
    },
    versus: {
      title: "Matchup",
      line: "vs {{opponent}}: {{hits}}/{{atBats}}, {{homeRuns}} HR, {{strikeouts}} K",
      plateAppearances: "Plate appearances",
      atBats: "At bats",
      hits: "Hits",
      homeRuns: "Home runs",
      strikeouts: "Strikeouts",
      walks: "Walks",
      avg: "AVG",
      ops: "OPS"
    },
    splits: {
      title: "Splits",
      home: "Home",
      away: "Away",
      versusLeft: "vs LHP",
      versusRight: "vs RHP",
      last15: "Last 15 days",
      versusOpponent: "vs {{opponent}}",
      avgLine: "AVG {{avg}}",
      opsLine: "OPS {{ops}}",
      avg: "AVG",
      ops: "OPS",
      homeRuns: "Home runs",
      strikeouts: "Strikeouts",
      atBats: "At bats",
      empty: "No split published."
    },
    full: "Full match",
    first_half: "First half",
    markets: {
      result: "Match result",
      goals: "Goals",
      corners: "Corners",
      btts: "Both teams to score",
      shots: "Shots",
      shots_on_target: "Shots on target",
      cards: "Cards"
    },
    sides: {
      home: "Home win",
      draw: "Draw",
      away: "Away win",
      over: "Over",
      under: "Under",
      yes: "Yes",
      no: "No"
    },
    filters: {
      today: "Today",
      tomorrow: "Tomorrow",
      period: "Time",
      type: "Type",
      all: "All",
      value: "Value",
      probabilitySort: "Probability",
      hitRateSort: "Hits",
      minProbability: "Minimum hit rate / probability",
      minOdds: "Minimum odds",
      probabilityShort: "Hits / prob.",
      oddsShort: "Odds",
      league: "League",
      leagueCount: "All leagues ({{count}})",
      selectedOptions_zero: "{{count}} selected",
      selectedOptions_one: "{{count}} selected",
      selectedOptions_other: "{{count}} selected",
      searchMarkets: "Search markets",
      noMarkets: "No markets found",
      searchLeagues: "Search leagues"
    },
    forTeam: "For {{team}}",
    opponentHistory: "Opponent conceded values: {{team}}",
    historyValues: "Recent match values",
    historicalHits: "Hits",
    hitRate: "Hit rate",
    matchHistory: "Recent match totals: {{team}}",
    warnings: {
      title: "Match warnings",
      viewAll: "View all warnings",
      refereeCards_zero: "Referee: {{average}} yellow + red cards per match ({{sample}} matches). Review this under.",
      refereeCards_one: "Referee: {{average}} yellow + red cards per match ({{sample}} match). Review this under.",
      refereeCards_other: "Referee: {{average}} yellow + red cards per match ({{sample}} matches). Review this under.",
      strongFavorite: "{{team}}: {{probability}} estimated win probability. Review the corner under in this context.",
      neutralVenue: "Neutral venue: home/away history may be less representative.",
      shortRest: "{{team}}: {{hours}} hours between kickoffs.",
      absences_zero: "{{team}}: {{count}} reported absences. Check the lineup.",
      absences_one: "{{team}}: {{count}} reported absence. Check the lineup.",
      absences_other: "{{team}}: {{count}} reported absences. Check the lineup.",
      injury: "Injury report: {{players}}.",
      lineupPending: "Lineup not published yet."
    },
    compareHistory: "Compare historical matches",
    openSample: "Historical sample",
    noComparison: "No historical matches recorded.",
    selection: {
      title: "Selected tickets",
      count_zero: "{{count}} tickets selected",
      count_one: "{{count}} ticket selected",
      count_other: "{{count}} tickets selected",
      limit: "Up to {{limit}} tickets at a time.",
      clear: "Clear selection",
      sameFixture: "Two or more tickets are from the same match. Combining them may not be accepted by the bookmaker.",
      started: "Some selected matches have already started. Remove them before recording."
    }
  },
  ticket: {
    title: "Pick Pro",
    filters: "Filters",
    summary: "Ticket summary",
    summaryToggle: "Show ticket details",
    games: "Number of games",
    gamesHint: "More selections increase combined odds and reduce the chance of winning.",
    increase: "Increase games",
    decrease: "Decrease games",
    window: "Time window",
    windowHint: "Only matches starting within this interval are considered.",
    hours: "{{count}}h",
    markets: "Markets",
    playerMarkets: "Player props",
    all: "All",
    none: "None",
    invert: "Invert",
    minProbability: "Minimum probability (%)",
    minOdds: "Minimum odds",
    generate: "Generate ticket",
    ready: "Your ticket",
    selectionCount: "{{selected}} / {{requested}} selections",
    available: "Selections use available prices and positive model value. One selection per match.",
    empty: "No selections available",
    emptyHint: "Try a longer time window or different markets.",
    hiddenByFilters_zero: "{{count}} selections are hidden by your minimum probability, odds, market or period filters. Loosen them to see them.",
    hiddenByFilters_one: "{{count}} selection is hidden by your minimum probability, odds, market or period filters. Loosen them to see it.",
    hiddenByFilters_other: "{{count}} selections are hidden by your minimum probability, odds, market or period filters. Loosen them to see them.",
    shortfall: "There are not enough qualifying matches to complete your ticket.",
    stake: "Stake",
    increaseStake: "Increase stake by {{amount}}",
    decreaseStake: "Decrease stake by {{amount}}",
    totalOdds: "Total odds",
    return: "Potential return",
    lock: "Lock selection",
    unlock: "Unlock selection",
    replace: "Replace selection",
    save: "Save ticket",
    saved: "Changes saved to your account.",
    saveError: "Unable to save changes. Check your connection and try again.",
    savedTitle: "Saved tickets",
    inTicket: "Games in ticket",
    twoDays: "2 days",
    criterion: "Criterion",
    criterionHint: "Statistics for the home or away team, or for the full match.",
    byTeam: "By team",
    byMatch: "By match",
    selectedTeam: "Team: {{team}}",
    playerPickSuffix: "\u2013 {{side}} {{line}}",
    playerMarket: "{{metric}}",
    historySample: "Historical sample: {{hits}}/{{total}}",
    historicalEstimate: "Historical estimate",
    teamAvailable: "Team totals with fresh odds and a historical home or away estimate. One selection per match.",
    accountSync: "Synced with your account. Pending results are checked automatically every minute after matches finish. Missing data stays pending. You can also check results or correct a selection manually.",
    ticketName: "Ticket name",
    selectionResult: "Selection result",
    removeSelection: "Remove selection",
    saveChanges: "Save changes",
    cancel: "Cancel",
    profit: "Profit",
    edit: "Edit",
    checkResults: "Check results",
    delete: "Delete",
    noSaved: "No saved tickets.",
    importLocal_zero: "Import {{count}} tickets from this browser",
    importLocal_one: "Import {{count}} ticket from this browser",
    importLocal_other: "Import {{count}} tickets from this browser",
    previous: "Previous",
    next: "Next",
    period: "Period",
    secondHalf: "Second half",
    combinedEdge: "Combined estimated edge",
    risk: "Estimated risk",
    indicatorHint: "Assumes independent matches. Low: at least 65% estimated chance of all selections winning; medium: 35\u201365%; high: below 35%. Historical estimates are not calibrated predictions.",
    previousOdds: "Previous odds",
    generation: {
      changed: "Alternative ticket generated.",
      unchanged: "No alternative selections satisfy your filters and locks."
    },
    movement: {
      unknown: "No previous price",
      stable: "Odds stable",
      up: "Odds increased",
      down: "Odds decreased"
    },
    riskLevels: {
      unknown: "\u2014",
      low: "Low",
      medium: "Medium",
      high: "High"
    },
    results: {
      pending: "Pending",
      won: "Won",
      lost: "Lost",
      void: "Void",
      halfWon: "Half won",
      halfLost: "Half lost"
    },
    marketNames: {
      cards: "Cards",
      shots: "Shots",
      shots_on_target: "Shots on target",
      points: "Points",
      runs: "Runs",
      moneyline: "Winner",
      spread: "Handicap"
    },
    refresh: "Refresh",
    lastRefreshed: "Last refreshed: {{time}}",
    staleData: "This list was last refreshed over 5 minutes ago. Refresh before sending to a bankroll.",
    stalePrices: "Some selected prices are over 5 minutes old. Refresh and check the bookmaker before recording."
  },
  study: {
    title: "Saved picks",
    subtitle: "Your saved picks, ready to revisit.",
    sendToBankroll: "Send to bankroll",
    oddsFor: "Odds: {{match}}",
    decimalOddsFor: "Decimal odds: {{selection}}",
    invalidStake: "Enter a stake between 0.01 and 1,000,000.",
    invalidOdds: "Enter decimal odds above 1 and up to 1000.",
    remove: "Remove selection",
    accumulator: "Accumulator ticket",
    accumulatorHint: "One stake for all selections. One losing leg loses the ticket.",
    singlesHint: "The entered stake applies to each single bet.",
    bankroll: "Bankroll",
    chooseBankroll: "Choose a bankroll",
    newBankroll: "New bankroll",
    stake: "Stake (BRL)",
    bookmaker: "Bookmaker",
    totalStake: "Total stake",
    combinedOdds: "Combined odds",
    noSelections: "Select at least one line.",
    invalidOpeningBalance: "Enter an opening balance between 0 and 10,000,000,000.",
    saveError: "Could not save. Check the values and the balance, then try again.",
    loadError: "Could not load your data.",
    recordBets: "Record bets",
    bankrollName: "Bankroll name",
    save: "Save",
    transactions: "Transactions",
    restore: "Restore",
    archive: "Archive",
    openingBalance: "Opening balance (BRL)",
    createBankroll: "Create bankroll",
    editBankroll: "Edit bankroll",
    adjustBalance: "Adjust balance",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    adjustmentAmount: "Amount (BRL)",
    applyAdjustment: "Apply",
    insufficientBalance: "Amount above the current balance.",
    archivedAdjustmentHint: "Restore this bankroll to adjust its balance.",
    selectionActions: "Selection actions",
    saved: "Saved",
    alreadyBet: "Already bet",
    alreadyBetOne: "{{bankroll}} \xB7 {{amount}}",
    alreadyBetMany: "{{count}} bets \xB7 {{amount}}",
    saveSelection: "Save ticket",
    removeFromNotebook: "Remove from saved picks",
    recorded: "Bets recorded",
    selectLine: "Select {{match}}: {{line}}",
    grouping: "Group selections",
    byGame: "By game",
    byMarket: "By market",
    search: "Filter by team, league or market",
    cancel: "Cancel",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    clearAll: "Clear all",
    empty: "No saved picks match these filters. Save picks from Radar or Pick Pro.",
    selectionCount_zero: "{{count}} selections",
    selectionCount_one: "{{count}} selection",
    selectionCount_other: "{{count}} selections",
    sendTicket: "Send ticket",
    previousTickets: "Previously saved tickets",
    clearHint: "Remove every saved pick? Recorded bets and bankrolls are kept.",
    oneSportHint: "A ticket holds selections from a single sport.",
    confirmClear: "Clear saved picks",
    betDetails: "Bet details and results",
    chooseBet: "Choose a bet",
    manualHint: "Saving results makes this bet manual. You can check recorded match results whenever needed.",
    needsReview: "Needs your result",
    needsReviewHint: "This match has ended but the result for one of the selections is not available from our data provider. Set it manually below.",
    profitEvolution: "Profit evolution",
    settlementBasis: "Results by settlement date",
    noResolved: "No settled bets in this period.",
    cumulativeProfit: "Cumulative profit",
    market: "Market",
    allMarkets: "All markets",
    filters: "Filters",
    from: "From",
    to: "To",
    profit: "Profit",
    roi: "Return on investment",
    hitRate: "Win rate",
    pending: "Pending bets",
    bankrolls: "Bankrolls",
    noBankrolls: "Create a bankroll to start tracking bets.",
    noPending: "No pending bets.",
    betHistory: "Settled bets",
    transactionKinds: {
      opening: "Opening balance",
      stake: "Stake",
      return: "Return",
      correction: "Correction",
      deposit: "Deposit",
      withdrawal: "Withdrawal"
    },
    bankrollSubtitle: "Manage your bankrolls and track each bet.",
    archived: "Archived",
    currentBalance: "Current balance",
    separateMatches: "Accumulators require different matches. Use singles for multiple lines from one match.",
    betSummary: {
      title: "Bet summary",
      return: "Return received",
      netProfit: "Net profit",
      returnHint: "Return includes your stake. Net profit is the return minus your stake.",
      settledAt: "Settled at"
    },
    deleteBet: "Delete bet",
    deleteBetPending: "{{stake}} goes back to {{bankroll}}.",
    deleteBetSettled: "{{stake}} goes back to {{bankroll}} and its {{payout}} return is removed.",
    deleteBetStats: "It also leaves your performance stats.",
    deleteError: "Could not delete this bet. Try again.",
    yourBankroll: "your bankroll"
  },
  bets: {
    title: "Bets",
    tabs: {
      live: "Live",
      upcoming: "Upcoming",
      settled: "Settled",
      performance: "Performance"
    },
    performance: {
      sport: "Sport",
      updated: "Updated",
      profit: "Profit",
      resolvedStake: "Settled stake",
      roi: "Return on investment",
      roiHint: "Profit / settled stake, excluding void bets",
      hitRate: "Win rate",
      resolvedCount_zero: "{{count}} settled bets",
      resolvedCount_one: "{{count}} settled bet",
      resolvedCount_other: "{{count}} settled bets",
      pending: "Pending bets",
      currentRisk: "Current stake at risk",
      live: "Live",
      liveHint: "Live matches in pending bets",
      loadError: "Could not load your results.",
      invalidRange: "Choose a valid date range.",
      noSports: "No sport on your plan yet.",
      ranges: {
        "1": "Today",
        "7": "7 days",
        "30": "30 days",
        month: "Month",
        all: "All time",
        custom: "Custom"
      }
    },
    awaiting: "Awaiting result",
    needsReview: "Needs your result",
    empty: {
      live: "No bets in play right now.",
      upcoming: "No upcoming bets.",
      settled: "No settled bets yet."
    },
    stake: "Stake",
    totalOdds: "Total odds",
    potentialReturn: "Potential return",
    return: "Return",
    profit: "Profit",
    modes: {
      singles: "Single",
      accumulator: "Accumulator"
    },
    progress: "{{current}} of {{line}}",
    marketPeriod: "{{market}}, {{period}}",
    pendingTrend: "Pending, {{result}} so far",
    viewAll: "View all bets",
    collapseAll: "Collapse all",
    expandAll: "Expand all",
    legCount_zero: "{{count}} selections",
    legCount_one: "{{count}} selection",
    legCount_other: "{{count}} selections",
    editBetLabel: "Edit bet: {{bet}}",
    deleteBetLabel: "Delete bet: {{bet}}"
  },
  matchContext: {
    updated: "Context updated: {{time}}",
    stale: "This match context may be outdated.",
    conditions: "Match conditions",
    neutralVenue: "Neutral venue",
    humidity: "Humidity: {{value}}%",
    forecast: "Forecast",
    formation: "Formation",
    coach: "Coach",
    rest: "{{hours}} hours between this kickoff and the previous match",
    schedule_zero: "{{count}} completed matches in the previous 7 days",
    schedule_one: "{{count}} completed match in the previous 7 days",
    schedule_other: "{{count}} completed matches in the previous 7 days",
    lineup: {
      confirmed: "Confirmed lineup",
      expected: "Expected lineup",
      unconfirmed: "Lineup not confirmed"
    },
    bench: "Bench",
    absences: "Reported absences",
    reasons: {
      injury: "Injury",
      suspension: "Suspension",
      unavailable: "Unavailable"
    },
    probabilities: "Pre-match result probabilities",
    liveProbabilities: "Live win probabilities at minute {{minute}}",
    expectedGoals: "Recorded expected goals (xG)",
    pressure: "Match pressure",
    period: "Period {{number}}",
    events: "Match events",
    event: {
      goal: "Goal",
      ownGoal: "Own goal",
      penalty: "Penalty goal",
      missedPenalty: "Missed penalty",
      yellowCard: "Yellow card",
      redCard: "Red card",
      substitution: "Substitution",
      var: "VAR review",
      varCard: "Card after VAR"
    },
    trends: "Match trends",
    seriesTeam: "Match trend for {{team}}"
  }
};

// src/locales/en/email.json
var email_default = {
  footer: "Pick Pro is an independent sports research service. It does not accept bets.",
  verifyEmail: {
    subject: "Confirm your Pick Pro email",
    greeting: "Hello,",
    body: "Confirm your email address to activate your Pick Pro account.",
    action: "Confirm email",
    expiry: "This link expires in 24 hours.",
    ignore: "If you did not create an account, you can ignore this email."
  },
  resetPassword: {
    subject: "Reset your Pick Pro password",
    greeting: "Hello,",
    body: "We received a request to reset the password of your Pick Pro account.",
    action: "Choose a new password",
    expiry: "This link expires in 1 hour.",
    ignore: "If you did not request this, you can ignore this email and your password stays the same."
  },
  passwordChanged: {
    subject: "Your Pick Pro password was changed",
    greeting: "Hello,",
    body: "The password of your Pick Pro account was changed and every other session was signed out.",
    action: "Open Pick Pro",
    ignore: "If this was not you, reset your password right away from the sign-in page."
  }
};

// src/locales/es/common.json
var common_default2 = {
  theme: {
    switchToLight: "Activar modo claro",
    switchToDark: "Activar modo oscuro"
  },
  live: {
    opportunitiesChanged: "Las oportunidades cambiaron. Revisa tus selecciones y cuotas antes de guardar.",
    reconnecting: "Las actualizaciones en tiempo real no est\xE1n disponibles temporalmente. Los datos se actualizan autom\xE1ticamente mientras nos reconectamos."
  },
  app: {
    name: "Pick Pro"
  },
  nav: {
    matches: "Partidos",
    language: "Idioma",
    mainLabel: "Principal",
    myLabel: "Guardados",
    primaryAction: "Empieza gratis",
    settings: "Configuraci\xF3n",
    signIn: "Entrar",
    signOut: "Cerrar sesi\xF3n",
    signUp: "Crear cuenta",
    pricing: "Planes",
    account: "Cuenta",
    admin: "Admin",
    sports: "Deportes",
    openNavigation: "Abrir navegaci\xF3n",
    closeNavigation: "Cerrar navegaci\xF3n",
    sport: "Deporte",
    overview: "Hoy",
    search: "Buscar",
    competitions: "Competiciones",
    teams: "Equipos",
    players: "Jugadores",
    radar: "Radar",
    "ticket-generator": "Pick Pro",
    bets: "Apuestas"
  },
  common: {
    loading: "Cargando",
    retry: "Reintentar",
    empty: "Nada que mostrar todav\xEDa",
    error: "La p\xE1gina no se carg\xF3.",
    previousMonth: "Mes anterior",
    nextMonth: "Mes siguiente",
    loadMore: "Cargar m\xE1s",
    close: "Cerrar",
    required: "Obligatorio"
  },
  errors: {
    internal: "Error inesperado",
    notFound: "No encontrado",
    notFoundDescription: "La direcci\xF3n no corresponde a ninguna p\xE1gina.",
    validation: "Algunos campos no son v\xE1lidos",
    unauthorized: "Inicia sesi\xF3n para continuar",
    forbidden: "No tienes acceso a esto",
    rateLimited: "Demasiados intentos, vuelve a probar en un momento",
    network: "No se pudo contactar con el servidor"
  },
  auth: {
    invalidCredentials: "Correo o contrase\xF1a incorrectos",
    emailNotVerified: "Confirma tu correo antes de iniciar sesi\xF3n",
    invalidToken: "Este enlace no es v\xE1lido o ha caducado",
    sportLocked: "Este deporte a\xFAn no est\xE1 habilitado en tu cuenta",
    fields: {
      email: "Correo",
      password: "Contrase\xF1a",
      newPassword: "Nueva contrase\xF1a",
      currentPassword: "Contrase\xF1a actual",
      confirmPassword: "Confirmar contrase\xF1a",
      passwordHint: "Al menos 10 caracteres",
      firstName: "Nombre",
      lastName: "Apellidos"
    },
    validation: {
      email: "Introduce un correo v\xE1lido",
      passwordLength: "Usa al menos 10 caracteres",
      passwordTooLong: "Usa una contrase\xF1a m\xE1s corta",
      passwordMatch: "Las contrase\xF1as no coinciden",
      required: "Obligatorio",
      nameLength: "Introduce de 1 a 100 caracteres"
    },
    signUp: {
      title: "Crea tu cuenta",
      description: "La investigaci\xF3n empieza con una cuenta. Tus primeros {{freeScans}} an\xE1lisis son gratis; despu\xE9s, cada deporte se habilita con su plan.",
      submit: "Crear cuenta",
      haveAccount: "\xBFYa tienes una cuenta?",
      sentTitle: "Revisa tu correo",
      sentDescription: "Enviamos un enlace de confirmaci\xF3n a {{email}}. \xC1brelo para activar tu cuenta.",
      resend: "Enviar el enlace de nuevo",
      resent: "Un nuevo enlace va en camino."
    },
    verify: {
      title: "Confirmando tu correo",
      success: "Tu correo est\xE1 confirmado. Ya puedes iniciar sesi\xF3n.",
      missing: "Esta p\xE1gina necesita el enlace de tu correo de confirmaci\xF3n.",
      resendPrompt: "Introduce tu correo para recibir un nuevo enlace."
    },
    signIn: {
      title: "Iniciar sesi\xF3n",
      description: "Bienvenido de nuevo.",
      submit: "Iniciar sesi\xF3n",
      forgot: "\xBFOlvidaste tu contrase\xF1a?",
      noAccount: "\xBFEres nuevo?",
      unverifiedHelp: "\xBFNecesitas un nuevo enlace de confirmaci\xF3n?"
    },
    forgot: {
      title: "Restablecer tu contrase\xF1a",
      description: "Introduce tu correo y te enviaremos un enlace para elegir una nueva contrase\xF1a.",
      submit: "Enviar enlace",
      sent: "Si existe una cuenta para {{email}}, un enlace de restablecimiento va en camino.",
      back: "Volver a iniciar sesi\xF3n"
    },
    reset: {
      title: "Elige una nueva contrase\xF1a",
      submit: "Guardar nueva contrase\xF1a",
      success: "Tu contrase\xF1a est\xE1 actualizada. Inicia sesi\xF3n con la nueva.",
      missing: "Esta p\xE1gina necesita el enlace de tu correo de restablecimiento."
    }
  },
  access: {
    title: "Tu cuenta est\xE1 lista",
    description: "Cada deporte de tu cuenta se habilita con su plan. Podr\xE1s investigar en cuanto se habilite un deporte.",
    sportsTitle: "Deportes en tu cuenta",
    granted: "Habilitado",
    pending: "Pendiente",
    pricingLink: "Ver los planes",
    contact: "\xBFDudas? Escribe a {{email}}.",
    inactive: "Tu cuenta est\xE1 inactiva. Contacta con soporte para recuperar el acceso."
  },
  sports: {
    football: "F\xFAtbol",
    nba: "NBA",
    nfl: "NFL",
    mlb: "MLB"
  },
  overview: {
    firstMatchOn: "Primer partido el {{date}}",
    lastMatchOn: "\xDAltimo partido el {{date}}"
  },
  today: {
    title: "Hoy",
    datePattern: "dddd, D [de] MMMM",
    summary: "{{date}}, {{live}} y {{upcoming}}",
    summaryQuiet: "{{date}}, sin partidos",
    liveCount_zero: "{{count}} en vivo",
    liveCount_one: "{{count}} en vivo",
    liveCount_other: "{{count}} en vivo",
    upcomingCount_zero: "{{count}} por jugar",
    upcomingCount_one: "{{count}} por jugar",
    upcomingCount_other: "{{count}} por jugar",
    openRadar: "Abrir Radar",
    openPickPro: "Pick Pro",
    liveMatches: "Partidos en vivo",
    nextKickoff: "Pr\xF3ximo partido",
    kickingOff: "Comenzando",
    countdownHours: "{{hours}}h {{minutes}}min",
    countdownMinutes: "{{minutes}} min",
    nextMatchday: "Pr\xF3xima jornada",
    nextMatchdayCount_zero: "{{count}} partidos el {{date}}",
    nextMatchdayCount_one: "{{count}} partido el {{date}}",
    nextMatchdayCount_other: "{{count}} partidos el {{date}}",
    nextUp: "A continuaci\xF3n",
    allOnMatches: "Los {{count}} en Partidos",
    favouriteCompetition: "Competici\xF3n favorita",
    phase: {
      off_season: "La temporada termin\xF3. El Radar sigue trabajando con las \xFAltimas jornadas.",
      pre_season: "La temporada empieza pronto.",
      in_season: "No hay partidos programados."
    },
    loadError: "No se pudieron cargar los partidos de hoy.",
    strip: {
      title: "Este mes",
      profit: "Ganancia",
      roi: "ROI",
      open: "Abiertas",
      openDetail_zero: "{{count}} apuestas, {{amount}} en riesgo",
      openDetail_one: "{{count}} apuesta, {{amount}} en riesgo",
      openDetail_other: "{{count}} apuestas, {{amount}} en riesgo",
      bankroll: "Banca",
      noBankroll: "Sin banca",
      noSettled: "A\xFAn no hay apuestas liquidadas este mes.",
      loadError: "No se pudieron cargar los resultados del mes.",
      bankrollError: "No se pudieron cargar tus bancas."
    },
    plan: {
      title: "Tu plan",
      status: "Estado",
      active: "Plan activo",
      inactive: "Plan inactivo",
      sports: "Deportes",
      manage: "Gestionar en Acceso"
    }
  },
  competitions: {
    search: "Buscar competiciones",
    results: "{{visible}} de {{total}} competiciones",
    noResults: "No se encontraron competiciones",
    noResultsDescription: "Prueba con otro nombre de competici\xF3n o borra la b\xFAsqueda.",
    clearSearch: "Borrar b\xFAsqueda",
    title: "Competiciones",
    seasons: "Temporadas",
    standings: "Clasificaci\xF3n",
    season: "Temporada",
    noStandings: "Todav\xEDa no hay clasificaci\xF3n para esta temporada.",
    columns: {
      rank: "Posici\xF3n",
      team: "Equipo",
      played: "Jugados",
      won: "Ganados",
      drawn: "Empatados",
      lost: "Perdidos",
      scored: "A favor",
      conceded: "En contra",
      goalDifference: "DG",
      points: "Puntos",
      record: "V-D",
      pct: "PCT"
    }
  },
  search: {
    title: "Buscar",
    resultsFor: 'Resultados para "{{query}}"',
    noResults: "No hay resultados para esta b\xFAsqueda.",
    seeAll: "Ver todos",
    competitions: "Competiciones",
    teams: "Equipos",
    players: "Jugadores"
  },
  metrics: {
    points: "Puntos",
    runs: "Carreras",
    hits: "Hits",
    errors: "Errores",
    goals: "Goles",
    corners: "C\xF3rners",
    cards: "Tarjetas",
    shots: "Remates",
    shots_on_target: "Remates a puerta",
    shots_off_target: "Remates fuera",
    shots_inside_box: "Remates dentro del \xE1rea",
    shots_outside_box: "Remates fuera del \xE1rea",
    shots_blocked: "Remates bloqueados",
    attacks: "Ataques",
    dangerous_attacks: "Ataques peligrosos",
    passes: "Pases",
    accurate_passes: "Pases acertados",
    tackles: "Entradas",
    interceptions: "Intercepciones",
    crosses: "Centros",
    accurate_crosses: "Centros acertados",
    big_chances_created: "Ocasiones claras creadas",
    key_passes: "Pases clave",
    dribbles: "Regates completados",
    duels_won: "Duelos ganados",
    clearances: "Despejes",
    touches: "Toques",
    rating: "Puntuaci\xF3n",
    minutes: "Minutos",
    fouls: "Faltas",
    yellow_cards: "Tarjetas amarillas",
    red_cards: "Tarjetas rojas",
    offsides: "Fueras de juego",
    saves: "Atajadas",
    possession: "Posesi\xF3n",
    rebounds: "Rebotes",
    offensive_rebounds: "Rebotes ofensivos",
    defensive_rebounds: "Rebotes defensivos",
    assists: "Asistencias",
    steals: "Robos",
    blocks: "Tapones",
    turnovers: "P\xE9rdidas",
    field_goals_made: "Tiros de campo anotados",
    field_goals_attempted: "Tiros de campo intentados",
    three_pointers_made: "Triples anotados",
    three_pointers_attempted: "Triples intentados",
    free_throws_made: "Tiros libres anotados",
    free_throws_attempted: "Tiros libres intentados",
    plus_minus: "M\xE1s/menos",
    total_yards: "Yardas totales",
    passing_yards: "Yardas por pase",
    rushing_yards: "Yardas por tierra",
    passing_attempts: "Pases intentados",
    passing_completions: "Pases completos",
    rushing_attempts: "Acarreos",
    first_downs: "Primeros downs",
    first_downs_passing: "Primeros downs por pase",
    first_downs_rushing: "Primeros downs por tierra",
    first_downs_penalty: "Primeros downs por castigo",
    third_down_conversions: "Terceros downs convertidos",
    third_down_attempts: "Terceros downs intentados",
    fourth_down_conversions: "Cuartos downs convertidos",
    fourth_down_attempts: "Cuartos downs intentados",
    red_zone_scores: "Anotaciones en zona roja",
    red_zone_attempts: "Visitas a zona roja",
    interceptions_thrown: "Pases interceptados",
    fumbles_lost: "Balones sueltos perdidos",
    penalties: "Castigos",
    penalty_yards: "Yardas por castigo",
    sacks: "Capturas",
    sack_yards_lost: "Yardas perdidas en capturas",
    total_offensive_plays: "Jugadas ofensivas",
    total_drives: "Series ofensivas",
    possession_time_seconds: "Tiempo de posesi\xF3n",
    defensive_touchdowns: "Touchdowns defensivos",
    yards_per_play: "Yardas por jugada",
    yards_per_pass: "Yardas por pase",
    yards_per_rush_attempt: "Yardas por acarreo",
    passing_touchdowns: "Touchdowns de pase",
    passing_interceptions: "Pases interceptados",
    rushing_touchdowns: "Touchdowns por tierra",
    receiving_yards: "Yardas por recepci\xF3n",
    receiving_touchdowns: "Touchdowns por recepci\xF3n",
    receptions: "Recepciones",
    receiving_targets: "Env\xEDos",
    total_tackles: "Tacleadas totales",
    solo_tackles: "Tacleadas en solitario",
    defensive_sacks: "Capturas",
    defensive_interceptions: "Intercepciones",
    at_bats: "Turnos al bate",
    rbi: "Carreras impulsadas",
    home_runs: "Jonrones",
    walks: "Bases por bolas",
    strikeouts: "Ponches",
    doubles: "Dobles",
    triples: "Triples",
    stolen_bases: "Bases robadas",
    batting_average: "Promedio de bateo",
    on_base_percentage: "Porcentaje de embasado",
    slugging: "Slugging",
    innings_pitched: "Entradas lanzadas",
    earned_run_average: "ERA",
    pitching_strikeouts: "Ponches propinados",
    pitching_walks: "Bases por bolas otorgadas",
    fouls_drawn: "Faltas recibidas",
    aerials_won: "Duelos a\xE9reos ganados",
    usage_percentage: "Porcentaje de uso",
    true_shooting_percentage: "Porcentaje de tiro verdadero",
    effective_field_goal_percentage: "Porcentaje efectivo de campo",
    offensive_rating: "Eficiencia ofensiva",
    defensive_rating: "Eficiencia defensiva",
    net_rating: "Eficiencia neta",
    pace: "Ritmo",
    pie: "Impacto del jugador",
    plate_appearances: "Apariciones al plato",
    total_bases: "Bases totales",
    pitches_thrown: "Lanzamientos realizados",
    points_rebounds_assists: "Puntos + rebotes + asistencias",
    points_rebounds: "Puntos + rebotes",
    points_assists: "Puntos + asistencias",
    rebounds_assists: "Rebotes + asistencias",
    double_double: "Doble-doble",
    triple_double: "Triple-doble",
    anytime_touchdown: "Touchdown en cualquier momento",
    first_touchdown: "Primer touchdown",
    rushing_receiving_yards: "Yardas por tierra + recepci\xF3n",
    longest_reception: "Recepci\xF3n m\xE1s larga",
    longest_rush: "Carrera m\xE1s larga",
    longest_pass: "Pase m\xE1s largo",
    kicking_points: "Puntos de pateo",
    singles: "Sencillos",
    extra_base_hits: "Hits de extrabase",
    hits_runs_rbis: "Hits + carreras + carreras impulsadas",
    runs_rbis: "Carreras + carreras impulsadas",
    hits_stolen_bases: "Hits + bases robadas",
    hits_runs_stolen_bases: "Hits + carreras + bases robadas",
    hits_walks_stolen_bases: "Hits + bases por bolas + bases robadas",
    pitcher_outs: "Outs registrados",
    pitcher_earned_runs: "Carreras limpias permitidas",
    pitcher_hits_allowed: "Hits permitidos",
    pitcher_hits_walks_earned_runs: "Hits + bases por bolas + carreras limpias permitidas",
    pitcher_win: "Victoria del lanzador",
    first_home_run: "Primer jonr\xF3n",
    touchdowns: "Touchdowns de carrera + recepci\xF3n",
    hit_woodwork: "Tiros al palo",
    big_chances_missed: "Grandes ocasiones falladas",
    tackles_won: "Entradas ganadas",
    throw_ins: "Saques de banda",
    goal_kicks: "Saques de puerta",
    free_kicks: "Tiros libres",
    long_passes: "Pases largos",
    xg: "Goles esperados (xG)",
    goals_0_15: "Goles 0-15 min",
    goals_15_30: "Goles 15-30 min",
    goals_30_45: "Goles 30-45 min",
    goals_45_60: "Goles 45-60 min",
    goals_60_75: "Goles 60-75 min",
    goals_75_90: "Goles 75-90 min",
    blocked_shots: "Tiros bloqueados",
    dispossessed: "Despose\xEDdo",
    duels: "Duelos",
    penalties_committed: "Penaltis cometidos",
    goals_conceded: "Goles recibidos",
    own_goals: "Goles en propia puerta",
    penalty_kicks: "Penaltis"
  },
  oddsFormats: {
    decimal: "Decimal (1,85)",
    fractional: "Fraccionaria (17/20)",
    american: "Americana (-118)"
  },
  settings: {
    title: "Configuraci\xF3n",
    preferences: {
      title: "Preferencias",
      locale: "Idioma",
      timezone: "Zona horaria",
      defaultSport: "Deporte predeterminado",
      noDefaultSport: "Primer deporte habilitado",
      oddsFormat: "Formato de cuotas",
      save: "Guardar preferencias",
      saved: "Preferencias guardadas."
    },
    password: {
      title: "Contrase\xF1a",
      description: "Cambiar la contrase\xF1a cierra la sesi\xF3n en todos los dem\xE1s dispositivos.",
      save: "Cambiar contrase\xF1a",
      saved: "Contrase\xF1a cambiada. Se cerraron las dem\xE1s sesiones."
    },
    delete: {
      title: "Eliminar cuenta",
      description: "Esto elimina tu cuenta y todo lo asociado a ella. No se puede deshacer.",
      confirmLabel: "Escribe {{word}} para confirmar",
      submit: "Eliminar mi cuenta",
      cancel: "Cancelar",
      mismatch: "Escribe la palabra de confirmaci\xF3n exactamente"
    }
  },
  admin: {
    users: {
      title: "Usuarios",
      search: "Buscar por correo",
      email: "Correo",
      status: "Acceso de la cuenta",
      sports: "Deportes",
      verified: "Verificado",
      unverified: "Sin verificar",
      firstGranted: "Primera concesi\xF3n",
      view: "Ver",
      empty: "Ning\xFAn usuario coincide.",
      saved: "Guardado",
      statuses: {
        beta: "Habilitado",
        active: "Habilitado",
        inactive: "Deshabilitado"
      }
    },
    navigation: {
      title: "Administraci\xF3n",
      overview: "Resumen",
      ingestion: "Ingesta"
    },
    overview: {
      description: "Gestiona cuentas, revisa accesos y sigue los nuevos registros.",
      manageUsers: "Gestionar usuarios",
      totalUsers: "Total de usuarios",
      verifiedUsers: "Cuentas verificadas",
      adminUsers: "Administradores",
      usersWithAccess: "Usuarios con acceso",
      planStatuses: "Estado del plan",
      sportAccess: "Acceso por deporte",
      accessDescription: "Incluye administradores. Se excluyen los permisos vencidos y las cuentas de miembros inactivas.",
      recentUsers: "Cuentas recientes",
      review: "Requiere atenci\xF3n",
      awaiting: "Pendiente de verificaci\xF3n",
      disabled: "Cuentas deshabilitadas",
      created: "Registro",
      accessNote: "Las cuentas habilitadas a\xFAn necesitan un permiso por deporte. Los administradores tienen acceso a todos los deportes."
    },
    filters: {
      role: "Rol",
      planStatus: "Filtrar por estado del plan",
      verified: "Verificaci\xF3n de correo",
      sport: "Acceso al deporte",
      all: "Todos",
      user: "Usuario",
      admin: "Administrador",
      true: "Verificado",
      false: "Sin verificar",
      enabled: "Filtrar por acceso de la cuenta"
    },
    details: {
      back: "Volver a usuarios",
      account: "Cuenta",
      created: "Creada",
      activeSessions: "Sesiones activas",
      grants: "Permisos registrados",
      noGrants: "No hay permisos registrados.",
      expires: "Vence",
      noExpiry: "Sin vencimiento",
      grantedBy: "Concedido por",
      viewGrantor: "Ver administrador",
      enableAccount: "Habilitar cuenta",
      disableAccount: "Deshabilitar cuenta"
    },
    ingestion: {
      description: "Sigue la cola del proveedor, los feeds en vivo y lo que ya est\xE1 almacenado.",
      refresh: "Actualizar",
      sport: "Diagn\xF3stico del deporte",
      approximate: "Recuentos aproximados seg\xFAn las estad\xEDsticas del planificador",
      outbox: "Cola de proyecci\xF3n",
      counts: {
        records: "Registros",
        versions: "Versiones",
        fixtures: "Partidos",
        teamMetrics: "M\xE9tricas de equipo",
        playerMetrics: "M\xE9tricas de jugador",
        quotes: "Cuotas registradas"
      },
      tasks: "Familias de tareas",
      noTasks: "No hay tareas programadas para este deporte.",
      family: "Familia",
      families: {
        leagues: "Ligas",
        seasons: "Temporadas",
        schedules: "Calendarios",
        teams: "Equipos",
        squads: "Plantillas",
        standings: "Clasificaciones",
        "fixture-batches": "Lotes de partidos",
        odds: "Cuotas",
        "live-feeds": "Feeds en vivo",
        games: "Juegos",
        stats: "Estad\xEDsticas",
        "box-scores": "Planillas",
        other: "Otros"
      },
      statuses: {
        pending: "Pendiente",
        running: "En curso",
        complete: "Completada",
        failed: "Fallida",
        retired: "Retirada",
        restricted: "Restringida"
      },
      oldestPending: "Pendiente m\xE1s antigua",
      priority: "prioridad {{priority}}",
      feeds: "Feeds en vivo",
      noFeeds: "No hay feeds en vivo programados para este deporte.",
      endpoint: "Endpoint",
      cadence: "Cadencia",
      completedAgo: "completado hace {{age}}",
      neverCompleted: "Nunca completado",
      match: "Diagn\xF3stico de partido",
      matchDescription: "Pega el id del partido o la URL de la p\xE1gina para ver los datos de investigaci\xF3n almacenados.",
      matchId: "Id o URL del partido",
      inspect: "Inspeccionar",
      invalidId: "Pega el id de un partido o la URL de la p\xE1gina del partido.",
      side: "Local\xEDa",
      team: "Equipo",
      storedFinishedBefore: "Finalizados antes",
      withTeamMetrics: "Con m\xE9tricas de equipo",
      withPlayerMetrics: "Con m\xE9tricas de jugador",
      lastMetric: "\xDAltima m\xE9trica almacenada",
      quotes: "Cuotas registradas",
      pendingBatches: "Lotes de partidos pendientes",
      competition: "Competici\xF3n",
      none: "Ninguna",
      provider: {
        title: "Estado del proveedor",
        description: "Basado en la actividad de ingesta del deporte seleccionado. Actualiza para consultar de nuevo.",
        statuses: {
          healthy: "Correcto",
          issues: "Problemas detectados",
          stale: "Desactualizado",
          unknown: "Sin datos",
          not_configured: "Sin configurar"
        },
        hints: {
          healthy: "Solicitudes recientes correctas, sin tareas fallidas ni restringidas.",
          issues: "Revisa las familias de tareas fallidas y restringidas a continuaci\xF3n. Las solicitudes restringidas pueden requerir cambios de acceso o suscripci\xF3n del proveedor.",
          stale: "Ninguna solicitud correcta en los \xFAltimos 30 minutos. Revisa el worker y el proveedor; la ingesta tambi\xE9n puede estar inactiva.",
          unknown: "Todav\xEDa no se ha registrado ninguna solicitud correcta. Comprueba que la ingesta est\xE9 configurada y en ejecuci\xF3n.",
          not_configured: "El worker inform\xF3 que falta la configuraci\xF3n del proveedor. Revisa sus credenciales."
        },
        counts: "{{failed}} fallidas \xB7 {{restricted}} restringidas \xB7 {{parked}} aparcadas",
        lastSuccess: "\xDAltimo \xE9xito: hace {{age}}",
        lastAttempt: "\xDAltimo intento: hace {{age}}",
        noSuccess: "Ninguna solicitud correcta registrada",
        noAttempt: "Ning\xFAn intento registrado"
      }
    },
    loginHistory: {
      title: "Historial de inicios de sesi\xF3n",
      description: "Inicios de sesi\xF3n correctos, del m\xE1s reciente al m\xE1s antiguo. La ubicaci\xF3n por IP es aproximada y puede indicar una VPN o un proveedor de red. El historial comienza cuando se activa el registro.",
      empty: "No hay inicios de sesi\xF3n registrados.",
      time: "Fecha y hora",
      location: "Ubicaci\xF3n aproximada",
      ip: "Direcci\xF3n IP",
      browser: "Navegador / dispositivo",
      unavailable: "No disponible"
    }
  },
  matches: {
    title: "Partidos",
    locked: "Bloqueado",
    lockedTitle: "Se requiere acceso al deporte",
    lockedDescription: "Tu cuenta no tiene acceso a este deporte. Elige un deporte disponible en el men\xFA.",
    unavailableTitle: "Los datos de partidos a\xFAn no est\xE1n disponibles",
    unavailableDescription: "Tu acceso est\xE1 activo. El calendario y los an\xE1lisis aparecer\xE1n aqu\xED cuando se conecten los datos deportivos.",
    previousDay: "D\xEDa anterior",
    nextDay: "D\xEDa siguiente",
    date: "Fecha",
    today: "Hoy",
    stale: "Las actualizaciones est\xE1n retrasadas. Estos son los \xFAltimos resultados almacenados.",
    empty: "No hay partidos programados para este d\xEDa.",
    loadingSchedule: "Cargando los partidos de este d\xEDa",
    timeUnknown: "Horario por confirmar",
    search: "Buscar por equipo",
    filters: {
      label: "Estado",
      all: "Todos",
      upcoming: "Pr\xF3ximos",
      live: "En vivo",
      finished: "Finalizados"
    },
    allCompetitions: "Todas las competiciones",
    competitions: {
      picker: "Competiciones",
      search: "Buscar competici\xF3n",
      selected_zero: "{{count}} competiciones",
      selected_one: "{{count}} competici\xF3n",
      selected_other: "{{count}} competiciones"
    },
    favourite: "Favorito",
    unfavourite: "Quitar favorito",
    noResults: "Ning\xFAn partido coincide con estos filtros.",
    clearFilters: "Borrar filtros",
    gamesCount_zero: "{{count}} partidos",
    gamesCount_one: "{{count}} partido",
    gamesCount_other: "{{count}} partidos",
    collapseGroup: "Contraer",
    expandGroup: "Expandir",
    statuses: {
      scheduled: "Programado",
      live: "En vivo",
      finished: "Finalizado",
      postponed: "Aplazado",
      cancelled: "Cancelado",
      unknown: "Estado no disponible",
      suspended: "Suspendido",
      delayed: "Retrasado",
      abandoned: "Abandonado",
      awarded: "Adjudicado"
    },
    notFound: "Partido no encontrado",
    backToMatches: "Volver a los partidos",
    venue: "Estadio",
    season: "Temporada",
    roundSuffix: ", jornada {{round}}",
    shootoutScore: "Penales {{home}} \u2013 {{away}}",
    pageTitle: "{{home}} vs. {{away}}",
    kickoff: "Inicio",
    teams: "Equipos",
    team: "Equipo",
    sides: {
      home: "Local",
      draw: "Empate",
      away: "Visitante"
    },
    rankOrdinal: "{{rank}}\xBA",
    form: {
      label: "Forma reciente",
      W: "V",
      D: "E",
      L: "D"
    },
    referee: "\xC1rbitro: {{name}}",
    refereeCards_zero: "{{cards}} tarjetas por partido ({{sample}} partidos)",
    refereeCards_one: "{{cards}} tarjetas por partido ({{sample}} partido)",
    refereeCards_other: "{{cards}} tarjetas por partido ({{sample}} partidos)",
    prices: {
      label: "Precios",
      captured: "capturado el {{time}}"
    },
    total: "Total",
    winner: "Ganador",
    periodScores: "Marcador por periodo",
    overviewPending: {
      title: "Todav\xEDa no hay registros de este partido",
      description: "Las estad\xEDsticas y el marcador por periodo aparecen aqu\xED cuando empiece el juego. La forma reciente y los enfrentamientos anteriores ya est\xE1n en el an\xE1lisis.",
      action: "Abrir el an\xE1lisis"
    },
    openMatch: "{{home}} contra {{away}}",
    liveMinute: "{{minute}}'",
    periods: {
      q1: "Q1",
      q2: "Q2",
      q3: "Q3",
      q4: "Q4",
      ot: "Pr\xF3rroga",
      runs: "Carreras",
      hits: "Hits",
      errors: "Errores",
      full: "Tiempo completo",
      first_half: "1\xAA parte",
      half_time: "Descanso",
      second_half: "2\xAA parte",
      extra_time: "Pr\xF3rroga",
      penalties: "Penales"
    },
    sections: {
      label: "Secciones del partido",
      overview: "Resumen",
      analysis: "An\xE1lisis",
      players: "Jugadores",
      lines: "L\xEDneas"
    },
    markets: {
      fulltime_result: "Resultado final",
      double_chance: "Doble oportunidad",
      draw_no_bet: "Empate anula apuesta",
      match_goals: "Goles m\xE1s/menos",
      goals_over_under: "Goles m\xE1s/menos",
      goal_line: "L\xEDnea de goles",
      asian_handicap: "H\xE1ndicap asi\xE1tico",
      both_teams_to_score: "Ambos marcan",
      half_time_result: "Resultado de la 1\xAA parte",
      "1st_half_goals": "Goles en la 1\xAA parte",
      home_team_goals: "Goles del local",
      away_team_goals: "Goles del visitante",
      corners: "C\xF3rners",
      cards: "Tarjetas"
    },
    lines: {
      disclaimer: "Los precios son de la propia casa de apuestas, capturados en el horario indicado. La frecuencia hist\xF3rica no es una probabilidad.",
      empty: "Todav\xEDa no hay precios de casa de apuestas guardados para este partido.",
      history: "{{hits}} de {{sample}} partidos por encima de la l\xEDnea, hist\xF3rico",
      over: "M\xE1s",
      under: "Menos",
      yes: "S\xED",
      no: "No",
      columns: {
        line: "L\xEDnea",
        side: "Selecci\xF3n",
        price: "Precio",
        opening: "Apertura",
        captured: "Captura",
        history: "Hist\xF3rico"
      }
    },
    players: {
      sample: "Partidos recientes",
      sampleCount_zero: "{{count}} partidos",
      sampleCount_one: "{{count}} partido",
      sampleCount_other: "{{count}} partidos",
      player: "Jugador",
      position: "Posici\xF3n",
      appearances: "Participaciones",
      empty: "Todav\xEDa no hay estad\xEDsticas de jugadores registradas para este partido."
    },
    research: {
      noHistory: "A\xFAn no hay partidos anteriores registrados para estos equipos."
    },
    statistics: {
      lead: "Resultados registrados por m\xE9trica para los filtros seleccionados.",
      sampleFilter: "Partidos recientes",
      sampleOption: "\xDAltimos {{size}} partidos",
      venueFilter: "Casa o visita",
      venues: {
        all: "Casa y visita",
        home: "Solo en casa",
        away: "Solo de visita"
      },
      periodFilter: "Periodo",
      columns: {
        metric: "M\xE9trica",
        mean: "Media",
        variation: "Variaci\xF3n",
        sample: "Muestra",
        values: "Valores recientes"
      },
      sample: "{{sampleSize}} de {{eligible}} partidos",
      sampleWithMissing: "{{sampleSize}} de {{eligible}} partidos, {{missing}} sin esta m\xE9trica",
      empty: "Todav\xEDa no hay estad\xEDsticas de equipo registradas para este deporte.",
      match: {
        title: "Estad\xEDsticas del partido",
        period: "Periodo del partido"
      }
    },
    analysis: {
      loading: "Cargando el an\xE1lisis",
      empty: "No hay partidos registrados para estos filtros.",
      filters: {
        sample: "Muestra",
        sampleOption: "{{size}} partidos",
        venue: "Local\xEDa",
        venues: {
          split: "Casa/Fuera",
          all: "Todos",
          home: "Casa",
          away: "Fuera"
        },
        competition: "Competici\xF3n",
        competitions: {
          all: "Todas"
        }
      },
      groups: {
        label: "Grupos de an\xE1lisis",
        performance: "Rendimiento",
        goals: "Goles",
        timing: "Minutos de gol",
        corners: "C\xF3rners",
        shots: "Remates",
        discipline: "Disciplina",
        odds: "Cuotas",
        head_to_head: "Cara a cara",
        projection: "Proyecci\xF3n",
        scoring: "Anotaci\xF3n",
        team_stats: "Estad\xEDsticas del equipo"
      },
      periods: {
        full: "tiempo completo",
        first_half: "primer tiempo",
        second_half: "segundo tiempo"
      },
      metrics: {
        goals: "goles",
        corners: "c\xF3rners",
        yellow_cards: "tarjetas amarillas",
        points: "puntos",
        runs: "carreras"
      },
      blocks: {
        goalsScored: "Goles marcados",
        goalsConceded: "Goles recibidos",
        goalMarkets: "Tasas de over de goles",
        timingFor: "Goles marcados por minuto",
        timingAgainst: "Goles recibidos por minuto",
        expectedGoals: "Goles esperados",
        cornersFor: "C\xF3rners a favor",
        cornersAgainst: "C\xF3rners en contra",
        cornersTotal: "C\xF3rners del partido",
        cornerMarkets: "Tasas de over de c\xF3rners",
        shots: "Remates",
        efficiency: "Definici\xF3n",
        discipline: "Tarjetas y faltas",
        cardMarkets: "Tasas de over de tarjetas",
        record: "Historial del cruce",
        rates: "Tasas del partido",
        meetings: "Enfrentamientos",
        projection: "Proyecci\xF3n",
        scoringFor: "{{metric}} a favor",
        scoringAgainst: "{{metric}} en contra",
        scoringMarkets: "Tasas de over del total"
      },
      rows: {
        games: "Partidos",
        points: "Puntos",
        pointsRate: "Rendimiento",
        won: "Ganados",
        drawn: "Empatados",
        lost: "Perdidos",
        form: "Forma",
        scoredFirst: "Marc\xF3 primero",
        wonFirstHalf: "Ganando al descanso",
        btts: "Ambos marcan",
        cleanSheet: "Porter\xEDa a cero",
        failedToScore: "No marc\xF3",
        scoreFor: "Puntos a favor",
        scoreAgainst: "Puntos en contra",
        mean: "Media",
        cv: "CV",
        median: "Mediana",
        p75: "P75",
        goalsScored: "Goles marcados, {{period}}",
        goalsConceded: "Goles recibidos, {{period}}",
        over: "Over {{line}} {{metric}}, {{period}}",
        teamOver: "Equipo over {{line}} {{metric}}, {{period}}",
        perGame: "Por partido, {{period}}",
        cornersFor: "C\xF3rners a favor, {{period}}",
        cornersAgainst: "C\xF3rners en contra, {{period}}",
        cornersTotal: "C\xF3rners del partido, {{period}}",
        metricFor: "{{metric}} a favor",
        metricAgainst: "{{metric}} en contra",
        shotsPerGoal: "Remates por gol",
        shotsOnTargetPerGoal: "Remates a puerta por gol",
        conversion: "Conversi\xF3n",
        expectedFor: "Goles esperados a favor",
        expectedAgainst: "Goles esperados en contra",
        draws: "Empates {{drawn}}",
        meanGoals: "Media de goles",
        meanCorners: "Media de c\xF3rners",
        over25: "Over 2.5 goles",
        produced: "Produce",
        opponentConceded: "Rival recibe",
        projection: "Proyecci\xF3n",
        pricedGames: "Partidos con cuota de cierre",
        averagePrice: "Cuota media",
        impliedProbability: "Probabilidad impl\xEDcita",
        winRate: "Tasa de victorias",
        profit: "Ganancia y p\xE9rdida",
        roi: "Retorno de la inversi\xF3n",
        scoringFor: "{{metric}} a favor, {{period}}",
        scoringAgainst: "{{metric}} en contra, {{period}}",
        spreadCover: "Cobertura del h\xE1ndicap",
        totalOver: "Over del total"
      },
      odds: {
        empty: "Las cuotas de cierre existen para partidos desde la temporada 2025-26",
        profitSummary: "Ganancia acumulada en {{count}} partidos con cuota, terminando en {{total}} unidades",
        columns: {
          date: "Fecha",
          opponent: "Rival",
          result: "Resultado",
          price: "Cuota de cierre",
          profit: "Ganancia y p\xE9rdida"
        }
      },
      headToHead: {
        empty: "Sin enfrentamientos en esta muestra",
        columns: {
          date: "Fecha",
          competition: "Competici\xF3n",
          score: "Marcador",
          corners: "C\xF3rners",
          cards: "Tarjetas"
        }
      },
      projection: {
        formula: "Proyecci\xF3n = (producci\xF3n del equipo + goles recibidos del rival) / 2, en la muestra seleccionada"
      }
    }
  },
  teams: {
    latestStanding: "Clasificaci\xF3n m\xE1s reciente",
    viewHistory: "Ver historial de temporadas",
    seasonHistory: "Historial de temporadas",
    historyDescription: "\xDAltima clasificaci\xF3n disponible de cada temporada y grupo.",
    noHistory: "A\xFAn no hay clasificaciones de temporadas disponibles.",
    loaded_zero: "{{formattedCount}} equipos cargados",
    loaded_one: "{{formattedCount}} equipo cargado",
    loaded_other: "{{formattedCount}} equipos cargados",
    clearFilters: "Borrar filtros",
    noResultsDescription: "Prueba con otro nombre de equipo o borra los filtros.",
    title: "Equipos",
    search: "Buscar equipos",
    competition: "Competici\xF3n",
    allCompetitions: "Todas las competiciones",
    empty: "No se encontraron equipos.",
    notFound: "Equipo no encontrado",
    backToTeams: "Volver a los equipos",
    sections: {
      standings: "Clasificaci\xF3n",
      label: "Secciones del equipo",
      overview: "Resumen",
      statistics: "Estad\xEDsticas",
      fixtures: "Partidos",
      players: "Jugadores"
    },
    standing: "Clasificaci\xF3n",
    noStanding: "Todav\xEDa no hay clasificaci\xF3n para este equipo.",
    position: "Posici\xF3n",
    played: "Jugados",
    won: "Ganados",
    drawn: "Empatados",
    lost: "Perdidos",
    points: "Puntos",
    group: "Grupo",
    form: "Forma reciente",
    results: {
      won: "V",
      lost: "D",
      drawn: "E"
    },
    liveMatch: "En vivo ahora",
    nextMatch: "Pr\xF3ximo partido",
    lastMatch: "\xDAltimo partido",
    noNextMatch: "No hay partido programado.",
    noLastMatch: "No hay partido finalizado.",
    season: "Temporada",
    seasonOption: "{{competition}} \xB7 {{season}}",
    noFixtures: "No hay partidos en esta temporada.",
    player: "Jugador",
    appearances: "Participaciones",
    lastPlayed: "\xDAltimo partido jugado",
    noPlayers: "Todav\xEDa no hay jugadores registrados para este equipo.",
    analysis: {
      empty: "Ning\xFAn partido finalizado coincide con estos filtros.",
      competition: "Competici\xF3n",
      allCompetitions: "Todas las competiciones",
      efficiency: "Puntos obtenidos",
      points: "Puntos",
      record: "Historial",
      sample_zero: "{{count}} partidos analizados",
      sample_one: "{{count}} partido analizado",
      sample_other: "{{count}} partidos analizados",
      scoredSample: "Resultados disponibles: {{count}}",
      form: "Forma reciente",
      full: "Partido completo",
      first_half: "Primer tiempo",
      averages: "Promedios por partido",
      for: "A favor",
      against: "En contra",
      total: "Total",
      trend: "Tendencia: \xFAltimos tres partidos comparados con el promedio de la muestra.",
      coverage: "Disponible en {{count}} de {{total}} partidos",
      homeAway: "Local vs visitante",
      home: "Local",
      away: "Visitante",
      frequencies: "Frecuencias hist\xF3ricas",
      markets: "Frecuencias hist\xF3ricas de mercados",
      historicalNote: "Frecuencias hist\xF3ricas, no pron\xF3sticos. Las estad\xEDsticas ausentes se excluyen de cada c\xE1lculo.",
      over: "M\xE1s de {{line}} \xB7 {{metric}}",
      btts: "Ambos marcaron",
      clean_sheet: "Porter\xEDa a cero",
      failed_to_score: "Sin marcar",
      scored_first: "Primero en marcar",
      won_first_half: "Gan\xF3 el primer tiempo",
      recent: "\xDAltimos cinco partidos",
      opponent: "Rival",
      matrix: "Estad\xEDsticas partido a partido",
      indicator: "Indicador",
      mean: "Prom.",
      cv: "CV",
      cvHelp: "El CV mide la variaci\xF3n respecto al promedio; los valores menores indican resultados m\xE1s consistentes.",
      available: "Muestra",
      all: "Todos",
      category: "Categor\xEDa de estad\xEDstica",
      period: "Periodo del partido",
      won: "G",
      drawn: "E",
      lost: "P",
      unknown: "Resultado desconocido",
      score: "Marcador",
      yellowCardsNote: "Los l\xEDmites de tarjetas usan las amarillas de ambos equipos. Las rojas aparecen por separado en Estad\xEDsticas."
    }
  },
  players: {
    title: "Jugadores",
    search: "Buscar jugadores",
    player: "Jugador",
    position: "Posici\xF3n",
    team: "Equipo",
    allTeams: "Todos los equipos",
    searchTeams: "Buscar equipos",
    noTeams: "No se encontraron equipos.",
    empty: "No se encontraron jugadores.",
    notFound: "Jugador no encontrado",
    backToPlayers: "Volver a los jugadores",
    averages: "Promedios",
    sections: {
      label: "Secciones del jugador"
    },
    gameLog: "Historial de partidos",
    formerTeam: "Equipo anterior",
    appearances_zero: "{{appearances}} partidos registrados",
    appearances_one: "{{appearances}} partido registrado",
    appearances_other: "{{appearances}} partidos registrados",
    opponent: "Rival",
    noGames: "Todav\xEDa no hay partidos registrados para este jugador.",
    sample: {
      label: "Partidos recientes",
      option: "\xDAltimos {{size}} partidos",
      all: "Todos los partidos"
    },
    analysis: {
      title: "An\xE1lisis del jugador",
      overview: "Resumen",
      statistics: "Estad\xEDsticas",
      role: "Participaci\xF3n",
      allRoles: "Todas las participaciones",
      starter: "Titular",
      substitute: "Suplente utilizado",
      unknown: "Desconocido",
      minMinutes: "Minutos m\xEDnimos",
      empty: "Ninguna participaci\xF3n coincide con estos filtros.",
      frequencies: "Frecuencias hist\xF3ricas del jugador",
      recent: "Participaciones recientes",
      matrix: "Estad\xEDsticas del jugador por partido",
      per90: "Por 90",
      starts: "Como titular",
      minutes: "Minutos jugados",
      coverage: "Cobertura de datos",
      methodology: "Los valores por 90 usan solo partidos con la estad\xEDstica y los minutos registrados. Los valores ausentes se excluyen. Las frecuencias describen participaciones pasadas, no predicciones.",
      over: "M\xE1s de {{line}} \xB7 {{metric}}",
      all: "Todos",
      attack: "Ataque",
      creation: "Creaci\xF3n",
      defense: "Defensa",
      discipline: "Disciplina",
      goalkeeping: "Porter\xEDa",
      trend: "\xDAltimas 3 vs muestra",
      per36: "Por 36",
      per9: "Por 9 entradas",
      scoring: "Anotaci\xF3n",
      rebounding: "Rebotes",
      advanced: "Avanzadas",
      passing: "Pases",
      rushing: "Carreras",
      receiving: "Recepciones",
      batting: "Bateo",
      pitching: "Lanzamiento",
      batter: "Bateador",
      pitcher: "Lanzador",
      battingOrder: "Orden de bateo",
      sportMethodology: "Las medias y frecuencias hist\xF3ricas excluyen los valores ausentes. Las tasas de NBA usan 36 minutos; las de lanzamiento de MLB usan nueve entradas, solo con partidos que registran la estad\xEDstica y el tiempo jugado. Las frecuencias describen partidos pasados, no predicciones."
    }
  },
  footer: {
    message: "Solo para mayores de 18 a\xF1os. Apuesta con responsabilidad.",
    responsibility: "Las apuestas implican un riesgo financiero real. Nunca apuestes dinero que no puedas permitirte perder.",
    independent: "Pick Pro es un servicio independiente de investigaci\xF3n deportiva. No recibe apuestas, no mantiene dep\xF3sitos para apuestas ni paga premios. Cualquier apuesta se realiza por separado con un operador externo.",
    noIncome: "Apostar no es una inversi\xF3n ni una fuente de ingresos. Las estad\xEDsticas y sugerencias no garantizan retornos. Puedes perder todo el importe apostado.",
    help: "Si las apuestas te est\xE1n afectando, busca apoyo en el SUS de Brasil, en una UBS o CAPS. Tambi\xE9n puedes solicitar la autoexclusi\xF3n de las plataformas autorizadas a nivel federal.",
    resources: "Recursos de juego responsable en Brasil",
    selfExclusion: "Autoexclusi\xF3n \xB7 GOV.BR",
    healthSupport: "Apoyo de salud \xB7 SUS",
    authorized: "Consultar operadores autorizados \xB7 SPA",
    regulation: "Normativa brasile\xF1a de apuestas",
    tagline: "Una visi\xF3n m\xE1s clara del juego. Investigaci\xF3n con contexto, a tu manera.",
    product: "Explora",
    transparency: "Transparencia",
    support: "Apoyo y protecci\xF3n",
    rights: "Todos los derechos reservados."
  },
  landing: {
    meta: {
      title: "Investigaci\xF3n deportiva con cuotas reales",
      description: "Historial de equipos y jugadores junto a las cuotas reales de las casas de apuestas, para f\xFAtbol, NBA, NFL y MLB. Tus primeros {{freeScans}} an\xE1lisis son gratis."
    },
    hero: {
      title: "Investiga el partido. Compara la l\xEDnea. Decide por ti mismo.",
      description: "Historial de equipos y jugadores junto a la cuota real de la casa de apuestas, con la hora en que se captur\xF3. F\xFAtbol, NBA, NFL y MLB.",
      primaryAction: "Empieza con {{freeScans}} an\xE1lisis gratis",
      offer: "Sin tarjeta. Despu\xE9s, {{base}} al mes, cancela cuando quieras.",
      caption: "Flamengo super\xF3 los 9,5 c\xF3rners en {{hits}} de sus \xFAltimos {{known}} partidos. La l\xEDnea ofreci\xF3 {{price}}, capturada antes del inicio. El historial y la l\xEDnea, lado a lado. La decisi\xF3n es tuya.",
      secondaryAction: "C\xF3mo funciona",
      responsibility: "Solo para mayores de 18 a\xF1os. Apostar implica riesgo financiero."
    },
    how: {
      title: "Del partido a una decisi\xF3n informada",
      description: "Sigue las evidencias sin convertir el rendimiento pasado en una predicci\xF3n.",
      steps: {
        research: {
          title: "Analiza el d\xEDa",
          description: "Un an\xE1lisis recorre con Radar o Pick Pro los partidos de un deporte y lista las selecciones con su historial reciente."
        },
        compare: {
          title: "Compara la l\xEDnea real",
          description: "El mercado, la l\xEDnea y la hora de captura van junto al historial."
        },
        track: {
          title: "Guarda y sigue el resultado",
          description: "Las selecciones guardadas y el seguimiento de resultados re\xFAnen todo el ciclo en un solo lugar."
        }
      }
    },
    honesty: {
      title: "El historial sigue siendo historial.",
      description: "Una frecuencia hist\xF3rica describe lo que ocurri\xF3 en una muestra definida y nunca lo que viene despu\xE9s, as\xED que aqu\xED no hay pron\xF3sticos: la lectura y la decisi\xF3n son tuyas."
    },
    faq: {
      title: "La versi\xF3n corta",
      items: {
        bettingSite: {
          question: "\xBFEs este un sitio de apuestas?",
          answer: "No. Es un producto independiente de investigaci\xF3n deportiva. Aqu\xED no puedes realizar apuestas."
        },
        guarantees: {
          question: "\xBFGarantizan resultados?",
          answer: "No. El deporte es incierto, el historial no predice resultados futuros y ning\xFAn resultado est\xE1 garantizado."
        },
        scans: {
          question: "\xBFQu\xE9 cuenta como an\xE1lisis?",
          answer: "Un an\xE1lisis recorre con Radar o Pick Pro los partidos del d\xEDa de un deporte. Los primeros {{freeScans}} son gratis. El plan incluye {{monthlyScans}} al mes entre todos tus deportes."
        },
        leagues: {
          question: "\xBFQu\xE9 ligas est\xE1n incluidas?",
          answer: "F\xFAtbol, NBA, NFL y MLB est\xE1n cubiertos. La disponibilidad depende del lanzamiento de cada deporte y de la cobertura de datos."
        },
        free: {
          question: "\xBFC\xF3mo funciona el precio?",
          answer: "Tus primeros {{freeScans}} an\xE1lisis son gratis, sin tarjeta. Despu\xE9s, elige un deporte principal por {{base}} al mes y a\xF1ade deportes por {{additional}} cada uno: dos deportes suman {{two}} y tres suman {{three}}. Todo plan incluye {{monthlyScans}} an\xE1lisis al mes entre todos tus deportes. Los precios son en reales brasile\xF1os. Cancela cuando quieras."
        }
      }
    },
    sports: {
      football: "F\xFAtbol",
      nba: "NBA",
      nfl: "NFL",
      mlb: "MLB"
    },
    closing: {
      title: "Empieza con {{freeScans}} an\xE1lisis gratis.",
      description: "Sin tarjeta. El plan empieza solo cuando t\xFA lo elijas."
    },
    pricing: {
      title: "{{freeScans}} an\xE1lisis gratis. Despu\xE9s, un plan para tus deportes.",
      description: "Elige tu deporte principal y a\xF1ade los que quieras seguir. Una cuota mensual en reales brasile\xF1os, con {{monthlyScans}} an\xE1lisis al mes incluidos.",
      base: "al mes por un deporte",
      extra: "al mes por cada deporte adicional",
      mainSport: "Elige tu deporte principal",
      extraSports: "A\xF1ade deportes extra (opcional)",
      total: "Tu total mensual",
      perMonth: "/mes",
      included: "Incluye {{monthlyScans}} an\xE1lisis al mes entre todos tus deportes. Cancela cuando quieras."
    }
  },
  legal: {
    back: "Volver a Pick Pro",
    updated: "\xDAltima revisi\xF3n:",
    contents: "En esta p\xE1gina",
    resources: "Recursos oficiales",
    draftTitle: "Borrador para revisi\xF3n",
    draftDescription: "Este documento a\xFAn no es definitivo. La identidad legal del proveedor, los contactos p\xFAblicos y los procedimientos deben confirmarse antes de abrir las suscripciones.",
    terms: {
      title: "T\xE9rminos de Uso",
      description: "El alcance del servicio, tus responsabilidades y las condiciones de uso de Pick Pro.",
      sections: {
        scope: {
          title: "Sobre el servicio",
          body: "Pick Pro es un producto independiente de investigaci\xF3n deportiva. Presenta informaci\xF3n, estad\xEDsticas y herramientas de an\xE1lisis. No acepta ni ejecuta apuestas, no guarda dep\xF3sitos para apuestas ni paga premios. Las bancas y los registros de apuestas son herramientas de seguimiento. Un operador externo es responsable de cualquier apuesta realizada con \xE9l. Este borrador describe el servicio actual y el modelo de suscripci\xF3n previsto."
        },
        access: {
          title: "Edad y acceso",
          body: "El servicio est\xE1 destinado a personas de 18 a\xF1os o m\xE1s. No lo utilices si eres menor de 18 a\xF1os o el acceso est\xE1 prohibido donde vives. Cada cuenta incluye {{freeScans}} an\xE1lisis gratis. Despu\xE9s, las herramientas de investigaci\xF3n se habilitan por deporte seg\xFAn el plan de la cuenta. El registro no crea una suscripci\xF3n de pago. La facturaci\xF3n autom\xE1tica a\xFAn no est\xE1 activa."
        },
        use: {
          title: "Uso permitido",
          body: "Utiliza el servicio legalmente para tu investigaci\xF3n. No interfieras con la seguridad, intentes accesos no autorizados, uses datos personales indebidamente, redistribuyas bases licenciadas sin permiso ni manipules eventos deportivos. Los derechos del software, marca y contenido pertenecen a sus titulares, preservando tus derechos y los usos legales."
        },
        payments: {
          title: "Cuotas y cobros",
          body: "La suscripci\xF3n prevista cuesta {{base}} al mes por un deporte principal a tu elecci\xF3n, m\xE1s {{additional}} mensuales por deporte adicional. Los precios son en reales brasile\xF1os. La calculadora no procesa pagos. Antes de contratar, el checkout debe identificar proveedor, deportes disponibles, total recurrente, renovaci\xF3n y cancelaci\xF3n. Los extras requieren selecci\xF3n expresa. No hay paquetes disponibles."
        },
        rights: {
          title: "Cancelaci\xF3n y derechos del consumidor",
          body: "Los canales de cancelaci\xF3n y reembolso deben presentarse antes de comprar. Se preservan los derechos de consumo aplicables, incluido el desistimiento de siete d\xEDas para los contratos a distancia comprendidos por la ley. Ninguna cl\xE1usula limita reembolsos obligatorios, recursos legales o acceso a la protecci\xF3n del consumidor. La demostraci\xF3n a\xFAn no ofrece gesti\xF3n de suscripciones ni reembolsos."
        },
        responsibility: {
          title: "L\xEDmites y responsabilidad",
          body: "Las frecuencias hist\xF3ricas no garantizan resultados futuros. Los datos y cuotas pueden cambiar o contener errores. Comprueba fuente, hora y condiciones reales del operador antes de decidir. Apostar puede causar dependencia y la p\xE9rdida de todo el importe. Estos t\xE9rminos no excluyen responsabilidades legales obligatorias ni trasladan al consumidor la responsabilidad por defectos del servicio."
        },
        changes: {
          title: "Cambios y conflictos",
          body: "Los cambios relevantes deben comunicarse claramente, sin eliminar retroactivamente derechos adquiridos. Las restricciones por seguridad, mantenimiento o uso il\xEDcito deben respetar al consumidor. La legislaci\xF3n brasile\xF1a rige la oferta en Brasil sin excluir otras protecciones obligatorias. Se preserva el acceso al tribunal competente, incluido el del domicilio del consumidor cuando corresponda."
        },
        contact: {
          title: "Proveedor y contacto",
          body: "El nombre legal, CNPJ/CPF cuando corresponda, direcci\xF3n comercial y contacto p\xFAblico est\xE1n pendientes de confirmaci\xF3n. Estos t\xE9rminos siguen siendo un borrador. Esos datos y un canal efectivo deben publicarse antes de abrir suscripciones. No env\xEDes documentos ni informaci\xF3n sensible a contactos no verificados."
        }
      }
    },
    privacy: {
      title: "Pol\xEDtica de Privacidad",
      description: "C\xF3mo se gestionan el acceso a la cuenta, las preferencias y los estudios guardados.",
      sections: {
        scope: {
          title: "Responsable y alcance",
          body: "Este borrador cubre las p\xE1ginas p\xFAblicas y las herramientas de investigaci\xF3n con sesi\xF3n iniciada de Pick Pro. La identidad jur\xEDdica, la direcci\xF3n y el contacto de privacidad del responsable siguen pendientes de confirmaci\xF3n. Las casas de apuestas y los servicios externos tienen sus propios avisos de privacidad."
        },
        access: {
          title: "Datos de la demostraci\xF3n",
          body: "El registro recopila tu correo electr\xF3nico y contrase\xF1a, que se almacena como hash. Tu cuenta guarda el estado de verificaci\xF3n y acceso y las preferencias de idioma, zona horaria y formato de cuotas. Al usar las herramientas de investigaci\xF3n y seguimiento, almacenamos selecciones guardadas, boletos, bancas y registros de apuestas. Los registros de inicio de sesi\xF3n y de sesi\xF3n incluyen informaci\xF3n t\xE9cnica como direcci\xF3n IP, navegador y horas de acceso. La calculadora de precios no procesa pagos."
        },
        use: {
          title: "Finalidades y bases legales",
          body: "Los datos de cuenta y sesi\xF3n permiten iniciar sesi\xF3n, verificar el correo, recuperar la contrase\xF1a y controlar el acceso. Las preferencias personalizan la interfaz. Los estudios guardados y los registros de seguimiento permiten revisar selecciones y resultados. El registro del tratamiento y las bases legales siguen pendientes de confirmaci\xF3n operativa. Navegar no autoriza seguimiento opcional, publicidad ni marketing."
        },
        payments: {
          title: "Almacenamiento y cookies",
          body: "El inicio de sesi\xF3n utiliza las cookies pickpro_access y pickpro_refresh para autenticaci\xF3n y pickpro_session para indicar una sesi\xF3n a la interfaz. Las preferencias tambi\xE9n se almacenan localmente en pickpro.preferences y permanecen hasta que se cambien o borren. La aplicaci\xF3n no instala p\xEDxeles publicitarios ni scripts de an\xE1lisis de audiencia. Las cookies de infraestructura, si se habilitan, deben inventariarse por separado."
        },
        rights: {
          title: "Tus derechos",
          body: "En los casos aplicables de la LGPD puedes solicitar confirmaci\xF3n, acceso, correcci\xF3n, informaci\xF3n sobre intercambio, anonimizaci\xF3n o eliminaci\xF3n de datos innecesarios o il\xEDcitos, portabilidad seg\xFAn las reglas y retirada del consentimiento. Puedes cuestionar tratamientos irregulares y pedir revisi\xF3n de decisiones automatizadas cuando corresponda. El canal p\xFAblico de solicitudes est\xE1 pendiente de confirmaci\xF3n. Puedes gestionar datos locales en el navegador y recurrir a la ANPD o la protecci\xF3n del consumidor."
        },
        responsibility: {
          title: "Proveedores y seguridad",
          body: "El alojamiento y la red reciben informaci\xF3n de solicitudes, que puede incluir IP, navegador, ruta y hora. Los proveedores, pa\xEDses, salvaguardas y plazos deben confirmarse en el despliegue real. Se requieren controles de acceso, transporte protegido y procedimientos de incidentes; ning\xFAn sistema carece de riesgos. Las transferencias internacionales, si existen, requieren mecanismo v\xE1lido de la LGPD y divulgaci\xF3n; este borrador no certifica un mecanismo implementado."
        },
        changes: {
          title: "Conservaci\xF3n y evoluci\xF3n",
          body: "Los datos de cuenta, estudios guardados y registros de seguimiento persisten para mantener tu historial. Puedes eliminar elementos guardados y solicitar la eliminaci\xF3n de tu cuenta en Configuraci\xF3n. Los plazos de conservaci\xF3n en servidores, registros de seguridad y copias de respaldo y la eliminaci\xF3n de estas copias siguen pendientes de confirmaci\xF3n. La facturaci\xF3n autom\xE1tica a\xFAn no est\xE1 activa; el procesamiento de pagos requerir\xE1 un aviso actualizado antes de su activaci\xF3n."
        },
        contact: {
          title: "Contacto, menores y cambios",
          body: "El servicio est\xE1 dirigido a adultos. Deben a\xF1adirse contacto de privacidad operativo, procedimientos para solicitudes e informes sobre menores e identidad del responsable antes de finalizar. Los cambios relevantes de finalidades, destinatarios u opciones se comunicar\xE1n. Actualizar la pol\xEDtica no proporciona consentimiento para un nuevo uso opcional."
        }
      }
    },
    responsible: {
      title: "Juego responsable",
      description: "Investigar puede aportar contexto. No elimina los riesgos de apostar.",
      sections: {
        scope: {
          title: "Investigaci\xF3n independiente",
          body: "Pick Pro no recibe apuestas, mantiene dep\xF3sitos para apuestas ni paga premios. Cualquier apuesta ocurre por separado con un operador externo. La cuota paga el software de investigaci\xF3n, no cr\xE9ditos para apostar."
        },
        access: {
          title: "Solo para adultos",
          body: "El servicio est\xE1 dirigido a mayores de 18 a\xF1os. Los operadores tienen verificaciones y restricciones propias; ser adulto o usar Pick Pro no demuestra elegibilidad para apostar."
        },
        use: {
          title: "Cifras con contexto",
          body: "Comprueba tama\xF1o y per\xEDodo de la muestra, registros ausentes y hora de las cuotas. Una frecuencia hist\xF3rica alta no garantiza resultados. Los ejemplos son ilustrativos; las sugerencias no son promesas de beneficio."
        },
        payments: {
          title: "Dinero y tiempo",
          body: "Apostar no es invertir, sustituir un empleo ni resolver deudas. Puedes perder todo el importe. No uses dinero de necesidades esenciales, pidas pr\xE9stamos para apostar ni aumentes importes para recuperar p\xE9rdidas. Establece l\xEDmites y detente si las apuestas afectan tu vida."
        },
        rights: {
          title: "Autoexclusi\xF3n centralizada",
          body: "El Gobierno ofrece bloqueo voluntario de plataformas autorizadas federalmente por la SPA, por un per\xEDodo elegido o indefinidamente. Usa el enlace GOV.BR. Esto no borra autom\xE1ticamente datos de Pick Pro ni cancela una suscripci\xF3n independiente de investigaci\xF3n."
        },
        responsibility: {
          title: "Apoyo de salud",
          body: "Si las apuestas afectan tu bienestar o relaciones, busca apoyo en el SUS de Brasil, en UBS o CAPS. Los familiares tambi\xE9n pueden buscar orientaci\xF3n. El enlace del Ministerio de Salud muestra los canales actuales."
        },
        changes: {
          title: "Operadores externos",
          body: "Si decides apostar, comprueba operador y dominio exacto en la lista actual de la SPA para servicios autorizados federalmente. Una marca en un ejemplo no es recomendaci\xF3n ni prueba de autorizaci\xF3n de un enlace. No conf\xEDes solo en logotipos o anuncios."
        },
        contact: {
          title: "Informaci\xF3n oficial",
          body: "Los enlaces llevan a servicios gubernamentales de autoexclusi\xF3n, salud, consulta de operadores y normativa, con t\xE9rminos y privacidad propios. Pick Pro no representa al Gobierno ni afirma que los enlaces constituyan aprobaci\xF3n regulatoria."
        }
      }
    }
  },
  radar: {
    title: "Radar {{sport}}",
    matches: "Partidos",
    players: "Jugadores",
    search: "Buscar partidos y jugadores",
    searchPlaceholder: "Equipo, jugador o competici\xF3n",
    date: "D\xEDa",
    market: "Mercado",
    sort: "Ordenar por",
    probability: "Probabilidad del modelo",
    ev: "EV estimado",
    fairOdds: "Cuota justa",
    offeredOdds: "Cuota disponible",
    oddsUpdated: "Cuota actualizada",
    analyzeMatch: "Analizar partido",
    analyzePlayer: "Analizar jugador",
    error: "No se pudo cargar el Radar",
    empty: "No hay selecciones coincidentes",
    emptyDescription: "Prueba otro d\xEDa o ajusta los filtros.",
    noFixtures: "No hay pr\xF3ximos partidos este d\xEDa",
    noFixturesDescription: "Elige otro d\xEDa para explorar {{sport}}.",
    loading: "Cargando Radar",
    loadingMore: "Cargando m\xE1s",
    count_zero: "{{count}} selecciones",
    count_one: "{{count}} selecci\xF3n",
    count_other: "{{count}} selecciones",
    coverage: "{{analyzed}} de {{total}} partidos tienen datos y cuotas utilizables para los mercados seleccionados",
    showMore: "Mostrar m\xE1s",
    reset: "Restablecer filtros",
    historical: "Rendimiento reciente",
    minutes: "Promedio de minutos",
    average: "Promedio",
    sample_zero: "\xDAltimas {{count}} participaciones",
    sample_one: "\xDAltima {{count}} participaci\xF3n",
    sample_other: "\xDAltimas {{count}} participaciones",
    unknown: "Sin registrar",
    over: "M\xE1s de {{line}}",
    milestone: "{{count}}+",
    opening: "Precio de apertura",
    quarters: "Por cuarto",
    lineup: {
      battingOrder: "Batea {{order}}\xBA",
      probablePitcher: "Lanzador probable"
    },
    lineupStatus: {
      starter: "Titular",
      bench: "Suplente",
      absent: "Fuera de la lista",
      expected: "Probable titular",
      pending: "Alineaci\xF3n pendiente"
    },
    lineupStatusHint: {
      expected: "Alineaci\xF3n probable, a\xFAn no confirmada.",
      pending: "La alineaci\xF3n a\xFAn no sali\xF3. El jugador puede no ser titular."
    },
    availability: {
      out: "Fuera",
      doubtful: "Muy dudoso",
      questionable: "Dudoso",
      day_to_day: "D\xEDa a d\xEDa",
      probable: "Probable",
      active: "Activo"
    },
    versus: {
      title: "Enfrentamiento",
      line: "vs {{opponent}}: {{hits}}/{{atBats}}, {{homeRuns}} HR, {{strikeouts}} K",
      plateAppearances: "Apariciones al plato",
      atBats: "Turnos al bate",
      hits: "Hits",
      homeRuns: "Jonrones",
      strikeouts: "Ponches",
      walks: "Bases por bolas",
      avg: "AVG",
      ops: "OPS"
    },
    splits: {
      title: "Splits",
      home: "En casa",
      away: "Fuera",
      versusLeft: "vs zurdo",
      versusRight: "vs derecho",
      last15: "\xDAltimos 15 d\xEDas",
      versusOpponent: "vs {{opponent}}",
      avgLine: "AVG {{avg}}",
      opsLine: "OPS {{ops}}",
      avg: "AVG",
      ops: "OPS",
      homeRuns: "Jonrones",
      strikeouts: "Ponches",
      atBats: "Turnos al bate",
      empty: "Sin split publicado."
    },
    full: "Partido completo",
    first_half: "Primera mitad",
    markets: {
      result: "Resultado del partido",
      goals: "Goles",
      corners: "C\xF3rners",
      btts: "Ambos marcan",
      shots: "Tiros",
      shots_on_target: "Tiros a puerta",
      cards: "Tarjetas"
    },
    sides: {
      home: "Victoria local",
      draw: "Empate",
      away: "Victoria visitante",
      over: "M\xE1s de",
      under: "Menos de",
      yes: "S\xED",
      no: "No"
    },
    filters: {
      today: "Hoy",
      tomorrow: "Ma\xF1ana",
      period: "Tiempo",
      type: "Tipo",
      all: "Todos",
      value: "Valor",
      probabilitySort: "Probabilidad",
      hitRateSort: "Aciertos",
      minProbability: "Tasa de acierto / probabilidad m\xEDnima",
      minOdds: "Cuota m\xEDnima",
      probabilityShort: "Aciertos / prob.",
      oddsShort: "Cuota",
      league: "Liga",
      leagueCount: "Todas las ligas ({{count}})",
      selectedOptions_zero: "{{count}} seleccionados",
      selectedOptions_one: "{{count}} seleccionado",
      selectedOptions_other: "{{count}} seleccionados",
      searchMarkets: "Buscar mercados",
      noMarkets: "No se encontraron mercados",
      searchLeagues: "Buscar liga..."
    },
    forTeam: "Para {{team}}",
    opponentHistory: "Valores concedidos por el rival: {{team}}",
    historyValues: "Valores de partidos recientes",
    historicalHits: "Aciertos",
    hitRate: "Tasa de acierto",
    matchHistory: "Totales de partidos recientes: {{team}}",
    warnings: {
      title: "Alertas del partido",
      viewAll: "Ver todas las alertas",
      refereeCards_zero: "\xC1rbitro: {{average}} tarjetas amarillas + rojas por partido ({{sample}} partidos). Revisa este under.",
      refereeCards_one: "\xC1rbitro: {{average}} tarjetas amarillas + rojas por partido ({{sample}} partido). Revisa este under.",
      refereeCards_other: "\xC1rbitro: {{average}} tarjetas amarillas + rojas por partido ({{sample}} partidos). Revisa este under.",
      strongFavorite: "{{team}}: {{probability}} de probabilidad estimada de victoria. Revisa el under de c\xF3rners en este contexto.",
      neutralVenue: "Campo neutral: el historial en casa/fuera puede ser menos representativo.",
      shortRest: "{{team}}: {{hours}} horas entre partidos.",
      absences_zero: "{{team}}: {{count}} bajas informadas. Revisa la alineaci\xF3n.",
      absences_one: "{{team}}: {{count}} baja informada. Revisa la alineaci\xF3n.",
      absences_other: "{{team}}: {{count}} bajas informadas. Revisa la alineaci\xF3n.",
      injury: "Parte m\xE9dico: {{players}}.",
      lineupPending: "Alineaci\xF3n a\xFAn no publicada."
    },
    compareHistory: "Comparar partidos anteriores",
    openSample: "Muestra hist\xF3rica",
    noComparison: "No hay partidos anteriores registrados.",
    selection: {
      title: "Boletos seleccionados",
      count_zero: "{{count}} boletos seleccionados",
      count_one: "{{count}} boleto seleccionado",
      count_other: "{{count}} boletos seleccionados",
      limit: "Hasta {{limit}} boletos a la vez.",
      clear: "Limpiar selecci\xF3n",
      sameFixture: "Dos o m\xE1s boletos son del mismo partido. Es posible que la casa no acepte combinarlos.",
      started: "Algunos partidos seleccionados ya comenzaron. Qu\xEDtalos antes de registrar."
    }
  },
  ticket: {
    title: "Pick Pro",
    filters: "Filtros",
    summary: "Resumen del boleto",
    summaryToggle: "Mostrar detalles del boleto",
    games: "Cantidad de partidos",
    gamesHint: "M\xE1s selecciones aumentan la cuota combinada y reducen la probabilidad de ganar.",
    increase: "Aumentar partidos",
    decrease: "Reducir partidos",
    window: "Intervalo de tiempo",
    windowHint: "Solo se consideran partidos que comienzan en este intervalo.",
    hours: "{{count}}h",
    markets: "Mercados",
    playerMarkets: "Props de jugadores",
    all: "Todos",
    none: "Ninguno",
    invert: "Invertir",
    minProbability: "Probabilidad m\xEDnima (%)",
    minOdds: "Cuota m\xEDnima",
    generate: "Generar boleto",
    ready: "Tu boleto",
    selectionCount: "{{selected}} / {{requested}} selecciones",
    available: "Selecciones con cuotas disponibles y valor positivo del modelo. Una selecci\xF3n por partido.",
    empty: "No hay selecciones disponibles",
    emptyHint: "Prueba un intervalo mayor u otros mercados.",
    hiddenByFilters_zero: "{{count}} selecciones est\xE1n ocultas por los filtros de probabilidad m\xEDnima, cuota, mercado o periodo. Rel\xE1jalos para verlas.",
    hiddenByFilters_one: "{{count}} selecci\xF3n est\xE1 oculta por los filtros de probabilidad m\xEDnima, cuota, mercado o periodo. Rel\xE1jalos para verla.",
    hiddenByFilters_other: "{{count}} selecciones est\xE1n ocultas por los filtros de probabilidad m\xEDnima, cuota, mercado o periodo. Rel\xE1jalos para verlas.",
    shortfall: "No hay suficientes partidos aptos para completar tu boleto.",
    stake: "Apuesta",
    increaseStake: "Aumentar apuesta en {{amount}}",
    decreaseStake: "Disminuir apuesta en {{amount}}",
    totalOdds: "Cuota total",
    return: "Retorno potencial",
    lock: "Bloquear selecci\xF3n",
    unlock: "Desbloquear selecci\xF3n",
    replace: "Reemplazar selecci\xF3n",
    save: "Guardar boleto",
    saved: "Cambios guardados en tu cuenta.",
    saveError: "No se pudo guardar. Comprueba la conexi\xF3n e int\xE9ntalo de nuevo.",
    savedTitle: "Boletos guardados",
    inTicket: "Partidos en el boleto",
    twoDays: "2 d\xEDas",
    criterion: "Criterio",
    criterionHint: "Estad\xEDsticas del equipo local o visitante, o del partido completo.",
    byTeam: "Por equipo",
    byMatch: "Por partido",
    selectedTeam: "Equipo: {{team}}",
    playerPickSuffix: "\u2013 {{side}} {{line}}",
    playerMarket: "{{metric}}",
    historySample: "Muestra hist\xF3rica: {{hits}}/{{total}}",
    historicalEstimate: "Estimaci\xF3n hist\xF3rica",
    teamAvailable: "Mercados por equipo con cuotas recientes y estimaci\xF3n hist\xF3rica como local o visitante. Una selecci\xF3n por partido.",
    accountSync: "Sincronizado con tu cuenta. Los resultados pendientes se comprueban autom\xE1ticamente cada minuto despu\xE9s de que terminen los partidos. Los datos ausentes siguen pendientes. Tambi\xE9n puedes comprobar los resultados o corregir una selecci\xF3n manualmente.",
    ticketName: "Nombre del boleto",
    selectionResult: "Resultado de la selecci\xF3n",
    removeSelection: "Eliminar selecci\xF3n",
    saveChanges: "Guardar cambios",
    cancel: "Cancelar",
    profit: "Beneficio",
    edit: "Editar",
    checkResults: "Comprobar resultados",
    delete: "Eliminar",
    noSaved: "No hay boletos guardados.",
    importLocal_zero: "Importar {{count}} boletos de este navegador",
    importLocal_one: "Importar {{count}} boleto de este navegador",
    importLocal_other: "Importar {{count}} boletos de este navegador",
    previous: "Anterior",
    next: "Siguiente",
    period: "Periodo",
    secondHalf: "Segundo tiempo",
    combinedEdge: "Ventaja combinada estimada",
    risk: "Riesgo estimado",
    indicatorHint: "Supone partidos independientes. Bajo: probabilidad estimada de acertar todas de al menos 65%; medio: 35\u201365%; alto: menos de 35%. Las estimaciones hist\xF3ricas no son predicciones calibradas.",
    previousOdds: "Cuota anterior",
    generation: {
      changed: "Boleto alternativo generado.",
      unchanged: "No hay selecciones alternativas que cumplan los filtros y bloqueos."
    },
    movement: {
      unknown: "Sin cuota anterior",
      stable: "Cuotas estables",
      up: "Cuota aument\xF3",
      down: "Cuota baj\xF3"
    },
    riskLevels: {
      unknown: "\u2014",
      low: "Bajo",
      medium: "Medio",
      high: "Alto"
    },
    results: {
      pending: "Pendiente",
      won: "Ganado",
      lost: "Perdido",
      void: "Anulado",
      halfWon: "Medio ganado",
      halfLost: "Medio perdido"
    },
    marketNames: {
      cards: "Tarjetas",
      shots: "Tiros",
      shots_on_target: "Tiros a puerta",
      points: "Puntos",
      runs: "Carreras",
      moneyline: "Ganador",
      spread: "H\xE1ndicap"
    },
    refresh: "Actualizar",
    lastRefreshed: "\xDAltima actualizaci\xF3n: {{time}}",
    staleData: "Esta lista se actualiz\xF3 hace m\xE1s de 5 minutos. Actualiza antes de enviar a una banca.",
    stalePrices: "Algunas cuotas seleccionadas tienen m\xE1s de 5 minutos. Actualiza y comprueba la casa de apuestas antes de registrar."
  },
  study: {
    title: "Selecciones guardadas",
    subtitle: "Tus selecciones guardadas, listas para revisar.",
    sendToBankroll: "Enviar a banca",
    oddsFor: "Cuota: {{match}}",
    decimalOddsFor: "Cuota decimal: {{selection}}",
    invalidStake: "Introduce un importe entre 0,01 y 1.000.000.",
    invalidOdds: "Introduce una cuota decimal mayor que 1 y hasta 1000.",
    remove: "Eliminar selecci\xF3n",
    accumulator: "Apuesta combinada",
    accumulatorHint: "Un importe para todas las selecciones. Una selecci\xF3n perdida pierde la combinada.",
    singlesHint: "El importe indicado se aplica a cada apuesta simple.",
    bankroll: "Banca",
    chooseBankroll: "Elige una banca",
    newBankroll: "Nueva banca",
    stake: "Importe (BRL)",
    bookmaker: "Casa de apuestas",
    totalStake: "Importe total",
    combinedOdds: "Cuota combinada",
    noSelections: "Selecciona al menos una l\xEDnea.",
    invalidOpeningBalance: "Ingresa un saldo inicial entre 0 y 10.000.000.000.",
    saveError: "No se pudo guardar. Revisa los valores y el saldo e int\xE9ntalo de nuevo.",
    loadError: "No se pudieron cargar tus datos.",
    recordBets: "Registrar apuestas",
    bankrollName: "Nombre de la banca",
    save: "Guardar",
    transactions: "Movimientos",
    restore: "Restaurar",
    archive: "Archivar",
    openingBalance: "Saldo inicial (BRL)",
    createBankroll: "Crear banca",
    editBankroll: "Editar banca",
    adjustBalance: "Ajustar saldo",
    deposit: "Dep\xF3sito",
    withdrawal: "Retiro",
    adjustmentAmount: "Importe (BRL)",
    applyAdjustment: "Aplicar",
    insufficientBalance: "Importe superior al saldo actual.",
    archivedAdjustmentHint: "Restaura esta banca para ajustar su saldo.",
    selectionActions: "Acciones de selecci\xF3n",
    saved: "Guardado",
    alreadyBet: "Ya apostado",
    alreadyBetOne: "{{bankroll}} \xB7 {{amount}}",
    alreadyBetMany: "{{count}} apuestas \xB7 {{amount}}",
    saveSelection: "Guardar boleto",
    removeFromNotebook: "Quitar de las selecciones guardadas",
    recorded: "Apuestas registradas",
    selectLine: "Seleccionar {{match}}: {{line}}",
    grouping: "Agrupar selecciones",
    byGame: "Por partido",
    byMarket: "Por mercado",
    search: "Filtrar por equipo, liga o mercado",
    cancel: "Cancelar",
    expandAll: "Expandir todos",
    collapseAll: "Contraer todos",
    clearAll: "Borrar todo",
    empty: "Ninguna selecci\xF3n guardada coincide con estos filtros. Guarda selecciones desde Radar o Pick Pro.",
    selectionCount_zero: "{{count}} selecciones",
    selectionCount_one: "{{count}} selecci\xF3n",
    selectionCount_other: "{{count}} selecciones",
    sendTicket: "Enviar combinada",
    previousTickets: "Boletos guardados anteriormente",
    clearHint: "\xBFQuitar todas las selecciones guardadas? Las apuestas registradas y las bancas se conservan.",
    oneSportHint: "Un boleto usa selecciones de un solo deporte.",
    confirmClear: "Borrar selecciones guardadas",
    betDetails: "Detalles y resultados de la apuesta",
    chooseBet: "Elige una apuesta",
    manualHint: "Guardar resultados hace que esta apuesta sea manual. Puedes consultar los resultados registrados cuando lo necesites.",
    needsReview: "Necesita tu resultado",
    needsReviewHint: "Este partido ya termin\xF3, pero el resultado de una de las selecciones no est\xE1 disponible en nuestro proveedor de datos. Def\xEDnelo manualmente abajo.",
    profitEvolution: "Evoluci\xF3n del beneficio",
    settlementBasis: "Resultados por fecha de liquidaci\xF3n",
    noResolved: "No hay apuestas liquidadas en este per\xEDodo.",
    cumulativeProfit: "Beneficio acumulado",
    market: "Mercado",
    allMarkets: "Todos los mercados",
    filters: "Filtros",
    from: "Desde",
    to: "Hasta",
    profit: "Beneficio",
    roi: "Retorno de la inversi\xF3n",
    hitRate: "Tasa de acierto",
    pending: "Apuestas pendientes",
    bankrolls: "Bancas",
    noBankrolls: "Crea una banca para empezar a registrar apuestas.",
    noPending: "No hay apuestas pendientes.",
    betHistory: "Apuestas liquidadas",
    transactionKinds: {
      opening: "Saldo inicial",
      stake: "Importe",
      return: "Retorno",
      correction: "Correcci\xF3n",
      deposit: "Dep\xF3sito",
      withdrawal: "Retiro"
    },
    bankrollSubtitle: "Gestiona tus bancas y sigue cada apuesta.",
    archived: "Archivada",
    currentBalance: "Saldo actual",
    separateMatches: "Las combinadas requieren partidos diferentes. Usa apuestas simples para varias l\xEDneas del mismo partido.",
    betSummary: {
      title: "Resumen de la apuesta",
      return: "Retorno recibido",
      netProfit: "Beneficio neto",
      returnHint: "El retorno incluye el importe apostado. El beneficio neto es el retorno menos el importe apostado.",
      settledAt: "Liquidada el"
    },
    deleteBet: "Eliminar apuesta",
    deleteBetPending: "{{stake}} vuelve a {{bankroll}}.",
    deleteBetSettled: "{{stake}} vuelve a {{bankroll}} y se elimina el retorno de {{payout}}.",
    deleteBetStats: "La apuesta tambi\xE9n sale de tus estad\xEDsticas de rendimiento.",
    deleteError: "No se pudo eliminar esta apuesta. Int\xE9ntalo de nuevo.",
    yourBankroll: "tu banca"
  },
  bets: {
    title: "Apuestas",
    tabs: {
      live: "En vivo",
      upcoming: "Pr\xF3ximas",
      settled: "Finalizadas",
      performance: "Rendimiento"
    },
    performance: {
      sport: "Deporte",
      updated: "Actualizado",
      profit: "Ganancia",
      resolvedStake: "Stake liquidado",
      roi: "Retorno de la inversi\xF3n",
      roiHint: "Ganancia / stake liquidado, sin apuestas anuladas",
      hitRate: "Tasa de acierto",
      resolvedCount_zero: "{{count}} apuestas liquidadas",
      resolvedCount_one: "{{count}} apuesta liquidada",
      resolvedCount_other: "{{count}} apuestas liquidadas",
      pending: "Apuestas pendientes",
      currentRisk: "Stake en riesgo ahora",
      live: "En vivo",
      liveHint: "Partidos en vivo en apuestas pendientes",
      loadError: "No se pudieron cargar tus resultados.",
      invalidRange: "Elige un per\xEDodo v\xE1lido.",
      noSports: "Ning\xFAn deporte en tu plan todav\xEDa.",
      ranges: {
        "1": "Hoy",
        "7": "7 d\xEDas",
        "30": "30 d\xEDas",
        month: "Mes",
        all: "Todo",
        custom: "Personalizado"
      }
    },
    awaiting: "Esperando resultado",
    needsReview: "Necesita tu resultado",
    empty: {
      live: "No hay apuestas en juego ahora.",
      upcoming: "No hay apuestas pr\xF3ximas.",
      settled: "Todav\xEDa no hay apuestas finalizadas."
    },
    stake: "Importe",
    totalOdds: "Cuota total",
    potentialReturn: "Retorno potencial",
    return: "Retorno",
    profit: "Ganancia",
    modes: {
      singles: "Simple",
      accumulator: "Combinada"
    },
    progress: "{{current}} de {{line}}",
    marketPeriod: "{{market}}, {{period}}",
    pendingTrend: "Pendiente, {{result}} hasta ahora",
    viewAll: "Ver todas las apuestas",
    collapseAll: "Contraer todo",
    expandAll: "Expandir todo",
    legCount_zero: "{{count}} selecciones",
    legCount_one: "{{count}} selecci\xF3n",
    legCount_other: "{{count}} selecciones",
    editBetLabel: "Editar apuesta: {{bet}}",
    deleteBetLabel: "Eliminar apuesta: {{bet}}"
  },
  matchContext: {
    updated: "Contexto actualizado: {{time}}",
    stale: "El contexto de este partido puede estar desactualizado.",
    conditions: "Condiciones del partido",
    neutralVenue: "Campo neutral",
    humidity: "Humedad: {{value}}%",
    forecast: "Pron\xF3stico",
    formation: "Formaci\xF3n",
    coach: "Entrenador",
    rest: "{{hours}} horas entre el inicio de este partido y el anterior",
    schedule_zero: "{{count}} partidos finalizados en los 7 d\xEDas anteriores",
    schedule_one: "{{count}} partido finalizado en los 7 d\xEDas anteriores",
    schedule_other: "{{count}} partidos finalizados en los 7 d\xEDas anteriores",
    lineup: {
      confirmed: "Alineaci\xF3n confirmada",
      expected: "Alineaci\xF3n probable",
      unconfirmed: "Alineaci\xF3n no confirmada"
    },
    bench: "Suplentes",
    absences: "Bajas informadas",
    reasons: {
      injury: "Lesi\xF3n",
      suspension: "Suspensi\xF3n",
      unavailable: "No disponible"
    },
    probabilities: "Probabilidades previas al partido",
    liveProbabilities: "Probabilidades en vivo en el minuto {{minute}}",
    expectedGoals: "Goles esperados registrados (xG)",
    pressure: "Presi\xF3n del partido",
    period: "Per\xEDodo {{number}}",
    events: "Eventos del partido",
    event: {
      goal: "Gol",
      ownGoal: "Autogol",
      penalty: "Gol de penalti",
      missedPenalty: "Penalti fallado",
      yellowCard: "Tarjeta amarilla",
      redCard: "Tarjeta roja",
      substitution: "Sustituci\xF3n",
      var: "Revisi\xF3n del VAR",
      varCard: "Tarjeta tras VAR"
    },
    trends: "Evoluci\xF3n del partido",
    seriesTeam: "Evoluci\xF3n de {{team}} en el partido"
  }
};

// src/locales/es/email.json
var email_default2 = {
  footer: "Pick Pro es un servicio independiente de investigaci\xF3n deportiva. No acepta apuestas.",
  verifyEmail: {
    subject: "Confirma tu correo en Pick Pro",
    greeting: "Hola,",
    body: "Confirma tu direcci\xF3n de correo para activar tu cuenta de Pick Pro.",
    action: "Confirmar correo",
    expiry: "Este enlace caduca en 24 horas.",
    ignore: "Si no creaste una cuenta, puedes ignorar este correo."
  },
  resetPassword: {
    subject: "Restablece tu contrase\xF1a de Pick Pro",
    greeting: "Hola,",
    body: "Recibimos una solicitud para restablecer la contrase\xF1a de tu cuenta de Pick Pro.",
    action: "Elegir una nueva contrase\xF1a",
    expiry: "Este enlace caduca en 1 hora.",
    ignore: "Si no lo solicitaste, puedes ignorar este correo y tu contrase\xF1a seguir\xE1 igual."
  },
  passwordChanged: {
    subject: "Tu contrase\xF1a de Pick Pro fue cambiada",
    greeting: "Hola,",
    body: "La contrase\xF1a de tu cuenta de Pick Pro fue cambiada y se cerraron todas las dem\xE1s sesiones.",
    action: "Abrir Pick Pro",
    ignore: "Si no fuiste t\xFA, restablece tu contrase\xF1a de inmediato desde la p\xE1gina de inicio de sesi\xF3n."
  }
};

// src/locales/pt-BR/common.json
var common_default3 = {
  theme: {
    switchToLight: "Ativar modo claro",
    switchToDark: "Ativar modo escuro"
  },
  live: {
    opportunitiesChanged: "As oportunidades mudaram. Revise suas sele\xE7\xF5es e odds antes de salvar.",
    reconnecting: "As atualiza\xE7\xF5es em tempo real est\xE3o temporariamente indispon\xEDveis. Os dados s\xE3o atualizados automaticamente enquanto reconectamos."
  },
  app: {
    name: "Pick Pro"
  },
  nav: {
    matches: "Partidas",
    language: "Idioma",
    mainLabel: "Principal",
    myLabel: "Salvos",
    primaryAction: "Comece gr\xE1tis",
    settings: "Configura\xE7\xF5es",
    signIn: "Entrar",
    signOut: "Sair",
    signUp: "Criar conta",
    pricing: "Planos",
    account: "Conta",
    admin: "Admin",
    sports: "Esportes",
    openNavigation: "Abrir navega\xE7\xE3o",
    closeNavigation: "Fechar navega\xE7\xE3o",
    sport: "Esporte",
    overview: "Hoje",
    search: "Buscar",
    competitions: "Competi\xE7\xF5es",
    teams: "Times",
    players: "Jogadores",
    radar: "Radar",
    "ticket-generator": "Pick Pro",
    bets: "Apostas"
  },
  common: {
    loading: "Carregando",
    retry: "Tentar novamente",
    empty: "Nada para mostrar ainda",
    error: "A p\xE1gina n\xE3o carregou.",
    previousMonth: "M\xEAs anterior",
    nextMonth: "Pr\xF3ximo m\xEAs",
    loadMore: "Carregar mais",
    close: "Fechar",
    required: "Obrigat\xF3rio"
  },
  errors: {
    internal: "Erro inesperado",
    notFound: "N\xE3o encontrado",
    notFoundDescription: "O endere\xE7o n\xE3o corresponde a nenhuma p\xE1gina.",
    validation: "Alguns campos s\xE3o inv\xE1lidos",
    unauthorized: "Entre para continuar",
    forbidden: "Voc\xEA n\xE3o tem acesso a isto",
    rateLimited: "Muitas tentativas, tente de novo em instantes",
    network: "N\xE3o foi poss\xEDvel falar com o servidor"
  },
  auth: {
    invalidCredentials: "E-mail ou senha incorretos",
    emailNotVerified: "Confirme seu e-mail antes de entrar",
    invalidToken: "Este link \xE9 inv\xE1lido ou expirou",
    sportLocked: "Este esporte ainda n\xE3o est\xE1 habilitado na sua conta",
    fields: {
      email: "E-mail",
      password: "Senha",
      newPassword: "Nova senha",
      currentPassword: "Senha atual",
      confirmPassword: "Confirmar senha",
      passwordHint: "Pelo menos 10 caracteres",
      firstName: "Nome",
      lastName: "Sobrenome"
    },
    validation: {
      email: "Informe um e-mail v\xE1lido",
      passwordLength: "Use pelo menos 10 caracteres",
      passwordTooLong: "Use uma senha mais curta",
      passwordMatch: "As senhas n\xE3o coincidem",
      required: "Obrigat\xF3rio",
      nameLength: "Informe de 1 a 100 caracteres"
    },
    signUp: {
      title: "Crie sua conta",
      description: "A pesquisa come\xE7a com uma conta. Suas primeiras {{freeScans}} an\xE1lises s\xE3o gr\xE1tis; depois, cada esporte \xE9 liberado pelo seu plano.",
      submit: "Criar conta",
      haveAccount: "J\xE1 tem uma conta?",
      sentTitle: "Confira seu e-mail",
      sentDescription: "Enviamos um link de confirma\xE7\xE3o para {{email}}. Abra o link para ativar sua conta.",
      resend: "Enviar o link de novo",
      resent: "Um novo link est\xE1 a caminho."
    },
    verify: {
      title: "Confirmando seu e-mail",
      success: "Seu e-mail foi confirmado. Voc\xEA j\xE1 pode entrar.",
      missing: "Esta p\xE1gina precisa do link do seu e-mail de confirma\xE7\xE3o.",
      resendPrompt: "Informe seu e-mail para receber um novo link."
    },
    signIn: {
      title: "Entrar",
      description: "Bem-vindo de volta.",
      submit: "Entrar",
      forgot: "Esqueceu a senha?",
      noAccount: "Novo por aqui?",
      unverifiedHelp: "Precisa de um novo link de confirma\xE7\xE3o?"
    },
    forgot: {
      title: "Redefinir sua senha",
      description: "Informe seu e-mail e enviaremos um link para escolher uma nova senha.",
      submit: "Enviar link de redefini\xE7\xE3o",
      sent: "Se existir uma conta para {{email}}, um link de redefini\xE7\xE3o est\xE1 a caminho.",
      back: "Voltar para entrar"
    },
    reset: {
      title: "Escolha uma nova senha",
      submit: "Salvar nova senha",
      success: "Sua senha foi atualizada. Entre com a nova senha.",
      missing: "Esta p\xE1gina precisa do link do seu e-mail de redefini\xE7\xE3o."
    }
  },
  access: {
    title: "Sua conta est\xE1 pronta",
    description: "Cada esporte da sua conta \xE9 habilitado pelo seu plano. Voc\xEA poder\xE1 pesquisar assim que um esporte for habilitado.",
    sportsTitle: "Esportes na sua conta",
    granted: "Habilitado",
    pending: "Pendente",
    pricingLink: "Ver os planos",
    contact: "D\xFAvidas? Escreva para {{email}}.",
    inactive: "Sua conta est\xE1 inativa. Fale com o suporte para restaurar o acesso."
  },
  sports: {
    football: "Futebol",
    nba: "NBA",
    nfl: "NFL",
    mlb: "MLB"
  },
  overview: {
    firstMatchOn: "Primeiro jogo em {{date}}",
    lastMatchOn: "\xDAltimo jogo em {{date}}"
  },
  today: {
    title: "Hoje",
    datePattern: "dddd, D [de] MMMM",
    summary: "{{date}}, {{live}} e {{upcoming}}",
    summaryQuiet: "{{date}}, sem jogos",
    liveCount_zero: "{{count}} ao vivo",
    liveCount_one: "{{count}} ao vivo",
    liveCount_other: "{{count}} ao vivo",
    upcomingCount_zero: "{{count}} por vir",
    upcomingCount_one: "{{count}} por vir",
    upcomingCount_other: "{{count}} por vir",
    openRadar: "Abrir Radar",
    openPickPro: "Pick Pro",
    liveMatches: "Jogos ao vivo",
    nextKickoff: "Pr\xF3ximo jogo",
    kickingOff: "Come\xE7ando",
    countdownHours: "{{hours}}h {{minutes}}min",
    countdownMinutes: "{{minutes}} min",
    nextMatchday: "Pr\xF3xima rodada",
    nextMatchdayCount_zero: "{{count}} jogos em {{date}}",
    nextMatchdayCount_one: "{{count}} jogo em {{date}}",
    nextMatchdayCount_other: "{{count}} jogos em {{date}}",
    nextUp: "A seguir",
    allOnMatches: "Todos os {{count}} em Partidas",
    favouriteCompetition: "Competi\xE7\xE3o favorita",
    phase: {
      off_season: "A temporada acabou. O Radar continua trabalhando nas \xFAltimas rodadas.",
      pre_season: "A temporada come\xE7a em breve.",
      in_season: "Nenhum jogo agendado."
    },
    loadError: "N\xE3o foi poss\xEDvel carregar os jogos de hoje.",
    strip: {
      title: "Este m\xEAs",
      profit: "Lucro",
      roi: "ROI",
      open: "Em aberto",
      openDetail_zero: "{{count}} apostas, {{amount}} em risco",
      openDetail_one: "{{count}} aposta, {{amount}} em risco",
      openDetail_other: "{{count}} apostas, {{amount}} em risco",
      bankroll: "Banca",
      noBankroll: "Sem banca",
      noSettled: "Nenhuma aposta liquidada este m\xEAs ainda.",
      loadError: "N\xE3o foi poss\xEDvel carregar os resultados do m\xEAs.",
      bankrollError: "N\xE3o foi poss\xEDvel carregar suas bancas."
    },
    plan: {
      title: "Seu plano",
      status: "Status",
      active: "Plano ativo",
      inactive: "Plano inativo",
      sports: "Esportes",
      manage: "Gerenciar em Acesso"
    }
  },
  competitions: {
    search: "Buscar competi\xE7\xF5es",
    results: "{{visible}} de {{total}} competi\xE7\xF5es",
    noResults: "Nenhuma competi\xE7\xE3o encontrada",
    noResultsDescription: "Tente outro nome de competi\xE7\xE3o ou limpe a busca.",
    clearSearch: "Limpar busca",
    title: "Competi\xE7\xF5es",
    seasons: "Temporadas",
    standings: "Classifica\xE7\xE3o",
    season: "Temporada",
    noStandings: "Ainda n\xE3o h\xE1 classifica\xE7\xE3o para esta temporada.",
    columns: {
      rank: "Posi\xE7\xE3o",
      team: "Time",
      played: "Jogos",
      won: "Vit\xF3rias",
      drawn: "Empates",
      lost: "Derrotas",
      scored: "Marcados",
      conceded: "Sofridos",
      goalDifference: "SG",
      points: "Pontos",
      record: "V-D",
      pct: "PCT"
    }
  },
  search: {
    title: "Buscar",
    resultsFor: 'Resultados para "{{query}}"',
    noResults: "Nenhum resultado para esta busca.",
    seeAll: "Ver todos",
    competitions: "Competi\xE7\xF5es",
    teams: "Times",
    players: "Jogadores"
  },
  metrics: {
    points: "Pontos",
    runs: "Corridas",
    hits: "Rebatidas",
    errors: "Erros",
    goals: "Gols",
    corners: "Escanteios",
    cards: "Cart\xF5es",
    shots: "Finaliza\xE7\xF5es",
    shots_on_target: "Finaliza\xE7\xF5es no alvo",
    shots_off_target: "Finaliza\xE7\xF5es para fora",
    shots_inside_box: "Finaliza\xE7\xF5es dentro da \xE1rea",
    shots_outside_box: "Finaliza\xE7\xF5es de fora da \xE1rea",
    shots_blocked: "Finaliza\xE7\xF5es bloqueadas",
    attacks: "Ataques",
    dangerous_attacks: "Ataques perigosos",
    passes: "Passes",
    accurate_passes: "Passes certos",
    tackles: "Desarmes",
    interceptions: "Intercepta\xE7\xF5es",
    crosses: "Cruzamentos",
    accurate_crosses: "Cruzamentos certos",
    big_chances_created: "Grandes chances criadas",
    key_passes: "Passes decisivos",
    dribbles: "Dribles certos",
    duels_won: "Duelos ganhos",
    clearances: "Cortes",
    touches: "Toques na bola",
    rating: "Nota",
    minutes: "Minutos",
    fouls: "Faltas",
    yellow_cards: "Cart\xF5es amarelos",
    red_cards: "Cart\xF5es vermelhos",
    offsides: "Impedimentos",
    saves: "Defesas",
    possession: "Posse de bola",
    rebounds: "Rebotes",
    offensive_rebounds: "Rebotes ofensivos",
    defensive_rebounds: "Rebotes defensivos",
    assists: "Assist\xEAncias",
    steals: "Roubos de bola",
    blocks: "Tocos",
    turnovers: "Erros de posse",
    field_goals_made: "Field goals convertidos",
    field_goals_attempted: "Field goals tentados",
    three_pointers_made: "Bolas de tr\xEAs convertidas",
    three_pointers_attempted: "Bolas de tr\xEAs tentadas",
    free_throws_made: "Lances livres convertidos",
    free_throws_attempted: "Lances livres tentados",
    plus_minus: "Saldo (+/-)",
    total_yards: "Jardas totais",
    passing_yards: "Jardas de passe",
    rushing_yards: "Jardas de corrida",
    passing_attempts: "Passes tentados",
    passing_completions: "Passes completos",
    rushing_attempts: "Corridas tentadas",
    first_downs: "First downs",
    first_downs_passing: "First downs de passe",
    first_downs_rushing: "First downs de corrida",
    first_downs_penalty: "First downs por penalidade",
    third_down_conversions: "Third downs convertidos",
    third_down_attempts: "Third downs tentados",
    fourth_down_conversions: "Fourth downs convertidos",
    fourth_down_attempts: "Fourth downs tentados",
    red_zone_scores: "Pontua\xE7\xF5es na red zone",
    red_zone_attempts: "Idas \xE0 red zone",
    interceptions_thrown: "Passes interceptados",
    fumbles_lost: "Fumbles perdidos",
    penalties: "Penalidades",
    penalty_yards: "Jardas de penalidade",
    sacks: "Sacks",
    sack_yards_lost: "Jardas perdidas em sacks",
    total_offensive_plays: "Jogadas ofensivas",
    total_drives: "Drives",
    possession_time_seconds: "Tempo de posse",
    defensive_touchdowns: "Touchdowns defensivos",
    yards_per_play: "Jardas por jogada",
    yards_per_pass: "Jardas por passe",
    yards_per_rush_attempt: "Jardas por corrida",
    passing_touchdowns: "Touchdowns de passe",
    passing_interceptions: "Passes interceptados",
    rushing_touchdowns: "Touchdowns de corrida",
    receiving_yards: "Jardas de recep\xE7\xE3o",
    receiving_touchdowns: "Touchdowns de recep\xE7\xE3o",
    receptions: "Recep\xE7\xF5es",
    receiving_targets: "Alvos",
    total_tackles: "Tackles totais",
    solo_tackles: "Tackles solo",
    defensive_sacks: "Sacks",
    defensive_interceptions: "Intercepta\xE7\xF5es",
    at_bats: "Vezes ao bast\xE3o",
    rbi: "RBI",
    home_runs: "Home runs",
    walks: "Bases por bolas",
    strikeouts: "Strikeouts",
    doubles: "Duplas",
    triples: "Triplas",
    stolen_bases: "Bases roubadas",
    batting_average: "M\xE9dia de rebatidas",
    on_base_percentage: "OBP",
    slugging: "Slugging",
    innings_pitched: "Innings lan\xE7ados",
    earned_run_average: "ERA",
    pitching_strikeouts: "Strikeouts como arremessador",
    pitching_walks: "Bases por bolas concedidas",
    fouls_drawn: "Faltas sofridas",
    aerials_won: "Duelos a\xE9reos ganhos",
    usage_percentage: "Taxa de uso",
    true_shooting_percentage: "Aproveitamento real de arremessos",
    effective_field_goal_percentage: "Aproveitamento efetivo de arremessos",
    offensive_rating: "Efici\xEAncia ofensiva",
    defensive_rating: "Efici\xEAncia defensiva",
    net_rating: "Efici\xEAncia l\xEDquida",
    pace: "Ritmo",
    pie: "Impacto do jogador",
    plate_appearances: "Apari\xE7\xF5es no bast\xE3o",
    total_bases: "Bases totais",
    pitches_thrown: "Arremessos realizados",
    points_rebounds_assists: "Pontos + rebotes + assist\xEAncias",
    points_rebounds: "Pontos + rebotes",
    points_assists: "Pontos + assist\xEAncias",
    rebounds_assists: "Rebotes + assist\xEAncias",
    double_double: "Duplo-duplo",
    triple_double: "Triplo-duplo",
    anytime_touchdown: "Touchdown a qualquer momento",
    first_touchdown: "Primeiro touchdown",
    rushing_receiving_yards: "Jardas de corrida + recep\xE7\xE3o",
    longest_reception: "Maior recep\xE7\xE3o",
    longest_rush: "Maior corrida",
    longest_pass: "Maior passe",
    kicking_points: "Pontos de chute",
    singles: "Rebatidas simples",
    extra_base_hits: "Rebatidas de extra-base",
    hits_runs_rbis: "Rebatidas + corridas + RBI",
    runs_rbis: "Corridas + RBI",
    hits_stolen_bases: "Rebatidas + bases roubadas",
    hits_runs_stolen_bases: "Rebatidas + corridas + bases roubadas",
    hits_walks_stolen_bases: "Rebatidas + bases por bolas + bases roubadas",
    pitcher_outs: "Outs registrados",
    pitcher_earned_runs: "Corridas limpas cedidas",
    pitcher_hits_allowed: "Rebatidas cedidas",
    pitcher_hits_walks_earned_runs: "Rebatidas + bases por bolas + corridas limpas cedidas",
    pitcher_win: "Vit\xF3ria do arremessador",
    first_home_run: "Primeiro home run",
    touchdowns: "Touchdowns de corrida + recep\xE7\xE3o",
    hit_woodwork: "Bolas na trave",
    big_chances_missed: "Grandes chances perdidas",
    tackles_won: "Desarmes certos",
    throw_ins: "Laterais",
    goal_kicks: "Tiros de meta",
    free_kicks: "Faltas cobradas",
    long_passes: "Passes longos",
    xg: "Gols esperados (xG)",
    goals_0_15: "Gols 0-15 min",
    goals_15_30: "Gols 15-30 min",
    goals_30_45: "Gols 30-45 min",
    goals_45_60: "Gols 45-60 min",
    goals_60_75: "Gols 60-75 min",
    goals_75_90: "Gols 75-90 min",
    blocked_shots: "Finaliza\xE7\xF5es bloqueadas",
    dispossessed: "Desarmado",
    duels: "Duelos",
    penalties_committed: "P\xEAnaltis cometidos",
    goals_conceded: "Gols sofridos",
    own_goals: "Gols contra",
    penalty_kicks: "P\xEAnaltis"
  },
  oddsFormats: {
    decimal: "Decimal (1,85)",
    fractional: "Fracion\xE1ria (17/20)",
    american: "Americana (-118)"
  },
  settings: {
    title: "Configura\xE7\xF5es",
    preferences: {
      title: "Prefer\xEAncias",
      locale: "Idioma",
      timezone: "Fuso hor\xE1rio",
      defaultSport: "Esporte padr\xE3o",
      noDefaultSport: "Primeiro esporte habilitado",
      oddsFormat: "Formato das odds",
      save: "Salvar prefer\xEAncias",
      saved: "Prefer\xEAncias salvas."
    },
    password: {
      title: "Senha",
      description: "Alterar a senha encerra a sess\xE3o em todos os outros dispositivos.",
      save: "Alterar senha",
      saved: "Senha alterada. As outras sess\xF5es foram encerradas."
    },
    delete: {
      title: "Excluir conta",
      description: "Isto remove sua conta e tudo o que est\xE1 ligado a ela. N\xE3o \xE9 poss\xEDvel desfazer.",
      confirmLabel: "Digite {{word}} para confirmar",
      submit: "Excluir minha conta",
      cancel: "Cancelar",
      mismatch: "Digite a palavra de confirma\xE7\xE3o exatamente"
    }
  },
  admin: {
    users: {
      title: "Usu\xE1rios",
      search: "Buscar por e-mail",
      email: "E-mail",
      status: "Acesso da conta",
      sports: "Esportes",
      verified: "Verificado",
      unverified: "N\xE3o verificado",
      firstGranted: "Primeira concess\xE3o",
      view: "Ver",
      empty: "Nenhum usu\xE1rio encontrado.",
      saved: "Salvo",
      statuses: {
        beta: "Habilitado",
        active: "Habilitado",
        inactive: "Desabilitado"
      }
    },
    navigation: {
      title: "Administra\xE7\xE3o",
      overview: "Vis\xE3o geral",
      ingestion: "Ingest\xE3o"
    },
    overview: {
      description: "Gerencie contas, revise acessos e acompanhe novos cadastros.",
      manageUsers: "Gerenciar usu\xE1rios",
      totalUsers: "Total de usu\xE1rios",
      verifiedUsers: "Contas verificadas",
      adminUsers: "Administradores",
      usersWithAccess: "Usu\xE1rios com acesso",
      planStatuses: "Status do plano",
      sportAccess: "Acesso por esporte",
      accessDescription: "Inclui administradores. Permiss\xF5es expiradas e contas de membros inativas s\xE3o exclu\xEDdas.",
      recentUsers: "Contas recentes",
      review: "Requer aten\xE7\xE3o",
      awaiting: "Aguardando verifica\xE7\xE3o",
      disabled: "Contas desabilitadas",
      created: "Cadastro",
      accessNote: "Contas habilitadas ainda precisam de uma permiss\xE3o por esporte. Administradores t\xEAm acesso a todos os esportes."
    },
    filters: {
      role: "Fun\xE7\xE3o",
      planStatus: "Filtrar por status do plano",
      verified: "Verifica\xE7\xE3o de e-mail",
      sport: "Acesso ao esporte",
      all: "Todos",
      user: "Usu\xE1rio",
      admin: "Administrador",
      true: "Verificado",
      false: "N\xE3o verificado",
      enabled: "Filtrar por acesso da conta"
    },
    details: {
      back: "Voltar aos usu\xE1rios",
      account: "Conta",
      created: "Criada em",
      activeSessions: "Sess\xF5es ativas",
      grants: "Permiss\xF5es registradas",
      noGrants: "Nenhuma permiss\xE3o registrada.",
      expires: "Expira em",
      noExpiry: "Sem expira\xE7\xE3o",
      grantedBy: "Concedida por",
      viewGrantor: "Ver administrador",
      enableAccount: "Habilitar conta",
      disableAccount: "Desabilitar conta"
    },
    ingestion: {
      description: "Acompanhe a fila do provedor, os feeds ao vivo e o que j\xE1 est\xE1 armazenado.",
      refresh: "Atualizar",
      sport: "Diagn\xF3stico do esporte",
      approximate: "Contagens aproximadas das estat\xEDsticas do planejador",
      outbox: "Fila de proje\xE7\xE3o",
      counts: {
        records: "Registros",
        versions: "Vers\xF5es",
        fixtures: "Partidas",
        teamMetrics: "M\xE9tricas de time",
        playerMetrics: "M\xE9tricas de jogador",
        quotes: "Cota\xE7\xF5es de odds"
      },
      tasks: "Fam\xEDlias de tarefas",
      noTasks: "Nenhuma tarefa agendada para este esporte.",
      family: "Fam\xEDlia",
      families: {
        leagues: "Ligas",
        seasons: "Temporadas",
        schedules: "Calend\xE1rios",
        teams: "Times",
        squads: "Elencos",
        standings: "Classifica\xE7\xF5es",
        "fixture-batches": "Lotes de partidas",
        odds: "Odds",
        "live-feeds": "Feeds ao vivo",
        games: "Jogos",
        stats: "Estat\xEDsticas",
        "box-scores": "S\xFAmulas",
        other: "Outros"
      },
      statuses: {
        pending: "Pendente",
        running: "Em execu\xE7\xE3o",
        complete: "Conclu\xEDda",
        failed: "Falhou",
        retired: "Aposentada",
        restricted: "Restrita"
      },
      oldestPending: "Pendente mais antiga",
      priority: "prioridade {{priority}}",
      feeds: "Feeds ao vivo",
      noFeeds: "Nenhum feed ao vivo agendado para este esporte.",
      endpoint: "Endpoint",
      cadence: "Cad\xEAncia",
      completedAgo: "conclu\xEDdo h\xE1 {{age}}",
      neverCompleted: "Nunca conclu\xEDdo",
      match: "Diagn\xF3stico de partida",
      matchDescription: "Cole o id da partida ou a URL da p\xE1gina para ver os dados de pesquisa armazenados.",
      matchId: "Id ou URL da partida",
      inspect: "Inspecionar",
      invalidId: "Cole o id de uma partida ou a URL da p\xE1gina da partida.",
      side: "Mando",
      team: "Time",
      storedFinishedBefore: "Encerradas antes",
      withTeamMetrics: "Com m\xE9tricas de time",
      withPlayerMetrics: "Com m\xE9tricas de jogador",
      lastMetric: "\xDAltima m\xE9trica armazenada",
      quotes: "Cota\xE7\xF5es de odds",
      pendingBatches: "Lotes de partidas pendentes",
      competition: "Competi\xE7\xE3o",
      none: "Nenhuma",
      provider: {
        title: "Status do provedor",
        description: "Baseado na atividade de ingest\xE3o do esporte selecionado. Atualize para consultar novamente.",
        statuses: {
          healthy: "Saud\xE1vel",
          issues: "Problemas detectados",
          stale: "Desatualizado",
          unknown: "Sem dados",
          not_configured: "N\xE3o configurado"
        },
        hints: {
          healthy: "Requisi\xE7\xF5es recentes bem-sucedidas, sem tarefas com falha ou restri\xE7\xE3o.",
          issues: "Revise as fam\xEDlias de tarefas com falha ou restri\xE7\xE3o abaixo. Requisi\xE7\xF5es restritas podem exigir altera\xE7\xF5es no acesso ou na assinatura do provedor.",
          stale: "Nenhuma requisi\xE7\xE3o bem-sucedida nos \xFAltimos 30 minutos. Verifique o worker e o provedor; a ingest\xE3o tamb\xE9m pode estar ociosa.",
          unknown: "Nenhuma requisi\xE7\xE3o bem-sucedida registrada. Verifique se a ingest\xE3o est\xE1 configurada e em execu\xE7\xE3o.",
          not_configured: "O worker informou que falta a configura\xE7\xE3o do provedor. Verifique as credenciais do provedor."
        },
        counts: "{{failed}} com falha \xB7 {{restricted}} restritas \xB7 {{parked}} pausadas",
        lastSuccess: "\xDAltimo sucesso: h\xE1 {{age}}",
        lastAttempt: "\xDAltima tentativa: h\xE1 {{age}}",
        noSuccess: "Nenhuma requisi\xE7\xE3o bem-sucedida registrada",
        noAttempt: "Nenhuma tentativa registrada"
      }
    },
    loginHistory: {
      title: "Hist\xF3rico de logins",
      description: "Logins bem-sucedidos, do mais recente ao mais antigo. A localiza\xE7\xE3o por IP \xE9 aproximada e pode indicar uma VPN ou operadora. O hist\xF3rico come\xE7a quando o registro \xE9 ativado.",
      empty: "Nenhum login registrado.",
      time: "Data e hora",
      location: "Localiza\xE7\xE3o aproximada",
      ip: "Endere\xE7o IP",
      browser: "Navegador / dispositivo",
      unavailable: "Indispon\xEDvel"
    }
  },
  matches: {
    title: "Partidas",
    locked: "Bloqueado",
    lockedTitle: "Acesso ao esporte necess\xE1rio",
    lockedDescription: "Sua conta n\xE3o tem acesso a este esporte. Escolha um esporte dispon\xEDvel no menu.",
    unavailableTitle: "Os dados das partidas ainda n\xE3o est\xE3o dispon\xEDveis",
    unavailableDescription: "Seu acesso est\xE1 ativo. A agenda e as an\xE1lises aparecer\xE3o aqui quando os dados esportivos estiverem conectados.",
    previousDay: "Dia anterior",
    nextDay: "Pr\xF3ximo dia",
    date: "Data",
    today: "Hoje",
    stale: "As atualiza\xE7\xF5es est\xE3o atrasadas. Estes s\xE3o os \xFAltimos resultados armazenados.",
    empty: "Nenhuma partida agendada para este dia.",
    loadingSchedule: "Carregando as partidas deste dia",
    timeUnknown: "Hor\xE1rio a confirmar",
    search: "Buscar por time",
    filters: {
      label: "Status",
      all: "Todos",
      upcoming: "Pr\xF3ximos",
      live: "Ao vivo",
      finished: "Encerrados"
    },
    allCompetitions: "Todas as competi\xE7\xF5es",
    competitions: {
      picker: "Competi\xE7\xF5es",
      search: "Buscar competi\xE7\xE3o",
      selected_zero: "{{count}} competi\xE7\xF5es",
      selected_one: "{{count}} competi\xE7\xE3o",
      selected_other: "{{count}} competi\xE7\xF5es"
    },
    favourite: "Favoritar",
    unfavourite: "Remover favorito",
    noResults: "Nenhuma partida corresponde a estes filtros.",
    clearFilters: "Limpar filtros",
    gamesCount_zero: "{{count}} jogos",
    gamesCount_one: "{{count}} jogo",
    gamesCount_other: "{{count}} jogos",
    collapseGroup: "Recolher",
    expandGroup: "Expandir",
    statuses: {
      scheduled: "Agendada",
      live: "Ao vivo",
      finished: "Encerrada",
      postponed: "Adiada",
      cancelled: "Cancelada",
      unknown: "Status indispon\xEDvel",
      suspended: "Suspensa",
      delayed: "Atrasada",
      abandoned: "Abandonada",
      awarded: "Decidida administrativamente"
    },
    notFound: "Partida n\xE3o encontrada",
    backToMatches: "Voltar para as partidas",
    venue: "Local",
    season: "Temporada",
    roundSuffix: ", rodada {{round}}",
    shootoutScore: "P\xEAnaltis {{home}} \u2013 {{away}}",
    pageTitle: "{{home}} x {{away}}",
    kickoff: "In\xEDcio",
    teams: "Times",
    team: "Time",
    sides: {
      home: "Mandante",
      draw: "Empate",
      away: "Visitante"
    },
    rankOrdinal: "{{rank}}\xBA",
    form: {
      label: "Forma recente",
      W: "V",
      D: "E",
      L: "D"
    },
    referee: "\xC1rbitro: {{name}}",
    refereeCards_zero: "{{cards}} cart\xF5es por partida ({{sample}} partidas)",
    refereeCards_one: "{{cards}} cart\xF5es por partida ({{sample}} partida)",
    refereeCards_other: "{{cards}} cart\xF5es por partida ({{sample}} partidas)",
    prices: {
      label: "Pre\xE7os",
      captured: "capturado em {{time}}"
    },
    total: "Total",
    winner: "Vencedor",
    periodScores: "Placar por tempo",
    overviewPending: {
      title: "Ainda n\xE3o h\xE1 registros desta partida",
      description: "Estat\xEDsticas e placares por per\xEDodo aparecem aqui quando o jogo come\xE7ar. A forma recente e os confrontos anteriores j\xE1 est\xE3o na an\xE1lise.",
      action: "Abrir a an\xE1lise"
    },
    openMatch: "{{home}} contra {{away}}",
    liveMinute: "{{minute}}'",
    periods: {
      q1: "Q1",
      q2: "Q2",
      q3: "Q3",
      q4: "Q4",
      ot: "Prorrog.",
      runs: "Corridas",
      hits: "Rebatidas",
      errors: "Erros",
      full: "Partida",
      first_half: "1\xBA tempo",
      half_time: "Intervalo",
      second_half: "2\xBA tempo",
      extra_time: "Prorroga\xE7\xE3o",
      penalties: "P\xEAnaltis"
    },
    sections: {
      label: "Se\xE7\xF5es da partida",
      overview: "Vis\xE3o geral",
      analysis: "An\xE1lise",
      players: "Jogadores",
      lines: "Linhas"
    },
    markets: {
      fulltime_result: "Resultado final",
      double_chance: "Dupla chance",
      draw_no_bet: "Empate anula aposta",
      match_goals: "Gols acima/abaixo",
      goals_over_under: "Gols acima/abaixo",
      goal_line: "Linha de gols",
      asian_handicap: "Handicap asi\xE1tico",
      both_teams_to_score: "Ambos marcam",
      half_time_result: "Resultado do 1\xBA tempo",
      "1st_half_goals": "Gols no 1\xBA tempo",
      home_team_goals: "Gols do mandante",
      away_team_goals: "Gols do visitante",
      corners: "Escanteios",
      cards: "Cart\xF5es"
    },
    lines: {
      disclaimer: "Os pre\xE7os s\xE3o da pr\xF3pria casa, capturados no hor\xE1rio indicado. A frequ\xEAncia hist\xF3rica n\xE3o \xE9 uma probabilidade.",
      empty: "Nenhum pre\xE7o de casa de apostas armazenado para esta partida ainda.",
      history: "{{hits}} de {{sample}} partidas acima da linha, hist\xF3rico",
      over: "Acima",
      under: "Abaixo",
      yes: "Sim",
      no: "N\xE3o",
      columns: {
        line: "Linha",
        side: "Sele\xE7\xE3o",
        price: "Pre\xE7o",
        opening: "Abertura",
        captured: "Captura",
        history: "Hist\xF3rico"
      }
    },
    players: {
      sample: "Partidas recentes",
      sampleCount_zero: "{{count}} partidas",
      sampleCount_one: "{{count}} partida",
      sampleCount_other: "{{count}} partidas",
      player: "Jogador",
      position: "Posi\xE7\xE3o",
      appearances: "Participa\xE7\xF5es",
      empty: "Ainda n\xE3o h\xE1 estat\xEDsticas de jogadores registradas para esta partida."
    },
    research: {
      noHistory: "Ainda n\xE3o h\xE1 partidas anteriores registradas para estes times."
    },
    statistics: {
      lead: "Resultados registrados por m\xE9trica para os filtros selecionados.",
      sampleFilter: "Partidas recentes",
      sampleOption: "\xDAltimas {{size}} partidas",
      venueFilter: "Mando de campo",
      venues: {
        all: "Casa e fora",
        home: "S\xF3 em casa",
        away: "S\xF3 fora"
      },
      periodFilter: "Tempo",
      columns: {
        metric: "M\xE9trica",
        mean: "M\xE9dia",
        variation: "Varia\xE7\xE3o",
        sample: "Amostra",
        values: "Valores recentes"
      },
      sample: "{{sampleSize}} de {{eligible}} partidas",
      sampleWithMissing: "{{sampleSize}} de {{eligible}} partidas, {{missing}} sem esta m\xE9trica",
      empty: "Ainda n\xE3o h\xE1 estat\xEDsticas de time registradas para este esporte.",
      match: {
        title: "Estat\xEDsticas da partida",
        period: "Per\xEDodo da partida"
      }
    },
    analysis: {
      loading: "Carregando a an\xE1lise",
      empty: "Nenhum jogo registrado para estes filtros.",
      filters: {
        sample: "Amostra",
        sampleOption: "{{size}} jogos",
        venue: "Mando",
        venues: {
          split: "Casa/Fora",
          all: "Todos",
          home: "Casa",
          away: "Fora"
        },
        competition: "Competi\xE7\xE3o",
        competitions: {
          all: "Todas"
        }
      },
      groups: {
        label: "Grupos de an\xE1lise",
        performance: "Desempenho",
        goals: "Gols",
        timing: "Minutos dos gols",
        corners: "Escanteios",
        shots: "Finaliza\xE7\xF5es",
        discipline: "Disciplina",
        odds: "Odds",
        head_to_head: "Confronto direto",
        projection: "Proje\xE7\xE3o",
        scoring: "Pontua\xE7\xE3o",
        team_stats: "Estat\xEDsticas do time"
      },
      periods: {
        full: "tempo integral",
        first_half: "primeiro tempo",
        second_half: "segundo tempo"
      },
      metrics: {
        goals: "gols",
        corners: "escanteios",
        yellow_cards: "cart\xF5es amarelos",
        points: "pontos",
        runs: "corridas"
      },
      blocks: {
        goalsScored: "Gols marcados",
        goalsConceded: "Gols sofridos",
        goalMarkets: "Taxas de over de gols",
        timingFor: "Gols marcados por minuto",
        timingAgainst: "Gols sofridos por minuto",
        expectedGoals: "Gols esperados",
        cornersFor: "Escanteios a favor",
        cornersAgainst: "Escanteios contra",
        cornersTotal: "Escanteios da partida",
        cornerMarkets: "Taxas de over de escanteios",
        shots: "Finaliza\xE7\xF5es",
        efficiency: "Aproveitamento ofensivo",
        discipline: "Cart\xF5es e faltas",
        cardMarkets: "Taxas de over de cart\xF5es",
        record: "Retrospecto do confronto",
        rates: "Taxas da partida",
        meetings: "Confrontos",
        projection: "Proje\xE7\xE3o",
        scoringFor: "{{metric}} a favor",
        scoringAgainst: "{{metric}} contra",
        scoringMarkets: "Taxas de over do total"
      },
      rows: {
        games: "Jogos",
        points: "Pontos",
        pointsRate: "Aproveitamento",
        won: "Vit\xF3rias",
        drawn: "Empates",
        lost: "Derrotas",
        form: "Forma",
        scoredFirst: "Marcou primeiro",
        wonFirstHalf: "Vencendo no intervalo",
        btts: "Ambas marcam",
        cleanSheet: "N\xE3o sofreu gol",
        failedToScore: "N\xE3o marcou",
        scoreFor: "Pontos a favor",
        scoreAgainst: "Pontos contra",
        mean: "M\xE9dia",
        cv: "CV",
        median: "Mediana",
        p75: "P75",
        goalsScored: "Gols marcados, {{period}}",
        goalsConceded: "Gols sofridos, {{period}}",
        over: "Over {{line}} {{metric}}, {{period}}",
        teamOver: "Time over {{line}} {{metric}}, {{period}}",
        perGame: "Por jogo, {{period}}",
        cornersFor: "Escanteios a favor, {{period}}",
        cornersAgainst: "Escanteios contra, {{period}}",
        cornersTotal: "Escanteios da partida, {{period}}",
        metricFor: "{{metric}} a favor",
        metricAgainst: "{{metric}} contra",
        shotsPerGoal: "Finaliza\xE7\xF5es por gol",
        shotsOnTargetPerGoal: "Finaliza\xE7\xF5es no alvo por gol",
        conversion: "Convers\xE3o",
        expectedFor: "Gols esperados a favor",
        expectedAgainst: "Gols esperados contra",
        draws: "Empates {{drawn}}",
        meanGoals: "M\xE9dia de gols",
        meanCorners: "M\xE9dia de escanteios",
        over25: "Over 2.5 gols",
        produced: "Produz",
        opponentConceded: "Advers\xE1rio sofre",
        projection: "Proje\xE7\xE3o",
        pricedGames: "Jogos com odd de fechamento",
        averagePrice: "Odd m\xE9dia",
        impliedProbability: "Probabilidade impl\xEDcita",
        winRate: "Taxa de vit\xF3rias",
        profit: "Lucro e preju\xEDzo",
        roi: "Retorno sobre investimento",
        scoringFor: "{{metric}} a favor, {{period}}",
        scoringAgainst: "{{metric}} contra, {{period}}",
        spreadCover: "Cobertura do handicap",
        totalOver: "Over do total"
      },
      odds: {
        empty: "As odds de fechamento existem para jogos a partir da temporada 2025-26",
        profitSummary: "Lucro acumulado em {{count}} jogos com odd, terminando em {{total}} unidades",
        columns: {
          date: "Data",
          opponent: "Advers\xE1rio",
          result: "Resultado",
          price: "Odd de fechamento",
          profit: "Lucro e preju\xEDzo"
        }
      },
      headToHead: {
        empty: "Nenhum confronto nesta amostra",
        columns: {
          date: "Data",
          competition: "Competi\xE7\xE3o",
          score: "Placar",
          corners: "Escanteios",
          cards: "Cart\xF5es"
        }
      },
      projection: {
        formula: "Proje\xE7\xE3o = (produ\xE7\xE3o do time + gols sofridos pelo advers\xE1rio) / 2, na amostra selecionada"
      }
    }
  },
  teams: {
    latestStanding: "Classifica\xE7\xE3o mais recente",
    viewHistory: "Ver hist\xF3rico de temporadas",
    seasonHistory: "Hist\xF3rico de temporadas",
    historyDescription: "\xDAltima classifica\xE7\xE3o dispon\xEDvel de cada temporada e grupo.",
    noHistory: "Ainda n\xE3o h\xE1 classifica\xE7\xF5es de temporadas dispon\xEDveis.",
    loaded_zero: "{{formattedCount}} equipes carregadas",
    loaded_one: "{{formattedCount}} equipe carregada",
    loaded_other: "{{formattedCount}} equipes carregadas",
    clearFilters: "Limpar filtros",
    noResultsDescription: "Tente outro nome de equipe ou limpe os filtros.",
    title: "Times",
    search: "Buscar times",
    competition: "Competi\xE7\xE3o",
    allCompetitions: "Todas as competi\xE7\xF5es",
    empty: "Nenhum time encontrado.",
    notFound: "Time n\xE3o encontrado",
    backToTeams: "Voltar aos times",
    sections: {
      standings: "Classifica\xE7\xE3o",
      label: "Se\xE7\xF5es do time",
      overview: "Vis\xE3o geral",
      statistics: "Estat\xEDsticas",
      fixtures: "Jogos",
      players: "Jogadores"
    },
    standing: "Classifica\xE7\xE3o",
    noStanding: "Ainda n\xE3o h\xE1 classifica\xE7\xE3o para este time.",
    position: "Posi\xE7\xE3o",
    played: "Partidas",
    won: "Vit\xF3rias",
    drawn: "Empates",
    lost: "Derrotas",
    points: "Pontos",
    group: "Grupo",
    form: "Forma recente",
    results: {
      won: "V",
      lost: "D",
      drawn: "E"
    },
    liveMatch: "Ao vivo agora",
    nextMatch: "Pr\xF3xima partida",
    lastMatch: "\xDAltima partida",
    noNextMatch: "Nenhuma partida agendada.",
    noLastMatch: "Nenhuma partida encerrada.",
    season: "Temporada",
    seasonOption: "{{competition}} \xB7 {{season}}",
    noFixtures: "Nenhum jogo nesta temporada.",
    player: "Jogador",
    appearances: "Participa\xE7\xF5es",
    lastPlayed: "\xDAltimo jogo",
    noPlayers: "Ainda n\xE3o h\xE1 jogadores registrados para este time.",
    analysis: {
      empty: "Nenhuma partida encerrada corresponde a estes filtros.",
      competition: "Competi\xE7\xE3o",
      allCompetitions: "Todas as competi\xE7\xF5es",
      efficiency: "Aproveitamento",
      points: "Pontos",
      record: "Hist\xF3rico",
      sample_zero: "{{count}} jogos analisados",
      sample_one: "{{count}} jogo analisado",
      sample_other: "{{count}} jogos analisados",
      scoredSample: "Resultados dispon\xEDveis: {{count}}",
      form: "Forma recente",
      full: "Partida",
      first_half: "1\xBA tempo",
      averages: "M\xE9dias por jogo",
      for: "Pr\xF3",
      against: "Contra",
      total: "Total",
      trend: "Tend\xEAncia: \xFAltimos tr\xEAs jogos comparados \xE0 m\xE9dia da amostra.",
      coverage: "Dispon\xEDvel em {{count}} de {{total}} jogos",
      homeAway: "Casa \xD7 fora",
      home: "Casa",
      away: "Fora",
      frequencies: "Frequ\xEAncias hist\xF3ricas",
      markets: "Frequ\xEAncias hist\xF3ricas de mercados",
      historicalNote: "Frequ\xEAncias hist\xF3ricas, n\xE3o previs\xF5es. Estat\xEDsticas ausentes s\xE3o exclu\xEDdas de cada c\xE1lculo.",
      over: "Mais de {{line}} \xB7 {{metric}}",
      btts: "Ambos marcaram",
      clean_sheet: "Sem sofrer gols",
      failed_to_score: "Sem marcar",
      scored_first: "Primeiro a marcar",
      won_first_half: "Venceu o 1\xBA tempo",
      recent: "\xDAltimos cinco jogos",
      opponent: "Advers\xE1rio",
      matrix: "Estat\xEDsticas jogo a jogo",
      indicator: "Indicador",
      mean: "M\xE9d.",
      cv: "CV",
      cvHelp: "O CV mede a varia\xE7\xE3o em rela\xE7\xE3o \xE0 m\xE9dia; valores menores indicam resultados mais consistentes.",
      available: "Amostra",
      all: "Todos",
      category: "Categoria de estat\xEDstica",
      period: "Tempo",
      won: "V",
      drawn: "E",
      lost: "D",
      unknown: "Resultado desconhecido",
      score: "Placar",
      yellowCardsNote: "Os limites de cart\xF5es usam os amarelos dos dois times. Os vermelhos aparecem separadamente em Estat\xEDsticas."
    }
  },
  players: {
    title: "Jogadores",
    search: "Buscar jogadores",
    player: "Jogador",
    position: "Posi\xE7\xE3o",
    team: "Time",
    allTeams: "Todos os times",
    searchTeams: "Buscar times",
    noTeams: "Nenhum time encontrado.",
    empty: "Nenhum jogador encontrado.",
    notFound: "Jogador n\xE3o encontrado",
    backToPlayers: "Voltar aos jogadores",
    averages: "M\xE9dias",
    sections: {
      label: "Se\xE7\xF5es do jogador"
    },
    gameLog: "Hist\xF3rico de jogos",
    formerTeam: "Time anterior",
    appearances_zero: "{{appearances}} jogos registrados",
    appearances_one: "{{appearances}} jogo registrado",
    appearances_other: "{{appearances}} jogos registrados",
    opponent: "Advers\xE1rio",
    noGames: "Ainda n\xE3o h\xE1 jogos registrados para este jogador.",
    sample: {
      label: "Jogos recentes",
      option: "\xDAltimos {{size}} jogos",
      all: "Todos os jogos"
    },
    analysis: {
      title: "An\xE1lise do jogador",
      overview: "Vis\xE3o geral",
      statistics: "Estat\xEDsticas",
      role: "Participa\xE7\xE3o",
      allRoles: "Todas as participa\xE7\xF5es",
      starter: "Titular",
      substitute: "Reserva utilizado",
      unknown: "Desconhecido",
      minMinutes: "Minutos m\xEDnimos",
      empty: "Nenhuma participa\xE7\xE3o corresponde a estes filtros.",
      frequencies: "Frequ\xEAncias hist\xF3ricas do jogador",
      recent: "Participa\xE7\xF5es recentes",
      matrix: "Estat\xEDsticas do jogador por partida",
      per90: "Por 90",
      starts: "Como titular",
      minutes: "Minutos jogados",
      coverage: "Cobertura dos dados",
      methodology: "Os valores por 90 usam apenas partidas com a estat\xEDstica e os minutos registrados. Valores ausentes s\xE3o exclu\xEDdos. As frequ\xEAncias descrevem participa\xE7\xF5es passadas, n\xE3o previs\xF5es.",
      over: "Acima de {{line}} \xB7 {{metric}}",
      all: "Todos",
      attack: "Ataque",
      creation: "Cria\xE7\xE3o",
      defense: "Defesa",
      discipline: "Disciplina",
      goalkeeping: "Goleiro",
      trend: "\xDAltimas 3 vs amostra",
      per36: "Por 36",
      per9: "Por 9 entradas",
      scoring: "Pontua\xE7\xE3o",
      rebounding: "Rebotes",
      advanced: "Avan\xE7adas",
      passing: "Passes",
      rushing: "Corridas",
      receiving: "Recep\xE7\xF5es",
      batting: "Rebatidas",
      pitching: "Arremessos",
      batter: "Rebatedor",
      pitcher: "Arremessador",
      battingOrder: "Ordem de rebatida",
      sportMethodology: "M\xE9dias e frequ\xEAncias hist\xF3ricas excluem valores ausentes. As taxas da NBA usam 36 minutos; as de arremesso da MLB usam nove entradas, apenas com partidas que registram a estat\xEDstica e o tempo jogado. As frequ\xEAncias descrevem jogos passados, n\xE3o previs\xF5es."
    }
  },
  footer: {
    message: "Apenas para maiores de 18 anos. Aposte com responsabilidade.",
    responsibility: "Apostas envolvem risco financeiro real. Nunca aposte dinheiro que voc\xEA n\xE3o pode perder.",
    independent: "O Pick Pro \xE9 um servi\xE7o independente de pesquisa esportiva. N\xE3o recebe apostas, n\xE3o mant\xE9m dep\xF3sitos para apostas e n\xE3o paga pr\xEAmios. Qualquer aposta \xE9 realizada separadamente com uma operadora externa.",
    noIncome: "Aposta n\xE3o \xE9 investimento nem fonte de renda. Estat\xEDsticas e sugest\xF5es n\xE3o garantem retorno. Voc\xEA pode perder todo o valor apostado.",
    help: "Se as apostas estiverem afetando voc\xEA, busque apoio no SUS, em uma UBS ou CAPS. Tamb\xE9m \xE9 poss\xEDvel solicitar a autoexclus\xE3o das plataformas autorizadas em \xE2mbito federal.",
    resources: "Recursos de jogo respons\xE1vel no Brasil",
    selfExclusion: "Autoexclus\xE3o \xB7 GOV.BR",
    healthSupport: "Apoio \xE0 sa\xFAde \xB7 SUS",
    authorized: "Consultar operadoras autorizadas \xB7 SPA",
    regulation: "Regulamenta\xE7\xE3o brasileira de apostas",
    tagline: "Uma vis\xE3o mais clara do jogo. Pesquisa com contexto, do seu jeito.",
    product: "Explore",
    transparency: "Transpar\xEAncia",
    support: "Apoio e prote\xE7\xE3o",
    rights: "Todos os direitos reservados."
  },
  landing: {
    meta: {
      title: "Pesquisa esportiva com odds reais",
      description: "Hist\xF3rico de times e jogadores ao lado das linhas reais das casas de apostas, para futebol, NBA, NFL e MLB. Suas {{freeScans}} primeiras an\xE1lises s\xE3o gr\xE1tis."
    },
    hero: {
      title: "Pesquise a partida. Compare a linha. Decida por voc\xEA.",
      description: "Hist\xF3rico de times e jogadores ao lado da linha real da casa de apostas, com o hor\xE1rio em que foi capturada. Futebol, NBA, NFL e MLB.",
      primaryAction: "Comece com {{freeScans}} an\xE1lises gr\xE1tis",
      offer: "Sem cart\xE3o. Depois, {{base}} por m\xEAs, cancele quando quiser.",
      caption: "O Flamengo passou de 9,5 escanteios em {{hits}} dos \xFAltimos {{known}} jogos. A linha ofereceu {{price}}, capturada antes do in\xEDcio. O hist\xF3rico e a linha lado a lado. A decis\xE3o \xE9 sua.",
      secondaryAction: "Como funciona",
      responsibility: "Para maiores de 18 anos. Apostar envolve risco financeiro."
    },
    how: {
      title: "Da partida \xE0 decis\xE3o informada",
      description: "Acompanhe as evid\xEAncias sem transformar desempenho passado em previs\xE3o.",
      steps: {
        research: {
          title: "Fa\xE7a a an\xE1lise do dia",
          description: "Uma an\xE1lise roda o Radar ou o Pick Pro sobre os jogos de um esporte e lista as sele\xE7\xF5es com o hist\xF3rico recente de cada uma."
        },
        compare: {
          title: "Compare a linha real",
          description: "Mercado, linha e hor\xE1rio de captura ficam ao lado do hist\xF3rico."
        },
        track: {
          title: "Salve e acompanhe o resultado",
          description: "Sele\xE7\xF5es salvas e acompanhamento de resultados re\xFAnem todo o ciclo em um s\xF3 lugar."
        }
      }
    },
    honesty: {
      title: "Hist\xF3rico continua sendo hist\xF3rico.",
      description: "Uma frequ\xEAncia hist\xF3rica descreve o que aconteceu em uma amostra definida e nunca o que vem a seguir, por isso aqui n\xE3o h\xE1 palpites: a leitura e a decis\xE3o s\xE3o suas."
    },
    faq: {
      title: "A vers\xE3o curta",
      items: {
        bettingSite: {
          question: "Este \xE9 um site de apostas?",
          answer: "N\xE3o. \xC9 um produto independente de pesquisa esportiva. N\xE3o \xE9 poss\xEDvel fazer apostas aqui."
        },
        guarantees: {
          question: "Voc\xEAs garantem resultados?",
          answer: "N\xE3o. O esporte \xE9 incerto, o hist\xF3rico n\xE3o prev\xEA resultados futuros e nenhum resultado \xE9 garantido."
        },
        scans: {
          question: "O que conta como an\xE1lise?",
          answer: "Uma an\xE1lise roda o Radar ou o Pick Pro sobre os jogos do dia de um esporte. As {{freeScans}} primeiras s\xE3o gr\xE1tis. O plano inclui {{monthlyScans}} por m\xEAs, somando todos os seus esportes."
        },
        leagues: {
          question: "Quais ligas est\xE3o inclu\xEDdas?",
          answer: "Futebol, NBA, NFL e MLB est\xE3o cobertos. A disponibilidade depende do lan\xE7amento de cada esporte e da cobertura de dados."
        },
        free: {
          question: "Como funciona o pre\xE7o?",
          answer: "Suas {{freeScans}} primeiras an\xE1lises s\xE3o gr\xE1tis, sem cart\xE3o. Depois, escolha um esporte principal por {{base}} por m\xEAs e adicione esportes por {{additional}} cada: dois esportes somam {{two}} e tr\xEAs somam {{three}}. Todo plano inclui {{monthlyScans}} an\xE1lises por m\xEAs, somando todos os seus esportes. Os valores s\xE3o em reais. Cancele quando quiser."
        }
      }
    },
    sports: {
      football: "Futebol",
      nba: "NBA",
      nfl: "NFL",
      mlb: "MLB"
    },
    closing: {
      title: "Comece com {{freeScans}} an\xE1lises gr\xE1tis.",
      description: "Sem cart\xE3o. O plano s\xF3 come\xE7a quando voc\xEA escolher."
    },
    pricing: {
      title: "{{freeScans}} an\xE1lises gr\xE1tis. Depois, um plano para os seus esportes.",
      description: "Escolha seu esporte principal e adicione os que voc\xEA quer acompanhar. Uma mensalidade em reais, com {{monthlyScans}} an\xE1lises por m\xEAs inclu\xEDdas.",
      base: "por m\xEAs por um esporte",
      extra: "por m\xEAs para cada esporte adicional",
      mainSport: "Escolha seu esporte principal",
      extraSports: "Adicione esportes extras (opcional)",
      total: "Sua mensalidade",
      perMonth: "/m\xEAs",
      included: "Inclui {{monthlyScans}} an\xE1lises por m\xEAs, somando todos os seus esportes. Cancele quando quiser."
    }
  },
  legal: {
    back: "Voltar ao Pick Pro",
    updated: "\xDAltima revis\xE3o:",
    contents: "Nesta p\xE1gina",
    resources: "Recursos oficiais",
    draftTitle: "Minuta para revis\xE3o",
    draftDescription: "Este documento ainda n\xE3o \xE9 definitivo. A identifica\xE7\xE3o legal do fornecedor, os contatos p\xFAblicos e os procedimentos operacionais precisam ser confirmados antes da abertura das assinaturas.",
    terms: {
      title: "Termos de Uso",
      description: "O escopo do servi\xE7o, suas responsabilidades e as condi\xE7\xF5es de uso do Pick Pro.",
      sections: {
        scope: {
          title: "Sobre o servi\xE7o",
          body: "O Pick Pro \xE9 um produto independente de pesquisa esportiva. Apresenta informa\xE7\xF5es, estat\xEDsticas e ferramentas de an\xE1lise. N\xE3o aceita nem executa apostas, n\xE3o guarda dep\xF3sitos para apostas nem paga pr\xEAmios. Bancas e registros de apostas s\xE3o ferramentas de acompanhamento. Uma operadora externa \xE9 respons\xE1vel por qualquer aposta feita nela. Esta minuta descreve o servi\xE7o atual e o modelo de assinatura previsto."
        },
        access: {
          title: "Idade e acesso",
          body: "O servi\xE7o \xE9 destinado a pessoas com 18 anos ou mais. N\xE3o o utilize se voc\xEA for menor de 18 anos ou se o acesso for proibido onde mora. Toda conta inclui {{freeScans}} an\xE1lises gr\xE1tis. Depois disso, as ferramentas de pesquisa s\xE3o liberadas por esporte, conforme o plano da conta. O cadastro n\xE3o cria uma assinatura paga. A cobran\xE7a autom\xE1tica ainda n\xE3o est\xE1 ativa."
        },
        use: {
          title: "Uso permitido",
          body: "Utilize o servi\xE7o de forma l\xEDcita para sua pesquisa. N\xE3o interfira na seguran\xE7a, tente acessos n\xE3o autorizados, utilize dados pessoais indevidamente, redistribua bases licenciadas sem autoriza\xE7\xE3o nem manipule eventos esportivos. Os direitos sobre software, marca e conte\xFAdo pertencem aos respectivos titulares, preservados seus direitos e usos permitidos por lei."
        },
        payments: {
          title: "Mensalidade e cobran\xE7a",
          body: "A assinatura prevista custa {{base}} por m\xEAs para um esporte principal \xE0 sua escolha, mais {{additional}} mensais por esporte adicional. Os valores s\xE3o em reais. A calculadora n\xE3o processa pagamentos. Antes da contrata\xE7\xE3o, o checkout dever\xE1 identificar fornecedor, esportes dispon\xEDveis, total recorrente, renova\xE7\xE3o e cancelamento. Adicionais exigem sele\xE7\xE3o expressa. N\xE3o h\xE1 pacotes dispon\xEDveis."
        },
        rights: {
          title: "Cancelamento e direitos do consumidor",
          body: "Os canais de cancelamento e reembolso dever\xE3o ser apresentados antes da compra. S\xE3o preservados os direitos da legisla\xE7\xE3o de consumo, inclusive o arrependimento em sete dias nas contrata\xE7\xF5es a dist\xE2ncia abrangidas pela lei. Nenhuma cl\xE1usula limita reembolsos obrigat\xF3rios, medidas legais ou acesso \xE0 defesa do consumidor. A demonstra\xE7\xE3o ainda n\xE3o oferece gest\xE3o de assinatura ou reembolso."
        },
        responsibility: {
          title: "Limites da pesquisa e responsabilidade",
          body: "Frequ\xEAncias hist\xF3ricas n\xE3o garantem resultados futuros. Dados e cota\xE7\xF5es podem mudar ou conter erros. Confira a fonte, o hor\xE1rio de captura e as condi\xE7\xF5es reais da operadora antes de decidir. Apostar pode causar depend\xEAncia e perda de todo o valor apostado. Estes termos n\xE3o afastam responsabilidades legais obrigat\xF3rias nem transferem ao consumidor a responsabilidade por defeitos do servi\xE7o."
        },
        changes: {
          title: "Altera\xE7\xF5es e conflitos",
          body: "Mudan\xE7as relevantes dever\xE3o ser comunicadas com clareza, sem retirar retroativamente direitos adquiridos. Limita\xE7\xF5es de acesso por seguran\xE7a, manuten\xE7\xE3o ou uso il\xEDcito devem respeitar a prote\xE7\xE3o do consumidor. A legisla\xE7\xE3o brasileira rege a oferta no Brasil, sem afastar outras prote\xE7\xF5es obrigat\xF3rias. \xC9 preservado o acesso ao ju\xEDzo competente, inclusive ao foro do domic\xEDlio do consumidor nos casos previstos em lei."
        },
        contact: {
          title: "Fornecedor e contato",
          body: "Nome legal ou raz\xE3o social, CNPJ/CPF quando aplic\xE1vel, endere\xE7o comercial e contato p\xFAblico de atendimento est\xE3o pendentes de confirma\xE7\xE3o. Por isso, estes termos permanecem como minuta. Esses dados e um canal efetivo dever\xE3o ser publicados antes da abertura das assinaturas. N\xE3o envie documentos ou dados sens\xEDveis a contatos n\xE3o verificados."
        }
      }
    },
    privacy: {
      title: "Pol\xEDtica de Privacidade",
      description: "Como o acesso \xE0 conta, as prefer\xEAncias e os estudos salvos s\xE3o tratados.",
      sections: {
        scope: {
          title: "Controlador e abrang\xEAncia",
          body: "Esta minuta abrange as p\xE1ginas p\xFAblicas e as ferramentas de pesquisa autenticadas do Pick Pro. A identidade jur\xEDdica, o endere\xE7o e o contato de privacidade do controlador ainda aguardam confirma\xE7\xE3o. Casas de apostas e servi\xE7os externos t\xEAm seus pr\xF3prios avisos de privacidade."
        },
        access: {
          title: "Dados da demonstra\xE7\xE3o",
          body: "O cadastro coleta seu e-mail e sua senha, armazenada como hash. Sua conta guarda o status de verifica\xE7\xE3o e acesso e as prefer\xEAncias de idioma, fuso hor\xE1rio e formato de odds. Ao usar as ferramentas de pesquisa e acompanhamento, armazenamos sele\xE7\xF5es salvas, bilhetes, bancas e registros de apostas. Os registros de login e sess\xE3o incluem informa\xE7\xF5es t\xE9cnicas como endere\xE7o IP, navegador e hor\xE1rios de acesso. A calculadora de pre\xE7os n\xE3o processa pagamentos."
        },
        use: {
          title: "Finalidades e bases legais",
          body: "Dados de conta e sess\xE3o permitem login, verifica\xE7\xE3o de e-mail, recupera\xE7\xE3o de senha e controle de acesso. As prefer\xEAncias personalizam a interface. Estudos salvos e registros de acompanhamento permitem revisitar sele\xE7\xF5es e resultados. O registro de tratamento e as bases legais ainda aguardam confirma\xE7\xE3o operacional. Navegar n\xE3o autoriza rastreamento opcional, publicidade ou marketing."
        },
        payments: {
          title: "Armazenamento e cookies",
          body: "O login usa os cookies pickpro_access e pickpro_refresh para autentica\xE7\xE3o e pickpro_session para indicar uma sess\xE3o \xE0 interface. As prefer\xEAncias tamb\xE9m s\xE3o armazenadas localmente em pickpro.preferences e permanecem at\xE9 serem alteradas ou apagadas. O aplicativo n\xE3o instala pixels publicit\xE1rios nem scripts de an\xE1lise de audi\xEAncia. Cookies de infraestrutura, se habilitados, devem ser inventariados separadamente."
        },
        rights: {
          title: "Seus direitos",
          body: "Nos casos aplic\xE1veis da LGPD, voc\xEA pode solicitar confirma\xE7\xE3o, acesso, corre\xE7\xE3o, informa\xE7\xE3o sobre compartilhamento, anonimiza\xE7\xE3o ou elimina\xE7\xE3o de dados desnecess\xE1rios ou il\xEDcitos, portabilidade conforme as regras e revoga\xE7\xE3o do consentimento. Tamb\xE9m pode contestar tratamentos irregulares e pedir revis\xE3o de decis\xF5es automatizadas nos casos previstos. O canal p\xFAblico de solicita\xE7\xF5es est\xE1 pendente de confirma\xE7\xE3o. Voc\xEA pode gerenciar dados locais pelo navegador e recorrer \xE0 ANPD ou \xE0 defesa do consumidor."
        },
        responsibility: {
          title: "Fornecedores e seguran\xE7a",
          body: "Hospedagem e rede recebem informa\xE7\xF5es das requisi\xE7\xF5es, que podem incluir IP, navegador, caminho solicitado e hor\xE1rio. Fornecedores, pa\xEDses, salvaguardas e prazos precisam ser confirmados na implanta\xE7\xE3o real. Devem existir controles de acesso, transporte protegido e procedimentos de incidentes; nenhum sistema \xE9 isento de riscos. Transfer\xEAncias internacionais, se houver, exigem mecanismo v\xE1lido da LGPD e divulga\xE7\xE3o correspondente; esta minuta n\xE3o certifica um mecanismo j\xE1 implementado."
        },
        changes: {
          title: "Reten\xE7\xE3o e evolu\xE7\xE3o",
          body: "Dados de conta, estudos salvos e registros de acompanhamento persistem para manter seu hist\xF3rico. Voc\xEA pode remover itens salvos e solicitar a exclus\xE3o da conta em Configura\xE7\xF5es. Os prazos de reten\xE7\xE3o em servidores, registros de seguran\xE7a e backups e a exclus\xE3o dos backups ainda aguardam confirma\xE7\xE3o. A cobran\xE7a autom\xE1tica ainda n\xE3o est\xE1 ativa; o processamento de pagamentos exigir\xE1 um aviso atualizado antes da ativa\xE7\xE3o."
        },
        contact: {
          title: "Contato, menores e altera\xE7\xF5es",
          body: "O servi\xE7o \xE9 destinado a adultos. O contato funcional de privacidade, procedimentos para solicita\xE7\xF5es e relatos envolvendo menores e identifica\xE7\xE3o do controlador dever\xE3o ser inclu\xEDdos antes da vers\xE3o definitiva. Mudan\xE7as relevantes em finalidades, destinat\xE1rios ou escolhas ser\xE3o informadas. Atualizar a pol\xEDtica n\xE3o fornece consentimento para um novo uso opcional."
        }
      }
    },
    responsible: {
      title: "Jogo respons\xE1vel",
      description: "Pesquisar pode trazer contexto. N\xE3o elimina os riscos de apostar.",
      sections: {
        scope: {
          title: "Pesquisa independente",
          body: "O Pick Pro n\xE3o recebe apostas, n\xE3o mant\xE9m dep\xF3sitos para apostas e n\xE3o paga pr\xEAmios. Qualquer aposta ocorre separadamente com uma operadora externa. A mensalidade \xE9 pelo software de pesquisa, n\xE3o por cr\xE9ditos para apostar."
        },
        access: {
          title: "Somente para adultos",
          body: "O servi\xE7o \xE9 destinado a maiores de 18 anos. Operadoras t\xEAm verifica\xE7\xF5es e impedimentos legais pr\xF3prios; ser adulto ou usar o Pick Pro n\xE3o comprova elegibilidade para apostar."
        },
        use: {
          title: "N\xFAmeros com contexto",
          body: "Confira tamanho e per\xEDodo da amostra, registros ausentes e hor\xE1rio de captura de cota\xE7\xF5es. Frequ\xEAncia hist\xF3rica alta n\xE3o garante resultado. Dados de exemplo s\xE3o ilustrativos; sugest\xF5es n\xE3o s\xE3o promessas de lucro."
        },
        payments: {
          title: "Dinheiro e tempo",
          body: "Aposta n\xE3o \xE9 investimento, substituto de trabalho ou solu\xE7\xE3o para d\xEDvidas. Voc\xEA pode perder todo o valor. N\xE3o use recursos de necessidades essenciais, n\xE3o tome empr\xE9stimos para apostar nem aumente valores para recuperar perdas. Defina limites e pare se as apostas estiverem afetando sua vida."
        },
        rights: {
          title: "Autoexclus\xE3o centralizada",
          body: "O Governo oferece bloqueio volunt\xE1rio das plataformas autorizadas em \xE2mbito federal pela SPA, por prazo escolhido ou indeterminado. Use o link GOV.BR abaixo. Isso n\xE3o exclui automaticamente dados do Pick Pro nem cancela uma assinatura separada de pesquisa."
        },
        responsibility: {
          title: "Apoio \xE0 sa\xFAde",
          body: "Se as apostas afetarem seu bem-estar ou relacionamentos, busque apoio no SUS, em UBS ou CAPS. Familiares tamb\xE9m podem buscar orienta\xE7\xE3o. O link do Minist\xE9rio da Sa\xFAde abaixo apresenta os canais atuais."
        },
        changes: {
          title: "Operadoras externas",
          body: "Se decidir apostar, confira a operadora e o dom\xEDnio exato na lista atual da SPA para servi\xE7os autorizados em \xE2mbito federal. Uma marca em exemplo de pesquisa n\xE3o \xE9 recomenda\xE7\xE3o nem prova de autoriza\xE7\xE3o de um link. N\xE3o confie apenas em logotipos ou publicidade."
        },
        contact: {
          title: "Informa\xE7\xE3o oficial",
          body: "Os links abaixo levam a servi\xE7os governamentais de autoexclus\xE3o, sa\xFAde, consulta de operadoras e regulamenta\xE7\xE3o, com termos e privacidade pr\xF3prios. O Pick Pro n\xE3o representa o Governo nem afirma que esses links constituam aprova\xE7\xE3o regulat\xF3ria."
        }
      }
    }
  },
  radar: {
    title: "Radar {{sport}}",
    matches: "Partidas",
    players: "Jogadores",
    search: "Buscar partidas e jogadores",
    searchPlaceholder: "Time, jogador ou competi\xE7\xE3o",
    date: "Dia",
    market: "Mercado",
    sort: "Ordenar por",
    probability: "Probabilidade do modelo",
    ev: "EV estimado",
    fairOdds: "Odd justa",
    offeredOdds: "Odd dispon\xEDvel",
    oddsUpdated: "Odd atualizada",
    analyzeMatch: "Analisar partida",
    analyzePlayer: "Analisar jogador",
    error: "N\xE3o foi poss\xEDvel carregar o Radar",
    empty: "Nenhuma sele\xE7\xE3o encontrada",
    emptyDescription: "Tente outro dia ou ajuste os filtros.",
    noFixtures: "Nenhuma partida futura neste dia",
    noFixturesDescription: "Escolha outro dia para explorar {{sport}}.",
    loading: "Carregando Radar",
    loadingMore: "Carregando mais",
    count_zero: "{{count}} sele\xE7\xF5es",
    count_one: "{{count}} sele\xE7\xE3o",
    count_other: "{{count}} sele\xE7\xF5es",
    coverage: "{{analyzed}} de {{total}} partidas t\xEAm dados e odds utiliz\xE1veis para os mercados selecionados",
    showMore: "Mostrar mais",
    reset: "Limpar filtros",
    historical: "Desempenho recente",
    minutes: "M\xE9dia de minutos",
    average: "M\xE9dia",
    sample_zero: "\xDAltimas {{count}} atua\xE7\xF5es",
    sample_one: "\xDAltima {{count}} atua\xE7\xE3o",
    sample_other: "\xDAltimas {{count}} atua\xE7\xF5es",
    unknown: "N\xE3o registrado",
    over: "Acima de {{line}}",
    milestone: "{{count}}+",
    opening: "Pre\xE7o de abertura",
    quarters: "Por per\xEDodo",
    lineup: {
      battingOrder: "Bate em {{order}}\xBA",
      probablePitcher: "Arremessador prov\xE1vel"
    },
    lineupStatus: {
      starter: "Titular",
      bench: "Reserva",
      absent: "Fora da escala\xE7\xE3o",
      expected: "Prov\xE1vel titular",
      pending: "Escala\xE7\xE3o pendente"
    },
    lineupStatusHint: {
      expected: "Escala\xE7\xE3o prov\xE1vel, ainda n\xE3o confirmada.",
      pending: "A escala\xE7\xE3o ainda n\xE3o saiu. O jogador pode n\xE3o come\xE7ar jogando."
    },
    availability: {
      out: "Fora",
      doubtful: "Muito duvidoso",
      questionable: "Duvidoso",
      day_to_day: "Dia a dia",
      probable: "Prov\xE1vel",
      active: "Ativo"
    },
    versus: {
      title: "Confronto",
      line: "vs {{opponent}}: {{hits}}/{{atBats}}, {{homeRuns}} HR, {{strikeouts}} K",
      plateAppearances: "Apari\xE7\xF5es no bast\xE3o",
      atBats: "Turnos ao bast\xE3o",
      hits: "Rebatidas",
      homeRuns: "Home runs",
      strikeouts: "Strikeouts",
      walks: "Bases por bolas",
      avg: "AVG",
      ops: "OPS"
    },
    splits: {
      title: "Splits",
      home: "Em casa",
      away: "Fora",
      versusLeft: "vs canhoto",
      versusRight: "vs destro",
      last15: "\xDAltimos 15 dias",
      versusOpponent: "vs {{opponent}}",
      avgLine: "AVG {{avg}}",
      opsLine: "OPS {{ops}}",
      avg: "AVG",
      ops: "OPS",
      homeRuns: "Home runs",
      strikeouts: "Strikeouts",
      atBats: "Turnos ao bast\xE3o",
      empty: "Nenhum split publicado."
    },
    full: "Partida",
    first_half: "Primeiro tempo",
    markets: {
      result: "Resultado da partida",
      goals: "Gols",
      corners: "Escanteios",
      btts: "Ambas marcam",
      shots: "Finaliza\xE7\xF5es",
      shots_on_target: "Chutes no alvo",
      cards: "Cart\xF5es"
    },
    sides: {
      home: "Vit\xF3ria da casa",
      draw: "Empate",
      away: "Vit\xF3ria de fora",
      over: "Acima de",
      under: "Abaixo de",
      yes: "Sim",
      no: "N\xE3o"
    },
    filters: {
      today: "Hoje",
      tomorrow: "Amanh\xE3",
      period: "Tempo",
      type: "Tipo",
      all: "Todos",
      value: "Valor",
      probabilitySort: "Probabilidade",
      hitRateSort: "Acertos",
      minProbability: "Taxa de acerto / probabilidade m\xEDnima",
      minOdds: "Odd m\xEDnima",
      probabilityShort: "Acertos / prob.",
      oddsShort: "Odd",
      league: "Liga",
      leagueCount: "Todas as ligas ({{count}})",
      selectedOptions_zero: "{{count}} selecionados",
      selectedOptions_one: "{{count}} selecionado",
      selectedOptions_other: "{{count}} selecionados",
      searchMarkets: "Buscar mercados",
      noMarkets: "Nenhum mercado encontrado",
      searchLeagues: "Buscar liga..."
    },
    forTeam: "Para {{team}}",
    opponentHistory: "Valores cedidos pelo advers\xE1rio: {{team}}",
    historyValues: "Valores dos jogos recentes",
    historicalHits: "Acertos",
    hitRate: "Taxa de acerto",
    matchHistory: "Totais das partidas recentes: {{team}}",
    warnings: {
      title: "Alertas da partida",
      viewAll: "Ver todos os alertas",
      refereeCards_zero: "\xC1rbitro: {{average}} cart\xF5es amarelos + vermelhos por jogo ({{sample}} jogos). Revise este under.",
      refereeCards_one: "\xC1rbitro: {{average}} cart\xF5es amarelos + vermelhos por jogo ({{sample}} jogo). Revise este under.",
      refereeCards_other: "\xC1rbitro: {{average}} cart\xF5es amarelos + vermelhos por jogo ({{sample}} jogos). Revise este under.",
      strongFavorite: "{{team}}: {{probability}} de chance estimada de vit\xF3ria. Revise o under de escanteios nesse contexto.",
      neutralVenue: "Campo neutro: o hist\xF3rico em casa/fora pode ser menos representativo.",
      shortRest: "{{team}}: {{hours}} horas entre partidas.",
      absences_zero: "{{team}}: {{count}} desfalques informados. Confira a escala\xE7\xE3o.",
      absences_one: "{{team}}: {{count}} desfalque informado. Confira a escala\xE7\xE3o.",
      absences_other: "{{team}}: {{count}} desfalques informados. Confira a escala\xE7\xE3o.",
      injury: "Boletim m\xE9dico: {{players}}.",
      lineupPending: "Escala\xE7\xE3o ainda n\xE3o publicada."
    },
    compareHistory: "Comparar jogos anteriores",
    openSample: "Amostra hist\xF3rica",
    noComparison: "Nenhum jogo anterior registrado.",
    selection: {
      title: "Bilhetes selecionados",
      count_zero: "{{count}} bilhetes selecionados",
      count_one: "{{count}} bilhete selecionado",
      count_other: "{{count}} bilhetes selecionados",
      limit: "At\xE9 {{limit}} bilhetes por vez.",
      clear: "Limpar sele\xE7\xE3o",
      sameFixture: "Dois ou mais bilhetes s\xE3o da mesma partida. Combin\xE1-los pode n\xE3o ser aceito pela casa.",
      started: "Algumas partidas selecionadas j\xE1 come\xE7aram. Remova-as antes de registrar."
    }
  },
  ticket: {
    title: "Pick Pro",
    filters: "Filtros",
    summary: "Resumo do bilhete",
    summaryToggle: "Mostrar detalhes do bilhete",
    games: "Quantidade de jogos",
    gamesHint: "Mais sele\xE7\xF5es aumentam a odd combinada e reduzem a chance de acerto.",
    increase: "Aumentar jogos",
    decrease: "Diminuir jogos",
    window: "Janela de tempo",
    windowHint: "Apenas partidas que come\xE7am neste intervalo s\xE3o consideradas.",
    hours: "{{count}}h",
    markets: "Mercados",
    playerMarkets: "Props de jogadores",
    all: "Todos",
    none: "Nenhum",
    invert: "Inverter",
    minProbability: "Probabilidade m\xEDnima (%)",
    minOdds: "Odd m\xEDnima",
    generate: "Gerar bilhete",
    ready: "Seu bilhete",
    selectionCount: "{{selected}} / {{requested}} sele\xE7\xF5es",
    available: "Sele\xE7\xF5es com odds dispon\xEDveis e valor positivo no modelo. Uma sele\xE7\xE3o por partida.",
    empty: "Nenhuma sele\xE7\xE3o dispon\xEDvel",
    emptyHint: "Tente uma janela de tempo maior ou outros mercados.",
    hiddenByFilters_zero: "{{count}} sele\xE7\xF5es est\xE3o ocultas pelos filtros de probabilidade m\xEDnima, odd, mercado ou per\xEDodo. Afrouxe-os para v\xEA-las.",
    hiddenByFilters_one: "{{count}} sele\xE7\xE3o est\xE1 oculta pelos filtros de probabilidade m\xEDnima, odd, mercado ou per\xEDodo. Afrouxe-os para v\xEA-la.",
    hiddenByFilters_other: "{{count}} sele\xE7\xF5es est\xE3o ocultas pelos filtros de probabilidade m\xEDnima, odd, mercado ou per\xEDodo. Afrouxe-os para v\xEA-las.",
    shortfall: "N\xE3o h\xE1 partidas eleg\xEDveis suficientes para completar seu bilhete.",
    stake: "Aposta",
    increaseStake: "Aumentar aposta em {{amount}}",
    decreaseStake: "Diminuir aposta em {{amount}}",
    totalOdds: "Odds totais",
    return: "Retorno potencial",
    lock: "Travar sele\xE7\xE3o",
    unlock: "Destravar sele\xE7\xE3o",
    replace: "Substituir sele\xE7\xE3o",
    save: "Salvar bilhete",
    saved: "Altera\xE7\xF5es salvas na sua conta.",
    saveError: "N\xE3o foi poss\xEDvel salvar. Verifique a conex\xE3o e tente novamente.",
    savedTitle: "Bilhetes salvos",
    inTicket: "Jogos no bilhete",
    twoDays: "2 dias",
    criterion: "Crit\xE9rio",
    criterionHint: "Estat\xEDsticas por time mandante/visitante, ou pela partida cheia.",
    byTeam: "Por time",
    byMatch: "De partida",
    selectedTeam: "Time: {{team}}",
    playerPickSuffix: "\u2013 {{side}} {{line}}",
    playerMarket: "{{metric}}",
    historySample: "Amostra hist\xF3rica: {{hits}}/{{total}}",
    historicalEstimate: "Estimativa hist\xF3rica",
    teamAvailable: "Mercados por time com odds recentes e estimativa hist\xF3rica como mandante ou visitante. Uma sele\xE7\xE3o por partida.",
    accountSync: "Sincronizado com sua conta. Os resultados pendentes s\xE3o conferidos automaticamente a cada minuto ap\xF3s o fim das partidas. Dados ausentes continuam pendentes. Voc\xEA tamb\xE9m pode conferir os resultados ou corrigir uma sele\xE7\xE3o manualmente.",
    ticketName: "Nome do bilhete",
    selectionResult: "Resultado da sele\xE7\xE3o",
    removeSelection: "Remover sele\xE7\xE3o",
    saveChanges: "Salvar altera\xE7\xF5es",
    cancel: "Cancelar",
    profit: "Lucro",
    edit: "Editar",
    checkResults: "Conferir resultados",
    delete: "Excluir",
    noSaved: "Nenhum bilhete salvo.",
    importLocal_zero: "Importar {{count}} bilhetes deste navegador",
    importLocal_one: "Importar {{count}} bilhete deste navegador",
    importLocal_other: "Importar {{count}} bilhetes deste navegador",
    previous: "Anterior",
    next: "Pr\xF3ximo",
    period: "Tempo",
    secondHalf: "Segundo tempo",
    combinedEdge: "Edge combinado estimado",
    risk: "Risco estimado",
    indicatorHint: "Pressup\xF5e partidas independentes. Baixo: chance estimada de acertar todas de pelo menos 65%; m\xE9dio: 35\u201365%; alto: abaixo de 35%. Estimativas hist\xF3ricas n\xE3o s\xE3o previs\xF5es calibradas.",
    previousOdds: "Odd anterior",
    generation: {
      changed: "Bilhete alternativo gerado.",
      unchanged: "Nenhuma sele\xE7\xE3o alternativa atende aos filtros e travas."
    },
    movement: {
      unknown: "Sem odd anterior",
      stable: "Odds est\xE1veis",
      up: "Odd subiu",
      down: "Odd caiu"
    },
    riskLevels: {
      unknown: "\u2014",
      low: "Baixo",
      medium: "M\xE9dio",
      high: "Alto"
    },
    results: {
      pending: "Pendente",
      won: "Ganho",
      lost: "Perdido",
      void: "Anulado",
      halfWon: "Meio ganho",
      halfLost: "Meio perdido"
    },
    marketNames: {
      cards: "Cart\xF5es",
      shots: "Finaliza\xE7\xF5es",
      shots_on_target: "Chutes no alvo",
      points: "Pontos",
      runs: "Corridas",
      moneyline: "Vencedor",
      spread: "Handicap"
    },
    refresh: "Atualizar",
    lastRefreshed: "\xDAltima atualiza\xE7\xE3o: {{time}}",
    staleData: "Esta lista foi atualizada h\xE1 mais de 5 minutos. Atualize antes de enviar para a banca.",
    stalePrices: "Algumas odds selecionadas t\xEAm mais de 5 minutos. Atualize e confira na casa de apostas antes de registrar."
  },
  study: {
    title: "Sele\xE7\xF5es salvas",
    subtitle: "Suas sele\xE7\xF5es salvas, prontas para revisitar.",
    sendToBankroll: "Enviar para banca",
    oddsFor: "Odd: {{match}}",
    decimalOddsFor: "Odd decimal: {{selection}}",
    invalidStake: "Informe uma stake entre 0,01 e 1.000.000.",
    invalidOdds: "Informe uma odd decimal acima de 1 e at\xE9 1000.",
    remove: "Remover sele\xE7\xE3o",
    accumulator: "Bilhete m\xFAltiplo",
    accumulatorHint: "Uma stake para todas as sele\xE7\xF5es. Uma sele\xE7\xE3o perdida perde o bilhete.",
    singlesHint: "A stake informada \xE9 aplicada a cada aposta simples.",
    bankroll: "Banca",
    chooseBankroll: "Escolha uma banca",
    newBankroll: "Nova banca",
    stake: "Stake (R$)",
    bookmaker: "Casa de aposta",
    totalStake: "Stake total",
    combinedOdds: "Odd combinada",
    noSelections: "Selecione pelo menos uma linha.",
    invalidOpeningBalance: "Informe um saldo inicial entre 0 e 10.000.000.000.",
    saveError: "N\xE3o foi poss\xEDvel salvar. Confira os valores e o saldo e tente novamente.",
    loadError: "N\xE3o foi poss\xEDvel carregar seus dados.",
    recordBets: "Registrar apostas",
    bankrollName: "Nome da banca",
    save: "Salvar",
    transactions: "Movimenta\xE7\xF5es",
    restore: "Restaurar",
    archive: "Arquivar",
    openingBalance: "Saldo inicial (R$)",
    createBankroll: "Criar banca",
    editBankroll: "Editar banca",
    adjustBalance: "Ajustar saldo",
    deposit: "Dep\xF3sito",
    withdrawal: "Saque",
    adjustmentAmount: "Valor (R$)",
    applyAdjustment: "Aplicar",
    insufficientBalance: "Valor acima do saldo atual.",
    archivedAdjustmentHint: "Restaure esta banca para ajustar o saldo.",
    selectionActions: "A\xE7\xF5es da sele\xE7\xE3o",
    saved: "Salvo",
    alreadyBet: "J\xE1 apostado",
    alreadyBetOne: "{{bankroll}} \xB7 {{amount}}",
    alreadyBetMany: "{{count}} apostas \xB7 {{amount}}",
    removeFromNotebook: "Remover das sele\xE7\xF5es salvas",
    saveSelection: "Salvar bilhete",
    recorded: "Apostas registradas",
    selectLine: "Selecionar {{match}}: {{line}}",
    grouping: "Agrupar sele\xE7\xF5es",
    byGame: "Por jogo",
    byMarket: "Por mercado",
    search: "Filtrar por time, liga ou mercado",
    cancel: "Cancelar",
    expandAll: "Expandir todos",
    collapseAll: "Encolher todos",
    clearAll: "Limpar tudo",
    empty: "Nenhuma sele\xE7\xE3o salva corresponde aos filtros. Salve sele\xE7\xF5es no Radar ou no Pick Pro.",
    selectionCount_zero: "{{count}} sele\xE7\xF5es",
    selectionCount_one: "{{count}} sele\xE7\xE3o",
    selectionCount_other: "{{count}} sele\xE7\xF5es",
    sendTicket: "Enviar bilhete",
    previousTickets: "Bilhetes salvos anteriormente",
    clearHint: "Remover todas as sele\xE7\xF5es salvas? Apostas registradas e bancas s\xE3o mantidas.",
    oneSportHint: "Um bilhete usa sele\xE7\xF5es de um \xFAnico esporte.",
    confirmClear: "Limpar sele\xE7\xF5es salvas",
    betDetails: "Detalhes e resultados da aposta",
    chooseBet: "Escolha uma aposta",
    manualHint: "Salvar resultados torna esta aposta manual. Voc\xEA pode consultar os resultados registrados quando precisar.",
    needsReview: "Precisa do seu resultado",
    needsReviewHint: "Esta partida j\xE1 terminou, mas o resultado de uma das sele\xE7\xF5es n\xE3o est\xE1 dispon\xEDvel no nosso provedor de dados. Defina-o manualmente abaixo.",
    profitEvolution: "Evolu\xE7\xE3o do lucro",
    settlementBasis: "Resultados por data de liquida\xE7\xE3o",
    noResolved: "Nenhuma aposta liquidada neste per\xEDodo.",
    cumulativeProfit: "Lucro acumulado",
    market: "Mercado",
    allMarkets: "Todos os mercados",
    filters: "Filtros",
    from: "De",
    to: "At\xE9",
    profit: "Lucro",
    roi: "Retorno sobre investimento",
    hitRate: "Taxa de acerto",
    pending: "Apostas pendentes",
    bankrolls: "Bancas",
    noBankrolls: "Crie uma banca para come\xE7ar a registrar apostas.",
    noPending: "Nenhuma aposta pendente.",
    betHistory: "Apostas liquidadas",
    transactionKinds: {
      opening: "Saldo inicial",
      stake: "Stake",
      return: "Retorno",
      correction: "Corre\xE7\xE3o",
      deposit: "Dep\xF3sito",
      withdrawal: "Saque"
    },
    bankrollSubtitle: "Gerencie suas bancas e acompanhe cada aposta.",
    archived: "Arquivada",
    currentBalance: "Saldo atual",
    separateMatches: "M\xFAltiplas exigem partidas diferentes. Use apostas simples para v\xE1rias linhas da mesma partida.",
    betSummary: {
      title: "Resumo da aposta",
      return: "Retorno recebido",
      netProfit: "Lucro l\xEDquido",
      returnHint: "O retorno inclui o valor apostado. O lucro l\xEDquido \xE9 o retorno menos o valor apostado.",
      settledAt: "Liquidada em"
    },
    deleteBet: "Excluir aposta",
    deleteBetPending: "{{stake}} volta para {{bankroll}}.",
    deleteBetSettled: "{{stake}} volta para {{bankroll}} e o retorno de {{payout}} \xE9 removido.",
    deleteBetStats: "A aposta tamb\xE9m sai das suas estat\xEDsticas de desempenho.",
    deleteError: "N\xE3o foi poss\xEDvel excluir esta aposta. Tente novamente.",
    yourBankroll: "sua banca"
  },
  bets: {
    title: "Apostas",
    tabs: {
      live: "Ao vivo",
      upcoming: "Pr\xF3ximas",
      settled: "Encerradas",
      performance: "Desempenho"
    },
    performance: {
      sport: "Esporte",
      updated: "Atualizado",
      profit: "Lucro",
      resolvedStake: "Stake liquidado",
      roi: "Retorno sobre investimento",
      roiHint: "Lucro / stake liquidado, sem apostas anuladas",
      hitRate: "Taxa de acerto",
      resolvedCount_zero: "{{count}} apostas liquidadas",
      resolvedCount_one: "{{count}} aposta liquidada",
      resolvedCount_other: "{{count}} apostas liquidadas",
      pending: "Apostas pendentes",
      currentRisk: "Stake em risco agora",
      live: "Ao vivo",
      liveHint: "Jogos ao vivo em apostas pendentes",
      loadError: "N\xE3o foi poss\xEDvel carregar seus resultados.",
      invalidRange: "Escolha um per\xEDodo v\xE1lido.",
      noSports: "Nenhum esporte no seu plano ainda.",
      ranges: {
        "1": "Hoje",
        "7": "7 dias",
        "30": "30 dias",
        month: "M\xEAs",
        all: "Tudo",
        custom: "Personalizado"
      }
    },
    awaiting: "Aguardando resultado",
    needsReview: "Precisa do seu resultado",
    empty: {
      live: "Nenhuma aposta em andamento agora.",
      upcoming: "Nenhuma aposta futura.",
      settled: "Nenhuma aposta encerrada ainda."
    },
    stake: "Valor",
    totalOdds: "Odd total",
    potentialReturn: "Retorno potencial",
    return: "Retorno",
    profit: "Lucro",
    modes: {
      singles: "Simples",
      accumulator: "M\xFAltipla"
    },
    progress: "{{current}} de {{line}}",
    marketPeriod: "{{market}}, {{period}}",
    pendingTrend: "Pendente, {{result}} at\xE9 agora",
    viewAll: "Ver todas as apostas",
    collapseAll: "Recolher tudo",
    expandAll: "Expandir tudo",
    legCount_zero: "{{count}} sele\xE7\xF5es",
    legCount_one: "{{count}} sele\xE7\xE3o",
    legCount_other: "{{count}} sele\xE7\xF5es",
    editBetLabel: "Editar aposta: {{bet}}",
    deleteBetLabel: "Excluir aposta: {{bet}}"
  },
  matchContext: {
    updated: "Contexto atualizado: {{time}}",
    stale: "O contexto desta partida pode estar desatualizado.",
    conditions: "Condi\xE7\xF5es da partida",
    neutralVenue: "Campo neutro",
    humidity: "Umidade: {{value}}%",
    forecast: "Previs\xE3o",
    formation: "Forma\xE7\xE3o",
    coach: "Treinador",
    rest: "{{hours}} horas entre o in\xEDcio desta partida e o da anterior",
    schedule_zero: "{{count}} partidas conclu\xEDdas nos 7 dias anteriores",
    schedule_one: "{{count}} partida conclu\xEDda nos 7 dias anteriores",
    schedule_other: "{{count}} partidas conclu\xEDdas nos 7 dias anteriores",
    lineup: {
      confirmed: "Escala\xE7\xE3o confirmada",
      expected: "Escala\xE7\xE3o prov\xE1vel",
      unconfirmed: "Escala\xE7\xE3o n\xE3o confirmada"
    },
    bench: "Banco de reservas",
    absences: "Desfalques informados",
    reasons: {
      injury: "Les\xE3o",
      suspension: "Suspens\xE3o",
      unavailable: "Indispon\xEDvel"
    },
    probabilities: "Probabilidades pr\xE9-jogo do resultado",
    liveProbabilities: "Probabilidades ao vivo no minuto {{minute}}",
    expectedGoals: "Gols esperados registrados (xG)",
    pressure: "Press\xE3o na partida",
    period: "Tempo {{number}}",
    events: "Eventos da partida",
    event: {
      goal: "Gol",
      ownGoal: "Gol contra",
      penalty: "Gol de p\xEAnalti",
      missedPenalty: "P\xEAnalti perdido",
      yellowCard: "Cart\xE3o amarelo",
      redCard: "Cart\xE3o vermelho",
      substitution: "Substitui\xE7\xE3o",
      var: "Revis\xE3o do VAR",
      varCard: "Cart\xE3o ap\xF3s VAR"
    },
    trends: "Evolu\xE7\xE3o da partida",
    seriesTeam: "Evolu\xE7\xE3o de {{team}} na partida"
  }
};

// src/locales/pt-BR/email.json
var email_default3 = {
  footer: "O Pick Pro \xE9 um servi\xE7o independente de pesquisa esportiva. N\xE3o aceita apostas.",
  verifyEmail: {
    subject: "Confirme seu e-mail no Pick Pro",
    greeting: "Ol\xE1,",
    body: "Confirme seu endere\xE7o de e-mail para ativar sua conta no Pick Pro.",
    action: "Confirmar e-mail",
    expiry: "Este link expira em 24 horas.",
    ignore: "Se voc\xEA n\xE3o criou uma conta, pode ignorar este e-mail."
  },
  resetPassword: {
    subject: "Redefina sua senha do Pick Pro",
    greeting: "Ol\xE1,",
    body: "Recebemos um pedido para redefinir a senha da sua conta no Pick Pro.",
    action: "Escolher uma nova senha",
    expiry: "Este link expira em 1 hora.",
    ignore: "Se voc\xEA n\xE3o fez este pedido, pode ignorar este e-mail e sua senha continua a mesma."
  },
  passwordChanged: {
    subject: "Sua senha do Pick Pro foi alterada",
    greeting: "Ol\xE1,",
    body: "A senha da sua conta no Pick Pro foi alterada e todas as outras sess\xF5es foram encerradas.",
    action: "Abrir o Pick Pro",
    ignore: "Se n\xE3o foi voc\xEA, redefina sua senha imediatamente pela p\xE1gina de entrada."
  }
};

// src/completeness.ts
function flatten(value, prefix, into) {
  if (value !== null && typeof value === "object" && !Array.isArray(value)) {
    for (const [childKey, child] of Object.entries(value)) {
      flatten(child, prefix ? `${prefix}.${childKey}` : childKey, into);
    }
    return;
  }
  into.set(prefix, value);
}
function findMissingKeys(resources2) {
  const flatByLocale = /* @__PURE__ */ new Map();
  const allKeys = /* @__PURE__ */ new Set();
  for (const [locale, tree] of Object.entries(resources2)) {
    const flat = /* @__PURE__ */ new Map();
    flatten(tree, "", flat);
    flatByLocale.set(locale, flat);
    for (const key of flat.keys()) allKeys.add(key);
  }
  const missing = [];
  for (const [locale, flat] of flatByLocale) {
    for (const key of [...allKeys].sort()) {
      const value = flat.get(key);
      if (typeof value !== "string" || value.trim() === "") missing.push({ locale, key });
    }
  }
  return missing;
}

// src/index.ts
var LOCALES = ["en", "pt-BR", "es"];
var DEFAULT_LOCALE = "pt-BR";
var resources = {
  en: { common: common_default, email: email_default },
  "pt-BR": { common: common_default3, email: email_default3 },
  es: { common: common_default2, email: email_default2 }
};
var emailResources = {
  en: email_default,
  "pt-BR": email_default3,
  es: email_default2
};
var isLocale = (value) => typeof value === "string" && LOCALES.includes(value);
export {
  DEFAULT_LOCALE,
  LOCALES,
  emailResources,
  findMissingKeys,
  isLocale,
  resources
};
//# sourceMappingURL=index.js.map